// Excavator Mounted
import ExcavatorMountedMain from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_MainPhoto.png";
import ExcavatorMounted1 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_1.jpg";
import ExcavatorMounted2 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_2.jpg";
import ExcavatorMounted3 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_3.jpg";
import ExcavatorMounted4 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_4.jpg";
import ExcavatorMounted5 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_5.jpg";
import ExcavatorMounted6 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_6.jpg";
import ExcavatorMounted7 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_7.jpg";
import ExcavatorMounted8 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_8.jpg";
import ExcavatorMounted9 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_9.jpg";
import ExcavatorMounted10 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_10.jpg";
import ExcavatorMounted11 from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_11.jpg";
import ExcavatorMountedPDF from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_PDF_FILE.pdf";
// Loader Mounted
import LoaderMountedMain from "../img/1TreeSpades/2LoaderMounted/42DL/BigJohn_42DL_MainPhoto.png";
import DL42Main from "../img/1TreeSpades/2LoaderMounted/42DL/BigJohn_42DL_1.jpg";
import DL421 from "../img/1TreeSpades/2LoaderMounted/42DL/BigJohn_42DL_2.jpg";
import DL422 from "../img/1TreeSpades/2LoaderMounted/42DL/BigJohn_42DL_3.jpg";
import DL423 from "../img/1TreeSpades/2LoaderMounted/42DL/BigJohn_42DL_4.jpg";
import DL424 from "../img/1TreeSpades/2LoaderMounted/42DL/BigJohn_42DL_5.jpg";
import DL52Main from "../img/1TreeSpades/2LoaderMounted/52DL/BigJohn_52DL_1.jpg";
import DL521 from "../img/1TreeSpades/2LoaderMounted/52DL/BigJohn_52DL_2.jpg";
import DL522 from "../img/1TreeSpades/2LoaderMounted/52DL/BigJohn_52DL_3.jpg";
import DL523 from "../img/1TreeSpades/2LoaderMounted/52DL/BigJohn_52DL_4.jpg";
import DL524 from "../img/1TreeSpades/2LoaderMounted/52DL/BigJohn_52DL_5.jpg";
import DL62Main from "../img/1TreeSpades/2LoaderMounted/62DL/BigJohn_62DL_1.jpg";
import DL621 from "../img/1TreeSpades/2LoaderMounted/62DL/BigJohn_62DL_2.jpg";
import DL622 from "../img/1TreeSpades/2LoaderMounted/62DL/BigJohn_62DL_3.jpg";
import DL623 from "../img/1TreeSpades/2LoaderMounted/62DL/BigJohn_62DL_4.jpg";
import DL624 from "../img/1TreeSpades/2LoaderMounted/62DL/BigJohn_62DL_5.jpg";
import DL80Main from "../img/1TreeSpades/2LoaderMounted/80DL/BigJohn_80DL_1.jpg";
import DL801 from "../img/1TreeSpades/2LoaderMounted/80DL/BigJohn_80DL_2.jpg";
import DL802 from "../img/1TreeSpades/2LoaderMounted/80DL/BigJohn_80DL_3.jpg";
import DL803 from "../img/1TreeSpades/2LoaderMounted/80DL/BigJohn_80DL_4.jpg";
import DL804 from "../img/1TreeSpades/2LoaderMounted/80DL/BigJohn_80DL_5.jpg";
import DL90Main from "../img/1TreeSpades/2LoaderMounted/90DL/BigJohn_90DL_1.jpg";
import DL901 from "../img/1TreeSpades/2LoaderMounted/90DL/BigJohn_90DL_2.jpg";
import DL902 from "../img/1TreeSpades/2LoaderMounted/90DL/BigJohn_90DL_3.jpg";
import DL903 from "../img/1TreeSpades/2LoaderMounted/90DL/BigJohn_90DL_4.jpg";
import DL904 from "../img/1TreeSpades/2LoaderMounted/90DL/BigJohn_90DL_5.jpg";
import DLLP90Main from "../img/1TreeSpades/2LoaderMounted/90DLLP/BigJohn_90DLLP_1.jpg";
import DLLP901 from "../img/1TreeSpades/2LoaderMounted/90DLLP/BigJohn_90DLLP_2.jpg";
import DLLP902 from "../img/1TreeSpades/2LoaderMounted/90DLLP/BigJohn_90DLLP_3.jpg";
import DLLP903 from "../img/1TreeSpades/2LoaderMounted/90DLLP/BigJohn_90DLLP_4.jpg";
import DLLP904 from "../img/1TreeSpades/2LoaderMounted/90DLLP/BigJohn_90DLLP_5.jpg";
import DL100Main from "../img/1TreeSpades/2LoaderMounted/100DL/BigJohn_100DL_1.jpg";
import DL1001 from "../img/1TreeSpades/2LoaderMounted/100DL/BigJohn_100DL_2.jpg";
import DL1002 from "../img/1TreeSpades/2LoaderMounted/100DL/BigJohn_100DL_3.jpg";
import DL1003 from "../img/1TreeSpades/2LoaderMounted/100DL/BigJohn_100DL_4.jpg";
import DL1004 from "../img/1TreeSpades/2LoaderMounted/100DL/BigJohn_100DL_5.jpg";
// Truck Mounted
import TruckMountedMain from "../img/1TreeSpades/3TruckMounted/100D/BigJohn_100D_MainPhoto.png";
import D45Main from "../img/1TreeSpades/3TruckMounted/45D/BigJohn_45D_1.jpg";
import D451 from "../img/1TreeSpades/3TruckMounted/45D/BigJohn_45D_2.jpg";
import D452 from "../img/1TreeSpades/3TruckMounted/45D/BigJohn_45D_3.jpg";
import D453 from "../img/1TreeSpades/3TruckMounted/45D/BigJohn_45D_4.jpg";
import D454 from "../img/1TreeSpades/3TruckMounted/45D/BigJohn_45D_5.jpg";

import D55Main from "../img/1TreeSpades/3TruckMounted/55D/BigJohn_55D_1.jpg";
import D551 from "../img/1TreeSpades/3TruckMounted/55D/BigJohn_55D_2.jpg";
import D552 from "../img/1TreeSpades/3TruckMounted/55D/BigJohn_55D_3.jpg";
import D553 from "../img/1TreeSpades/3TruckMounted/55D/BigJohn_55D_4.jpg";
import D554 from "../img/1TreeSpades/3TruckMounted/55D/BigJohn_55D_5.jpg";

import D65Main from "../img/1TreeSpades/3TruckMounted/65D/BigJohn_65D_1.jpg";
import D651 from "../img/1TreeSpades/3TruckMounted/65D/BigJohn_65D_2.jpg";
import D652 from "../img/1TreeSpades/3TruckMounted/65D/BigJohn_65D_3.jpg";
import D653 from "../img/1TreeSpades/3TruckMounted/65D/BigJohn_65D_4.jpg";
import D654 from "../img/1TreeSpades/3TruckMounted/65D/BigJohn_65D_5.jpg";

import D80Main from "../img/1TreeSpades/3TruckMounted/80D/BigJohn_80D_1.jpg";
import D801 from "../img/1TreeSpades/3TruckMounted/80D/BigJohn_80D_2.jpg";
import D802 from "../img/1TreeSpades/3TruckMounted/80D/BigJohn_80D_3.jpg";
import D803 from "../img/1TreeSpades/3TruckMounted/80D/BigJohn_80D_4.jpg";
import D804 from "../img/1TreeSpades/3TruckMounted/80D/BigJohn_80D_5.jpg";

import D90Main from "../img/1TreeSpades/3TruckMounted/90D/BigJohn_90D_1.jpg";
import D901 from "../img/1TreeSpades/3TruckMounted/90D/BigJohn_90D_2.jpg";
import D902 from "../img/1TreeSpades/3TruckMounted/90D/BigJohn_90D_3.jpg";
import D903 from "../img/1TreeSpades/3TruckMounted/90D/BigJohn_90D_4.jpg";
import D904 from "../img/1TreeSpades/3TruckMounted/90D/BigJohn_90D_5.jpg";

import DAG90Main from "../img/1TreeSpades/3TruckMounted/90DAG/BigJohn_90DAG_1.jpg";
import DAG901 from "../img/1TreeSpades/3TruckMounted/90DAG/BigJohn_90DAG_2.jpg";
import DAG902 from "../img/1TreeSpades/3TruckMounted/90DAG/BigJohn_90DAG_3.jpg";
import DAG903 from "../img/1TreeSpades/3TruckMounted/90DAG/BigJohn_90DAG_4.jpg";
import DAG904 from "../img/1TreeSpades/3TruckMounted/90DAG/BigJohn_90DAG_5.jpg";

import DLP90Main from "../img/1TreeSpades/3TruckMounted/90DLP/BigJohn_90DLP_MainPhoto.png";
import DLP901 from "../img/1TreeSpades/3TruckMounted/90DLP/BigJohn_90DLP_1.jpg";
import DLP902 from "../img/1TreeSpades/3TruckMounted/90DLP/BigJohn_90DLP_2.jpg";
import DLP903 from "../img/1TreeSpades/3TruckMounted/90DLP/BigJohn_90DLP_3.jpg";
import DLP904 from "../img/1TreeSpades/3TruckMounted/90DLP/BigJohn_90DLP_4.jpg";

import D100Main from "../img/1TreeSpades/3TruckMounted/100D/BigJohn_100D_1.jpg";
import D1001 from "../img/1TreeSpades/3TruckMounted/100D/BigJohn_100D_2.jpg";
import D1002 from "../img/1TreeSpades/3TruckMounted/100D/BigJohn_100D_3.jpg";
import D1003 from "../img/1TreeSpades/3TruckMounted/100D/BigJohn_100D_4.jpg";
import D1004 from "../img/1TreeSpades/3TruckMounted/100D/BigJohn_100D_5.jpg";
// Skid Mounted
import SkidMountedMain from "../img/1TreeSpades/4SkidSteerMounted/MODEL 48/BigJohn_Model48_MainPhoto.png";
import Model20 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 20/BigJohn_Model20_MainPhoto.png";
import Model201 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 20/BigJohn_MODEL20_1.jpg";

import Model28 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 28/BigJohn_Model28_MainPhoto.png";
import Model281 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 28/BigJohn_MODEL28_1.jpg";
import Model282 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 28/BigJohn_MODEL28_2.jpeg";
import Model283 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 28/BigJohn_MODEL28_3.jpeg";
import Model284 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 28/BigJohn_MODEL28_4.jpeg";

import Model36Main from "../img/1TreeSpades/4SkidSteerMounted/MODEL 36/BigJohn_Model36_MainPhoto.png";
import Model36 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 36/BigJohn_MODEL36_1.jpg";
import Model361 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 36/BigJohn_MODEL36_2.jpg";
import Model362 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 36/BigJohn_MODEL36_3.jpeg";
import Model363 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 36/BigJohn_MODEL36_4.jpeg";

import Model40Main from "../img/1TreeSpades/4SkidSteerMounted/MODEL 40/BigJohn_Model40_MainPhoto.png";
import Model40 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 40/BigJohn_MODEL40_1.jpg";
import Model401 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 40/BigJohn_MODEL40_2.jpg";
import Model402 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 40/BigJohn_MODEL40_3.jpg";
import Model403 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 40/BigJohn_MODEL40_4.jpeg";

import Model44Main from "../img/1TreeSpades/4SkidSteerMounted/MODEL 44/BigJohn_Model44_MainPhoto.png";
import Model441 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 44/BigJohn_MODEL44_2.jpg";
import Model442 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 44/BigJohn_MODEL44_3.jpg";
import Model443 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 44/BigJohn_MODEL44_4.jpeg";
import Model444 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 44/BigJohn_MODEL44_5.jpeg";
import Model445 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 44/BigJohn_MODEL44_6.jpeg";

import Model48Main from "../img/1TreeSpades/4SkidSteerMounted/MODEL 48/BigJohn_Model48_MainPhoto.png";
import Model48 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 48/BigJohn_MODEL48_1.jpg";
import Model481 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 48/BigJohn_MODEL48_2.jpg";
import Model482 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 48/BigJohn_MODEL48_3.jpg";

import Model54Main from "../img/1TreeSpades/4SkidSteerMounted/MODEL 54/BigJohn_Model54_MainPhoto.png";
import Model54 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 54/BigJohn_MODEL54_1.jpeg";
import Model541 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 54/BigJohn_MODEL54_2.jpeg";
import Model542 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 54/BigJohn_MODEL54_3.jpeg";
import Model543 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 54/BigJohn_MODEL54_4.jpg";
import Model544 from "../img/1TreeSpades/4SkidSteerMounted/MODEL 54/BigJohn_MODEL54_5.jpg";
// Trailer Mounted
import TrailerMountedMain from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_MainPhoto.png";

import Main44DTG from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_MainPhoto.png";
import DTG441 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_1.jpeg";
import DTG442 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_2.jpg";
import DTG443 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_3.jpg";
import DTG444 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_4.jpg";
// import DTG445 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_5.jpeg";
// import DTG446 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_6.jpeg";
// import DTG447 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_7.jpeg";
// import DTG448 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_8.jpg";
// import DTG449 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_9.jpg";
// import DTG4410 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_10.jpg";
// import DTG4411 from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_11.jpg";

import Main54 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_MainPhoto.png";
import D541 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_1.jpg";
import D542 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_2.jpg";
import D543 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_3.jpg";
import D544 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_4.jpg";
// import D545 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_5.jpg";
// import D546 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_6.jpg";
// import D547 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_7.jpg";
// import D548 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_8.jpeg";
// import D549 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_9.jpeg";
// import D5410 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_10.jpeg";
// import D5411 from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_11.jpg";

import Main55DTD from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_MainPhoto.png";
import DTD551 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_1.jpg";
import DTD552 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_2.jpg";
import DTD553 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_3.jpg";
import DTD554 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_4.jpg";
// import DTD555 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_5.jpg";
// import DTD556 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_6.jpeg";
// import DTD557 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_7.jpeg";
// import DTD558 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_8.jpeg";
// import DTD559 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_9.jpg";
// import DTD5510 from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_10.jpg";

import Main65DTD from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_MainPhoto.png";
import DTD651 from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_1.jpg";
import DTD652 from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_2.jpg";
import DTD653 from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_3.jpg";
import DTD654 from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_4.jpg";
// import DTD655 from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_5.jpg";
// import DTD656 from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_6.jpeg";
// import DTD657 from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_7.jpeg";
// import DTD658 from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_8.jpg";
// import DTD659 from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_9.jpg";

// Tractor Mounted
import TractorMountedMain from "../img/1TreeSpades/6TractorMounted/BigJohn_TRACTOR_MainPhoto.png";
import TractorMounted1 from "../img/1TreeSpades/6TractorMounted/BigJohn_TRACTOR_1.jpeg";
import TractorMounted2 from "../img/1TreeSpades/6TractorMounted/BigJohn_TRACTOR_2.jpeg";
import TractorMounted3 from "../img/1TreeSpades/6TractorMounted/BigJohn_TRACTOR_3.jpg";
import TractorMounted4 from "../img/1TreeSpades/6TractorMounted/BigJohn_TRACTOR_4.jpeg";
import TractorMounted5 from "../img/1TreeSpades/6TractorMounted/BigJohn_TRACTOR_5.jpg";
// Tree Spades Accessories
import TreeSpadesAccMain from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/90 Pod Trailer/BigJohn_90POD_MainPhoto.png";

import PodTrailer44 from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/44 Pod Trailer/BigJohn_44POD_1.jpg";
import PodTrailer44Main from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/44 Pod Trailer/BigJohn_44POD_MainPhoto.png";

import PodTrailer55 from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/55 Pod Trailer/BigJohn_55POD_1.jpg";
import PodTrailer55Main from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/55 Pod Trailer/BigJohn_55POD_MainPhoto.png";

import PodTrailer65 from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/65 Pod Trailer/BigJohn_65POD_1.jpg";
import PodTrailer65Main from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/65 Pod Trailer/BigJohn_65POD_MainPhoto.png";

import PodTrailer90 from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/90 Pod Trailer/BigJohn_90POD_1.jpeg";
import PodTrailer90Main from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/90 Pod Trailer/BigJohn_90POD_MainPhoto.png";
// Ride On Machines
import ROMMain from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo 2.0/PFG_Squalo20_MainPhoto.png";
import ROMNemo from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo/PFG_NEMO2WD_2.jpg";
import ROMNemo2 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo/PFG_NEMO2WD_3.jpg";
import ROMNemo3 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo/PFG_NEMO2WD_4.jpg";
import ROMNemo4 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo/PFG_NEMO2WD_5.jpg";
import ROMNemo5 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo/PFG_NEMO2WD_6.jpg";
import ROMNemo6 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo/PFG_NEMO2WD_7.jpg";

import ROMNemoTrack from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo Track/PFG_NEMOTRACK_2.jpg";
import ROMNemoTrack2 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo Track/PFG_NEMOTRACK_3.jpg";
import ROMNemoTrack3 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo Track/PFG_NEMOTRACK_4.jpg";
import ROMNemoTrack4 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo Track/PFG_NEMOTRACK_5.jpg";
import ROMNemoTrack5 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo Track/PFG_NEMOTRACK_6.jpg";
import ROMNemoTrack6 from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo Track/PFG_NEMOTRACK_7.jpg";

import ROMSqualo from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo/PFG_SQUALO_2.jpg";
import ROMSqualo2 from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo/PFG_SQUALO_3.jpg";
import ROMSqualo3 from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo/PFG_SQUALO_4.jpg";
import ROMSqualo4 from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo/PFG_SQUALO_5.jpg";
import ROMSqualo5 from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo/PFG_SQUALO_6.jpg";

import ROMSqualo20Main from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo 2.0/PFG_Squalo20_MainPhoto.png";
import ROMSqualo201 from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo 2.0/Squalo-2.0-2-p726ckbutlpslqkj1bhgltip0nkgn2t4ldefsrfffu-q5mbbgqz65qcj7e7kuddx2bg4kwlupk1qrdirbkpuy (1).jpg";
import ROMSqualo202 from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo 2.0/Squalo-2.0-2-p726ckbutlpslqkj1bhgltip0nkgn2t4ldefsrfffu-q5mbbgqz65qcj7e7kuddx2bg4kwlupk1qrdirbkpuy.jpg";
import ROMSqualo203 from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo 2.0/Squalo-2.0-3-p726cm7j79sd8yhsqcapqt1m7fb72h0l9mperbcn3e-q5mbbgqz65qcj7e7kuddx2bg4kwlupk1qrdirbkpuy.jpg";
import ROMSqualo204 from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo 2.0/Squalo-2.0-p726cl9p0fr2xcj5vtw36ba5m1fturwuxi1xa1e19m-q5mbbgqz65qcj7e7kuddx2bg4kwlupk1qrdirbkpuy.jpg";

// Tractor Towed Machine
import TTMMain from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600XL Surf Rake/Barber_SurfRake600XL_2.jpg";

import CerniaMain from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Cernia/PFG_ Cernia_MainPhoto.png";
import Cernia from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Cernia/PFG_CERNIA_2.jpg";
import Cernia2 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Cernia/PFG_CERNIA_3.jpg";
import Cernia3 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Cernia/PFG_CERNIA_4.jpg";

import MantaMain from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta/PFG_ Manta_MainPhoto.png";
import Manta from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta/PFG_MANTA_2.jpg";
import Manta2 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta/PFG_MANTA_3.jpg";
import Manta3 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta/PFG_MANTA_4.jpg";
import Manta4 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta/PFG_MANTA_5.jpg";

import MantaGoldMain from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta Gold/PFG_ MantaGold_MainPhoto.png";
import MantaGold from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta Gold/PFG_MANTAGOLD_2.jpg";
import MantaGold2 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta Gold/PFG_MANTAGOLD_3.jpg";
import MantaGold3 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta Gold/PFG_MANTAGOLD_4.jpg";

import CaimanoMain from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Caimano/PFG_ Caimano_MainPhoto.png";
import Caimano from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Caimano/PFG_CAIMANO_2.jpg";
import Caimano2 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Caimano/PFG_CAIMANO_3.jpg";
import Caimano3 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Caimano/PFG_CAIMANO_4.jpg";
import Caimano4 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Caimano/PFG_CAIMANO_5.jpg";
import Caimano5 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Caimano/PFG_CAIMANO_6.jpg";

import Model400SRMain from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400 Surf Rake/Barber_SurfRake400_MainPhoto.png";
import Model400SR1 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400 Surf Rake/Barber_SurfRake400_1.jpg";
import Model400SR2 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400 Surf Rake/Barber_SurfRake400_2.jpg";
import Model400SR3 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400 Surf Rake/Barber_SurfRake400_3.jpg";
import Model400SR4 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400 Surf Rake/Barber_SurfRake400_4.jpg";

import Model400SRHDMain from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400HD Surf Rake/Barber_SurfRake400HD_MainPhoto.png";
import Model400SRHD1 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400HD Surf Rake/Barber_SurfRake400HD_1.jpg";
import Model400SRHD2 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400HD Surf Rake/Barber_SurfRake400HD_2.jpg";
import Model400SRHD3 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400HD Surf Rake/Barber_SurfRake400HD_3.jpg";
import Model400SRHD4 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400HD Surf Rake/Barber_SurfRake400HD_4.jpg";

import Model600SRHDMain from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600HD Surf Rake/Barber_SurfRake600HD_MainPhoto.png";
import Model600SRHD1 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600HD Surf Rake/Barber_SurfRake600HD_1.jpg";
import Model600SRHD2 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600HD Surf Rake/Barber_SurfRake600HD_2.jpg";
import Model600SRHD3 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600HD Surf Rake/Barber_SurfRake600HD_3.jpg";
import Model600SRHD4 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600HD Surf Rake/Barber_SurfRake600HD_4.jpg";

import Model600XLMain from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600XL Surf Rake/Barber_SurfRake600XL_MainPhoto.png";
import Model600XL1 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600XL Surf Rake/Barber_SurfRake600XL_1.jpg";
import Model600XL2 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600XL Surf Rake/Barber_SurfRake600XL_2.jpg";
import Model600XL3 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600XL Surf Rake/Barber_SurfRake600XL_3.jpg";
import Model600XL4 from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600XL Surf Rake/Barber_SurfRake600XL_4.jpg";
// Walk Behind Machines
import WBMMain from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda 2.0 Electric/PFG_BARRACUDA20_MainPhoto.png";

import BarracudaMain from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda/PFG_BARRACUDA_MainPhoto.png";
import Barracuda from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda/PFG_BARRACUDA_2.jpg";
import Barracuda1 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda/PFG_BARRACUDA_3.jpg";
import Barracuda2 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda/PFG_BARRACUDA_4.jpg";
import Barracuda3 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda/PFG_BARRACUDA_5.jpg";

import BarracudaElectricMain from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda 2.0 Electric/PFG_BARRACUDA20_MainPhoto.png";
import BarracudaElectric from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda 2.0 Electric/PFG_BARRACUDA20_1.png";
import BarracudaElectric1 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda 2.0 Electric/PFG_BARRACUDA20_2.png";
import BarracudaElectric2 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda 2.0 Electric/PFG_BARRACUDA20_3.png";
import BarracudaElectric3 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda 2.0 Electric/PFG_BARRACUDA20_4.png";

import DolphinMain from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin/PFG_Delfino_MainPhoto.png";
import Dolphin from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin/PFG_DELFINO_2.jpg";
import Dolphin1 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin/PFG_DELFINO_3.jpg";
import Dolphin2 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin/PFG_DELFINO_4.jpg";
import Dolphin3 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin/PFG_DELFINO_5.jpg";

import DolphinElectricMain from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin 2.0 Electric/PFG_Delfino20_MainPhoto.png";
import DolphinElectric from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin 2.0 Electric/PFG_DELFINO20_1.png";
import DolphinElectric1 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin 2.0 Electric/PFG_DELFINO20_2.png";
import DolphinElectric2 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin 2.0 Electric/PFG_DELFINO20_3.png";
import DolphinElectric3 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin 2.0 Electric/PFG_DELFINO20_4.png";
import DolphinElectric4 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin 2.0 Electric/PFG_DELFINO20_5.png";

import SandMan1 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Sand Man/MODEL 850/Barber_SandMan_1.jpg";
import SandMan2 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Sand Man/MODEL 850/Barber_SandMan_2.jpg";
import SandMan3 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Sand Man/MODEL 850/Barber_SandMan_3.jpg";
import SandMan4 from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Sand Man/MODEL 850/Barber_SandMan_4.jpg";
import SandManMain from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Sand Man/MODEL 850/Barber_SandMan_MainPhoto.png";
// Grass Collector Machines
import KoalaMain from "../img/3. Grass Collector Machines/20. KOALA/PHOTOS/PERUZZO_KOALA_MainPhoto.png";
import Koala1 from "../img/3. Grass Collector Machines/20. KOALA/PHOTOS/PERUZZO_KOALA_8.jpg";
import Koala2 from "../img/3. Grass Collector Machines/20. KOALA/PHOTOS/PERUZZO_KOALA_9.jpg";
import Koala3 from "../img/3. Grass Collector Machines/20. KOALA/PHOTOS/PERUZZO_KOALA_10.jpg";
import Koala4 from "../img/3. Grass Collector Machines/20. KOALA/PHOTOS/PERUZZO_KOALA_11.jpg";

import KoalaProMain from "../img/3. Grass Collector Machines/21. KOALA PROFESSIONAL/PHOTOS/PERUZZO_KOALA PROFESSIOAL_MainPhoto.png";
import KoalaPro1 from "../img/3. Grass Collector Machines/21. KOALA PROFESSIONAL/PHOTOS/PERUZZO_KOALA PROFESSIOAL_14.jpg";
import KoalaPro2 from "../img/3. Grass Collector Machines/21. KOALA PROFESSIONAL/PHOTOS/PERUZZO_KOALA PROFESSIOAL_15.jpg";
import KoalaPro3 from "../img/3. Grass Collector Machines/21. KOALA PROFESSIONAL/PHOTOS/PERUZZO_KOALA PROFESSIOAL_16.jpg";
import KoalaPro4 from "../img/3. Grass Collector Machines/21. KOALA PROFESSIONAL/PHOTOS/PERUZZO_KOALA PROFESSIOAL_17.jpg";

import PhanterMain from "../img/3. Grass Collector Machines/22. PHANTER/PHOTOS/PERUZZO_PANTHER_MainPhoto.png";
import Phanter1 from "../img/3. Grass Collector Machines/22. PHANTER/PHOTOS/PERUZZO_PHANTER_10.jpg";
import Phanter2 from "../img/3. Grass Collector Machines/22. PHANTER/PHOTOS/PERUZZO_PHANTER_11.jpg";
import Phanter3 from "../img/3. Grass Collector Machines/22. PHANTER/PHOTOS/PERUZZO_PHANTER_12.jpg";
import Phanter4 from "../img/3. Grass Collector Machines/22. PHANTER/PHOTOS/PERUZZO_PHANTER_13.jpg";

import PhanterMultifitMain from "../img/3. Grass Collector Machines/23. PHANTER MULTIFIT/PHOTOS/PERUZZO_PANTHERMULTIFIT_MainPhoto.png";
import PhanterMultifit from "../img/3. Grass Collector Machines/23. PHANTER MULTIFIT/PHOTOS/PERUZZO_PHANTERMULTIFIT_3.jpg";
import PhanterMultifit1 from "../img/3. Grass Collector Machines/23. PHANTER MULTIFIT/PHOTOS/PERUZZO_PHANTERMULTIFIT_4.jpg";
import PhanterMultifit2 from "../img/3. Grass Collector Machines/23. PHANTER MULTIFIT/PHOTOS/PERUZZO_PHANTERMULTIFIT_5.jpg";
import PhanterMultifit3 from "../img/3. Grass Collector Machines/23. PHANTER MULTIFIT/PHOTOS/PERUZZO_PHANTERMULTIFIT_6.jpg";

import PhanterProfessionalMain from "../img/3. Grass Collector Machines/24. PHANTER PROFESSIONAL/PHOTOS/PERUZZO_PANTHERPROFESSIONAL_MainPhoto.png";
import PhanterProfessional from "../img/3. Grass Collector Machines/24. PHANTER PROFESSIONAL/PHOTOS/PERUZZO_PHANTERPROFESSIONAL_7.jpg";
import PhanterProfessional1 from "../img/3. Grass Collector Machines/24. PHANTER PROFESSIONAL/PHOTOS/PERUZZO_PHANTERPROFESSIONAL_8.jpg";
import PhanterProfessional2 from "../img/3. Grass Collector Machines/24. PHANTER PROFESSIONAL/PHOTOS/PERUZZO_PHANTERPROFESSIONAL_9.jpg";
import PhanterProfessional3 from "../img/3. Grass Collector Machines/24. PHANTER PROFESSIONAL/PHOTOS/PERUZZO_PHANTERPROFESSIONAL_10.jpg";

import TigerMain from "../img/3. Grass Collector Machines/25. TIGER/PHOTOS/PERUZZO_TIGER_MainPhoto.png";
import Tiger1 from "../img/3. Grass Collector Machines/25. TIGER/PHOTOS/PERUZZO_TIGER_15.jpg";
import Tiger2 from "../img/3. Grass Collector Machines/25. TIGER/PHOTOS/PERUZZO_TIGER_16.jpg";
import Tiger3 from "../img/3. Grass Collector Machines/25. TIGER/PHOTOS/PERUZZO_TIGER_17.jpg";
import Tiger4 from "../img/3. Grass Collector Machines/25. TIGER/PHOTOS/PERUZZO_TIGER_18.jpg";

import CanguroMain from "../img/3. Grass Collector Machines/27. CANGURO PROFESSIONAL SUPER/PHOTOS/PERUZZO_CANGUROPROFESSIONALSUPER_MainPhoto.png";
import CanguroNormal from "../img/3. Grass Collector Machines/26. CANGURO NORMAL SUPER/PHOTOS/PERUZZO_CANGURONORMALSUPER_23.jpg";
import CanguroNormal1 from "../img/3. Grass Collector Machines/26. CANGURO NORMAL SUPER/PHOTOS/PERUZZO_CANGURONORMALSUPER_24.jpg";
import CanguroNormal2 from "../img/3. Grass Collector Machines/26. CANGURO NORMAL SUPER/PHOTOS/PERUZZO_CANGURONORMALSUPER_25.jpg";
import CanguroNormal3 from "../img/3. Grass Collector Machines/26. CANGURO NORMAL SUPER/PHOTOS/PERUZZO_CANGURONORMALSUPER_26.jpg";

import CanguroProfessional from "../img/3. Grass Collector Machines/27. CANGURO PROFESSIONAL SUPER/PHOTOS/PERUZZO_CANGUROPROFESSIONALSUPER_2.jpg";
import CanguroProfessional1 from "../img/3. Grass Collector Machines/27. CANGURO PROFESSIONAL SUPER/PHOTOS/PERUZZO_CANGUROPROFESSIONALSUPER_3.jpg";
import CanguroProfessional2 from "../img/3. Grass Collector Machines/27. CANGURO PROFESSIONAL SUPER/PHOTOS/PERUZZO_CANGUROPROFESSIONALSUPER_4.jpg";
import CanguroProfessional3 from "../img/3. Grass Collector Machines/27. CANGURO PROFESSIONAL SUPER/PHOTOS/PERUZZO_CANGUROPROFESSIONALSUPER_1.jpg";

import ElephantMain from "../img/3. Grass Collector Machines/28. ELEPHANT SUPER/PHOTOS/PERUZZO_ELEPHANT_MainPhoto.png";
import Elephant1 from "../img/3. Grass Collector Machines/28. ELEPHANT SUPER/PHOTOS/PERUZZO_ELEPHANT_6.jpg";
import Elephant2 from "../img/3. Grass Collector Machines/28. ELEPHANT SUPER/PHOTOS/PERUZZO_ELEPHANT_7.jpg";
import Elephant3 from "../img/3. Grass Collector Machines/28. ELEPHANT SUPER/PHOTOS/PERUZZO_ELEPHANT_8.jpg";
import Elephant4 from "../img/3. Grass Collector Machines/28. ELEPHANT SUPER/PHOTOS/PERUZZO_ELEPHANT_9.jpg";
// Grass Mower Machines
import MotofrogMain from "../img/4. Grass Mower Machines/3. MOTOFROG 75/PHOTOS/PERUZZO_MOTOFROG75_MainPhoto.png";
import Motofrog1 from "../img/4. Grass Mower Machines/3. MOTOFROG 75/PHOTOS/PERUZZO_MOTOFROG75_15.jpg";
import Motofrog2 from "../img/4. Grass Mower Machines/3. MOTOFROG 75/PHOTOS/PERUZZO_MOTOFROG75_16.jpg";
import Motofrog3 from "../img/4. Grass Mower Machines/3. MOTOFROG 75/PHOTOS/PERUZZO_MOTOFROG75_17.jpg";
import Motofrog4 from "../img/4. Grass Mower Machines/3. MOTOFROG 75/PHOTOS/PERUZZO_MOTOFROG75_18.jpg";

import TEGSpMain from "../img/4. Grass Mower Machines/5. TEG SPECIAL - TEG SPECIAL HD/PHOTOS/PERUZZO_TEGSPECIALTEGSPECIALHD_MainPhoto.png";
import TEGSp1 from "../img/4. Grass Mower Machines/5. TEG SPECIAL - TEG SPECIAL HD/PHOTOS/PERUZZO_TEGSPECIALTEGSPECIALHD_21.jpg";
import TEGSp2 from "../img/4. Grass Mower Machines/5. TEG SPECIAL - TEG SPECIAL HD/PHOTOS/PERUZZO_TEGSPECIALTEGSPECIALHD_22.jpg";
import TEGSp3 from "../img/4. Grass Mower Machines/5. TEG SPECIAL - TEG SPECIAL HD/PHOTOS/PERUZZO_TEGSPECIALTEGSPECIALHD_23.jpg";
import TEGSp4 from "../img/4. Grass Mower Machines/5. TEG SPECIAL - TEG SPECIAL HD/PHOTOS/PERUZZO_TEGSPECIALTEGSPECIALHD_24.jpg";

import ScorpionMain from "../img/4. Grass Mower Machines/6. SCORPION/PHOTOS/PERUZZO_SCORPION_MainPhoto.png";
import Scorpion1 from "../img/4. Grass Mower Machines/6. SCORPION/PHOTOS/PERUZZO_SCORPION_9.jpg";
import Scorpion2 from "../img/4. Grass Mower Machines/6. SCORPION/PHOTOS/PERUZZO_SCORPION_10.jpg";
import Scorpion3 from "../img/4. Grass Mower Machines/6. SCORPION/PHOTOS/PERUZZO_SCORPION_11.jpg";
import Scorpion4 from "../img/4. Grass Mower Machines/6. SCORPION/PHOTOS/PERUZZO_SCORPION_12.jpg";

import FOXMain from "../img/4. Grass Mower Machines/7. FOX/PHOTOS/PERUZZO_FOX_MainPhoto.png";
import FOX1 from "../img/4. Grass Mower Machines/7. FOX/PHOTOS/PERUZZO_FOX_10.jpg";
import FOX2 from "../img/4. Grass Mower Machines/7. FOX/PHOTOS/PERUZZO_FOX_11.jpg";
import FOX3 from "../img/4. Grass Mower Machines/7. FOX/PHOTOS/PERUZZO_FOX_12.jpg";
import FOX4 from "../img/4. Grass Mower Machines/7. FOX/PHOTOS/PERUZZO_FOX_13.jpg";

import FOXSMain from "../img/4. Grass Mower Machines/8. FOX-S/PHOTOS/PERUZZO_FOXS_MainPhoto.png";
import FOXS1 from "../img/4. Grass Mower Machines/8. FOX-S/PHOTOS/PERUZZO_FOXS_10.jpg";
import FOXS2 from "../img/4. Grass Mower Machines/8. FOX-S/PHOTOS/PERUZZO_FOXS_11.jpg";
import FOXS3 from "../img/4. Grass Mower Machines/8. FOX-S/PHOTOS/PERUZZO_FOXS_12.jpg";
import FOXS4 from "../img/4. Grass Mower Machines/8. FOX-S/PHOTOS/PERUZZO_FOXS_13.jpg";

import MotoFOXMain from "../img/4. Grass Mower Machines/9. MOTOFOX/PHOTOS/PERUZZO_MOTOFOX_12.jpg";
import MotoFOX1 from "../img/4. Grass Mower Machines/9. MOTOFOX/PHOTOS/PERUZZO_MOTOFOX_10.jpg";
import MotoFOX2 from "../img/4. Grass Mower Machines/9. MOTOFOX/PHOTOS/PERUZZO_MOTOFOX_11.jpg";
import MotoFOX3 from "../img/4. Grass Mower Machines/9. MOTOFOX/PHOTOS/PERUZZO_MOTOFOX_12.jpg";
import MotoFOX4 from "../img/4. Grass Mower Machines/9. MOTOFOX/PHOTOS/PERUZZO_MOTOFOX_9.jpg";

import PumaMain from "../img/4. Grass Mower Machines/10. PUMA/PHOTOS/PERUZZO_PUMA_MainPhoto.png";
import Puma1 from "../img/4. Grass Mower Machines/10. PUMA/PHOTOS/PERUZZO_PUMA_10.jpg";
import Puma2 from "../img/4. Grass Mower Machines/10. PUMA/PHOTOS/PERUZZO_PUMA_6.jpg";
import Puma3 from "../img/4. Grass Mower Machines/10. PUMA/PHOTOS/PERUZZO_PUMA_7.jpg";
import Puma4 from "../img/4. Grass Mower Machines/10. PUMA/PHOTOS/PERUZZO_PUMA_8.jpg";

import ELKMain from "../img/4. Grass Mower Machines/11. ELK/PHOTOS/PERUZZO_ELK_MainPhoto.png";
import ELK1 from "../img/4. Grass Mower Machines/11. ELK/PHOTOS/PERUZZO_ELK_10.jpg";
import ELK2 from "../img/4. Grass Mower Machines/11. ELK/PHOTOS/PERUZZO_ELK_11.jpg";
import ELK3 from "../img/4. Grass Mower Machines/11. ELK/PHOTOS/PERUZZO_ELK_12.jpg";
import ELK4 from "../img/4. Grass Mower Machines/11. ELK/PHOTOS/PERUZZO_ELK_13.jpg";

import TRIFLEXMain from "../img/4. Grass Mower Machines/12. TRIFLEX/PHOTOS/PERUZZO_TRIFLEX_MainPhoto.png";
import TRIFLEX1 from "../img/4. Grass Mower Machines/12. TRIFLEX/PHOTOS/PERUZZO_TRIFLEX_10.jpg";
import TRIFLEX2 from "../img/4. Grass Mower Machines/12. TRIFLEX/PHOTOS/PERUZZO_TRIFLEX_11.jpg";
import TRIFLEX3 from "../img/4. Grass Mower Machines/12. TRIFLEX/PHOTOS/PERUZZO_TRIFLEX_12.jpg";
import TRIFLEX4 from "../img/4. Grass Mower Machines/12. TRIFLEX/PHOTOS/PERUZZO_TRIFLEX_13.jpg";
import TRIFLEX5 from "../img/4. Grass Mower Machines/12. TRIFLEX/PHOTOS/PERUZZO_TRIFLEX_14.jpg";

import FOXCrossMain from "../img/4. Grass Mower Machines/13. FOX CROSS/PHOTOS/PERUZZO_FOXCROSS_MainPhoto.png";
import FOXCross1 from "../img/4. Grass Mower Machines/13. FOX CROSS/PHOTOS/PERUZZO_FOXCROSS_1.jpg";
import FOXCross2 from "../img/4. Grass Mower Machines/13. FOX CROSS/PHOTOS/PERUZZO_FOXCROSS_2.jpg";
import FOXCross3 from "../img/4. Grass Mower Machines/13. FOX CROSS/PHOTOS/PERUZZO_FOXCROSS_3.jpg";
import FOXCross4 from "../img/4. Grass Mower Machines/13. FOX CROSS/PHOTOS/PERUZZO_FOXCROSS_4.jpg";

import ELKCrossMain from "../img/4. Grass Mower Machines/14. ELK CROSS/PHOTOS/PERUZZO_ELKCROSS_MainPhoto.png";
import ELKCross1 from "../img/4. Grass Mower Machines/14. ELK CROSS/PHOTOS/PERUZZO_ELKCROSS_10.jpg";
import ELKCross2 from "../img/4. Grass Mower Machines/14. ELK CROSS/PHOTOS/PERUZZO_ELKCROSS_1.jpg";
import ELKCross3 from "../img/4. Grass Mower Machines/14. ELK CROSS/PHOTOS/PERUZZO_ELKCROSS_2.jpg";
import ELKCross4 from "../img/4. Grass Mower Machines/14. ELK CROSS/PHOTOS/PERUZZO_ELKCROSS_3.jpg";

import ELKCrossFMain from "../img/4. Grass Mower Machines/15. ELK CROSS FRONT/PHOTOS/PERUZZO_ELKCROSSFRONT_MainPhoto.png";
import ELKCrossF1 from "../img/4. Grass Mower Machines/15. ELK CROSS FRONT/PHOTOS/PERUZZO_ELKCROSSFRONT_10.jpg";
import ELKCrossF2 from "../img/4. Grass Mower Machines/15. ELK CROSS FRONT/PHOTOS/PERUZZO_ELKCROSSFRONT_11.jpg";
import ELKCrossF3 from "../img/4. Grass Mower Machines/15. ELK CROSS FRONT/PHOTOS/PERUZZO_ELKCROSSFRONT_12.jpg";
import ELKCrossF4 from "../img/4. Grass Mower Machines/15. ELK CROSS FRONT/PHOTOS/PERUZZO_ELKCROSSFRONT_13.jpg";

import BullMain from "../img/4. Grass Mower Machines/16. BULL CROSS/PHOTOS/PERUZZO_BULLCROSS_MainPhoto.png";
import BullCross1 from "../img/4. Grass Mower Machines/16. BULL CROSS/PHOTOS/PERUZZO_BULLCROSS_MainPhoto.png";
import BullCross2 from "../img/4. Grass Mower Machines/16. BULL CROSS/PHOTOS/PERUZZO_BULLCROSS_1.jpg";
import BullCross3 from "../img/4. Grass Mower Machines/16. BULL CROSS/PHOTOS/PERUZZO_BULLCROSS_2.png";
import BullCross4 from "../img/4. Grass Mower Machines/16. BULL CROSS/PHOTOS/PERUZZO_BULLCROSS_3.jpg";

import BullSuper1 from "../img/4. Grass Mower Machines/17. BULL SUPER/PHOTOS/PERUZZO_BULLSUPER_MainPhoto.png";
import BullSuper2 from "../img/4. Grass Mower Machines/17. BULL SUPER/PHOTOS/PERUZZO_BULLSUPER_1.jpg";
import BullSuper3 from "../img/4. Grass Mower Machines/17. BULL SUPER/PHOTOS/PERUZZO_BULLSUPER_2.jpg";
import BullSuper4 from "../img/4. Grass Mower Machines/17. BULL SUPER/PHOTOS/PERUZZO_BULLSUPER_3.jpg";

import BullReverse1 from "../img/4. Grass Mower Machines/18. BULL REVERSE/PHOTOS/PERUZZO_BULLREVERSE_MainPhoto.png";
import BullReverse2 from "../img/4. Grass Mower Machines/18. BULL REVERSE/PHOTOS/PERUZZO_BULLREVERSE_1.jpg";
import BullReverse3 from "../img/4. Grass Mower Machines/18. BULL REVERSE/PHOTOS/PERUZZO_BULLREVERSE_2.jpg";
import BullReverse4 from "../img/4. Grass Mower Machines/18. BULL REVERSE/PHOTOS/PERUZZO_BULLREVERSE_3.jpg";

import ROTOMain from "../img/4. Grass Mower Machines/19. ROTO/PHOTOS/PERUZZO_ROTO_MainPhoto.png";
import ROTO1 from "../img/4. Grass Mower Machines/19. ROTO/PHOTOS/PERUZZO_ROTO_10.jpg";
import ROTO2 from "../img/4. Grass Mower Machines/19. ROTO/PHOTOS/PERUZZO_ROTO_11.jpg";
import ROTO3 from "../img/4. Grass Mower Machines/19. ROTO/PHOTOS/PERUZZO_ROTO_12.jpg";
import ROTO4 from "../img/4. Grass Mower Machines/19. ROTO/PHOTOS/PERUZZO_ROTO_13.jpg";
import ROTO5 from "../img/4. Grass Mower Machines/19. ROTO/PHOTOS/PERUZZO_ROTO_14.jpg";

// Remote Controlled Grass Mower
import RobofoxMain from "../img/5. Remote Controlled Grass Mower/1. ROBOFOX ELECTRIC/PHOTOS/PERUZZO_ROBOFOXELECTRIC_MainPhoto.png";
import RobofoxElectric1 from "../img/5. Remote Controlled Grass Mower/1. ROBOFOX ELECTRIC/PHOTOS/PERUZZO_ROBOFOXELECTRIC_1.jpg";
import RobofoxElectric2 from "../img/5. Remote Controlled Grass Mower/1. ROBOFOX ELECTRIC/PHOTOS/PERUZZO_ROBOFOXELECTRIC_2.jpg";
import RobofoxElectric3 from "../img/5. Remote Controlled Grass Mower/1. ROBOFOX ELECTRIC/PHOTOS/PERUZZO_ROBOFOXELECTRIC_3.jpg";
import RobofoxElectric4 from "../img/5. Remote Controlled Grass Mower/1. ROBOFOX ELECTRIC/PHOTOS/PERUZZO_ROBOFOXELECTRIC_4.jpg";

import RobofoxHybridMain from "../img/5. Remote Controlled Grass Mower/2. ROBOFOX HYBRID/PHOTOS/PERUZZO_ROBOFOXHYBRID_MainPhoto.png";
import RobofoxHybrid1 from "../img/5. Remote Controlled Grass Mower/2. ROBOFOX HYBRID/PHOTOS/PERUZZO_ROBOFOXHYBRID_1.jpg";
import RobofoxHybrid2 from "../img/5. Remote Controlled Grass Mower/2. ROBOFOX HYBRID/PHOTOS/PERUZZO_ROBOFOXHYBRID_2.jpg";
import RobofoxHybrid3 from "../img/5. Remote Controlled Grass Mower/2. ROBOFOX HYBRID/PHOTOS/PERUZZO_ROBOFOXHYBRID_3.jpg";
import RobofoxHybrid4 from "../img/5. Remote Controlled Grass Mower/2. ROBOFOX HYBRID/PHOTOS/PERUZZO_ROBOFOXHYBRID_4.jpg";
// Litter Collection Equipment
import PTO570Main from "../img/6. Litter Collection Equipment/570PTO/Votex_570PTO_MainPhoto.png";
import PTO5701 from "../img/6. Litter Collection Equipment/570PTO/Votex_570PTO_1.webp";
import PTO5702 from "../img/6. Litter Collection Equipment/570PTO/Votex_570PTO_2.webp";
import PTO5703 from "../img/6. Litter Collection Equipment/570PTO/Votex_570PTO_3.webp";

import M5211 from "../img/6. Litter Collection Equipment/521M/Votex_521M_MainPhoto.png";
import M5251 from "../img/6. Litter Collection Equipment/525M/Votex_525M_MainPhoto.png";
import M541Main from "../img/6. Litter Collection Equipment/541M/Votex_541M_MainPhoto.png";
import M546Main from "../img/6. Litter Collection Equipment/546M/Votex_546M_MainPhoto.png";

import Model400Main from "../img/6. Litter Collection Equipment/Model 400 Turf Rake/Barber_TurfRake400_MainPhoto.png";
import Model4001 from "../img/6. Litter Collection Equipment/Model 400 Turf Rake/Barber_RoadRake400_1.jpg";
import Model4002 from "../img/6. Litter Collection Equipment/Model 400 Turf Rake/Barber_RoadRake400_2.jpg";
import Model4003 from "../img/6. Litter Collection Equipment/Model 400 Turf Rake/Barber_RoadRake400_3.jpg";
import Model4004 from "../img/6. Litter Collection Equipment/Model 400 Turf Rake/Barber_RoadRake400_4.jpg";

import Model400HDMain from "../img/6. Litter Collection Equipment/Model 400HD Turf Rake/Barber_TurfRake400HD_MainPhoto.png";
import Model400HD1 from "../img/6. Litter Collection Equipment/Model 400HD Turf Rake/Barber_RoadRake400HD_1.jpg";
import Model400HD2 from "../img/6. Litter Collection Equipment/Model 400HD Turf Rake/Barber_RoadRake400HD_2.jpg";
import Model400HD3 from "../img/6. Litter Collection Equipment/Model 400HD Turf Rake/Barber_RoadRake400HD_3.jpg";
import Model400HD4 from "../img/6. Litter Collection Equipment/Model 400HD Turf Rake/Barber_RoadRake400HD_4.jpg";

import Model600HDMain from "../img/6. Litter Collection Equipment/Model 600HD Turf Rake/Barber_TurfRake600HD_MainPhoto.png";
import Model600HD1 from "../img/6. Litter Collection Equipment/Model 600HD Turf Rake/Barber_RoadRake600HD_1.jpg";
import Model600HD2 from "../img/6. Litter Collection Equipment/Model 600HD Turf Rake/Barber_RoadRake600HD_2.jpg";
import Model600HD3 from "../img/6. Litter Collection Equipment/Model 600HD Turf Rake/Barber_RoadRake600HD_3.jpg";
import Model600HD4 from "../img/6. Litter Collection Equipment/Model 600HD Turf Rake/Barber_RoadRake600HD_4.jpg";

import ModelLP1Main from "../img/6. Litter Collection Equipment/Model LP1 Litter Picker/Barber_LP1_MainPhoto.png";
import ModelLP11 from "../img/6. Litter Collection Equipment/Model LP1 Litter Picker/Barber_LP1_1.jpg";
import ModelLP12 from "../img/6. Litter Collection Equipment/Model LP1 Litter Picker/Barber_LP1_2.jpg";
import ModelLP13 from "../img/6. Litter Collection Equipment/Model LP1 Litter Picker/Barber_LP1_3.jpg";
import ModelLP14 from "../img/6. Litter Collection Equipment/Model LP1 Litter Picker/Barber_LP1_4.jpg";

import RR200TMain from "../img/6. Litter Collection Equipment/Road Rake Model 200T/Barber_Model_200T_MainPhoto.png";
import RR2001 from "../img/6. Litter Collection Equipment/Road Rake Model 200/Barber_Model_200_MainPhoto.png";
import RR2002 from "../img/6. Litter Collection Equipment/Road Rake Model 200T/Barber_RoadRake200T_1.jpg";
import RR2003 from "../img/6. Litter Collection Equipment/Road Rake Model 200T/Barber_RoadRake200T_3.jpg";
import RR2004 from "../img/6. Litter Collection Equipment/Road Rake Model 200T/Barber_RoadRake200T_4.jpg";

import RR200T1 from "../img/6. Litter Collection Equipment/Road Rake Model 200T/Barber_RoadRake200T_2.jpg";
import RR200T2 from "../img/6. Litter Collection Equipment/Road Rake Model 200T/Barber_RoadRake200T_6.jpg";
import RR200T3 from "../img/6. Litter Collection Equipment/Road Rake Model 200T/Barber_RoadRake200T_3.jpg";
import RR200T4 from "../img/6. Litter Collection Equipment/Road Rake Model 200T/Barber_RoadRake200T_4.jpg";

import RotovacMain from "../img/6. Litter Collection Equipment/Rotovac/PHOTOS/PERUZZO_ROTOVAC_MainPhoto.png";
import Rotovac1 from "../img/6. Litter Collection Equipment/Rotovac/PHOTOS/PERUZZO_ROTOVAC_26.jpg";
import Rotovac2 from "../img/6. Litter Collection Equipment/Rotovac/PHOTOS/PERUZZO_ROTOVAC_27.jpg";
import Rotovac3 from "../img/6. Litter Collection Equipment/Rotovac/PHOTOS/PERUZZO_ROTOVAC_28.jpg";
import Rotovac4 from "../img/6. Litter Collection Equipment/Rotovac/PHOTOS/PERUZZO_ROTOVAC_29.jpg";
import Rotovac5 from "../img/6. Litter Collection Equipment/Rotovac/PHOTOS/PERUZZO_ROTOVAC_30.jpg";

import Turbo400Main from "../img/6. Litter Collection Equipment/Turbo 400 Vacuum Machine/PHOTOS/PERUZZO_TURBO400_MainPhoto.png";
import Turbo4001 from "../img/6. Litter Collection Equipment/Turbo 400 Vacuum Machine/PHOTOS/PERUZZO_TURBO400_10.jpg";
import Turbo4002 from "../img/6. Litter Collection Equipment/Turbo 400 Vacuum Machine/PHOTOS/PERUZZO_TURBO400_11.jpg";
import Turbo4003 from "../img/6. Litter Collection Equipment/Turbo 400 Vacuum Machine/PHOTOS/PERUZZO_TURBO400_12.jpg";
import Turbo4004 from "../img/6. Litter Collection Equipment/Turbo 400 Vacuum Machine/PHOTOS/PERUZZO_TURBO400_13.jpg";
import Turbo4005 from "../img/6. Litter Collection Equipment/Turbo 400 Vacuum Machine/PHOTOS/PERUZZO_TURBO400_14.jpg";

import VT1100Main from "../img/6. Litter Collection Equipment/VT1100/Votex_VT1100_MainPhoto.png";
import VT11001 from "../img/6. Litter Collection Equipment/VT1100/Votex_VT1100_1.webp";
import VT11002 from "../img/6. Litter Collection Equipment/VT1100/Votex_VT1100_2.webp";

import VT4201 from "../img/6. Litter Collection Equipment/VT420/Votex_VT420_MainPhoto.png";
import VT4202 from "../img/6. Litter Collection Equipment/VT420/Votex_VT420_1.webp";
import VT4203 from "../img/6. Litter Collection Equipment/VT420/Votex_VT420_2.webp";
import VT4204 from "../img/6. Litter Collection Equipment/VT420/Votex_VT420_3.webp";
import VT4205 from "../img/6. Litter Collection Equipment/VT420/Votex_VT420_4.webp";

import VT8501 from "../img/6. Litter Collection Equipment/VT850/Votex_VT850_MainPhoto.png";
import VT8502 from "../img/6. Litter Collection Equipment/VT850/Votex_VT850_1.webp";
import VT8503 from "../img/6. Litter Collection Equipment/VT850/Votex_VT850_2.webp";
import VT8504 from "../img/6. Litter Collection Equipment/VT850/Votex_VT850_3.webp";
import VT8505 from "../img/6. Litter Collection Equipment/VT850/Votex_VT850_4.webp";
// Wood Chipper Machines
import T3Main from "../img/7. Wood Chipper Machines/1. T3/PHOTOS/PERUZZO_T3_MainPhoto.png";
import T31 from "../img/7. Wood Chipper Machines/1. T3/PHOTOS/PERUZZO_T3_1.jpg";
import T32 from "../img/7. Wood Chipper Machines/1. T3/PHOTOS/PERUZZO_T3_2.jpg";
import T33 from "../img/7. Wood Chipper Machines/1. T3/PHOTOS/PERUZZO_T3_3.jpg";
import T34 from "../img/7. Wood Chipper Machines/1. T3/PHOTOS/PERUZZO_T3_4.jpg";

import T5Main from "../img/7. Wood Chipper Machines/2. T5/PHOTOS/PERUZZO_T5_MainPhoto.png";
import T51 from "../img/7. Wood Chipper Machines/2. T5/PHOTOS/PERUZZO_T5_1.jpg";
import T52 from "../img/7. Wood Chipper Machines/2. T5/PHOTOS/PERUZZO_T5_2.jpg";
import T53 from "../img/7. Wood Chipper Machines/2. T5/PHOTOS/PERUZZO_T5_3.jpg";
import T54 from "../img/7. Wood Chipper Machines/2. T5/PHOTOS/PERUZZO_T5_4.jpg";

import TB50Main from "../img/7. Wood Chipper Machines/3 .TB50/PHOTOS/PERUZZO_TB50_MainPhoto.png";
import TB501 from "../img/7. Wood Chipper Machines/3 .TB50/PHOTOS/PERUZZO_TB50_1.jpg";
import TB502 from "../img/7. Wood Chipper Machines/3 .TB50/PHOTOS/PERUZZO_TB50_2.jpg";
import TB503 from "../img/7. Wood Chipper Machines/3 .TB50/PHOTOS/PERUZZO_TB50_3.jpg";
import TB504 from "../img/7. Wood Chipper Machines/3 .TB50/PHOTOS/PERUZZO_TB50_4.jpg";

import TB100Main from "../img/7. Wood Chipper Machines/4. TB 100/PHOTOS/PERUZZO_TB100_MainPhoto.png";
import TB1001 from "../img/7. Wood Chipper Machines/4. TB 100/PHOTOS/PERUZZO_TB100_1.jpg";
import TB1002 from "../img/7. Wood Chipper Machines/4. TB 100/PHOTOS/PERUZZO_TB100_2.jpg";
import TB1003 from "../img/7. Wood Chipper Machines/4. TB 100/PHOTOS/PERUZZO_TB100_3.jpg";
import TB1004 from "../img/7. Wood Chipper Machines/4. TB 100/PHOTOS/PERUZZO_TB100_4.jpg";

import TB120CProMain from "../img/7. Wood Chipper Machines/5. TB 120 C PROFESSIONAL/PHOTOS/PERUZZO_TB120PROFESSIONAL_MainPhoto.png";
import TB120CPro1 from "../img/7. Wood Chipper Machines/5. TB 120 C PROFESSIONAL/PHOTOS/PERUZZO_TB120PROFESSIONAL_1.jpg";
import TB120CPro2 from "../img/7. Wood Chipper Machines/5. TB 120 C PROFESSIONAL/PHOTOS/PERUZZO_TB120PROFESSIONAL_2.jpg";
import TB120CPro3 from "../img/7. Wood Chipper Machines/5. TB 120 C PROFESSIONAL/PHOTOS/PERUZZO_TB120PROFESSIONAL_3.jpg";
import TB120CPro4 from "../img/7. Wood Chipper Machines/5. TB 120 C PROFESSIONAL/PHOTOS/PERUZZO_TB120PROFESSIONAL_4.jpg";

import TB100CProMain from "../img/7. Wood Chipper Machines/6. TB 100 C PROFESSIONAL/PHOTOS/PERUZZO_TB100CPROFESSIONAL_MainPhoto.png";
import TB100CPro1 from "../img/7. Wood Chipper Machines/6. TB 100 C PROFESSIONAL/PHOTOS/PERUZZO_TB100CPROFESSIONAL_1.jpg";
import TB100CPro2 from "../img/7. Wood Chipper Machines/6. TB 100 C PROFESSIONAL/PHOTOS/PERUZZO_TB100CPROFESSIONAL_2.jpg";
import TB100CPro3 from "../img/7. Wood Chipper Machines/6. TB 100 C PROFESSIONAL/PHOTOS/PERUZZO_TB100CPROFESSIONAL_3.jpg";
import TB100CPro4 from "../img/7. Wood Chipper Machines/6. TB 100 C PROFESSIONAL/PHOTOS/PERUZZO_TB100CPROFESSIONAL_4.jpg";

import TB100TMain from "../img/7. Wood Chipper Machines/7. TB 100 T/PHOTOS/PERUZZO_TB100TPROFESSIONAL_MainPhoto.png";
import TB100T1 from "../img/7. Wood Chipper Machines/7. TB 100 T/PHOTOS/PERUZZO_TB100TPROFESSIONAL_1.jpg";
import TB100T2 from "../img/7. Wood Chipper Machines/7. TB 100 T/PHOTOS/PERUZZO_TB100TPROFESSIONAL_2.jpg";
import TB100T3 from "../img/7. Wood Chipper Machines/7. TB 100 T/PHOTOS/PERUZZO_TB100TPROFESSIONAL_3.jpg";
import TB100T4 from "../img/7. Wood Chipper Machines/7. TB 100 T/PHOTOS/PERUZZO_TB100TPROFESSIONAL_4.jpg";

import TB100CMain from "../img/7. Wood Chipper Machines/8. TB 100 C/PHOTOS/PERUZZO_TB100C_MainPhoto.png";
import TB100C1 from "../img/7. Wood Chipper Machines/8. TB 100 C/PHOTOS/PERUZZO_TB100C_1.jpg";
import TB100C2 from "../img/7. Wood Chipper Machines/8. TB 100 C/PHOTOS/PERUZZO_TB100C_2.jpg";
import TB100C3 from "../img/7. Wood Chipper Machines/8. TB 100 C/PHOTOS/PERUZZO_TB100C_3.jpg";
import TB100C4 from "../img/7. Wood Chipper Machines/8. TB 100 C/PHOTOS/PERUZZO_TB100C_4.jpg";

import TIREXMain from "../img/7. Wood Chipper Machines/9. TIREX/PHOTOS/PERUZZO_TIREX_MainPhoto.png";
import TIREX1 from "../img/7. Wood Chipper Machines/9. TIREX/PHOTOS/PERUZZO_TIREX_1.jpg";
import TIREX2 from "../img/7. Wood Chipper Machines/9. TIREX/PHOTOS/PERUZZO_TIREX_2.jpeg";
import TIREX3 from "../img/7. Wood Chipper Machines/9. TIREX/PHOTOS/PERUZZO_TIREX_3.jpg";
import TIREX4 from "../img/7. Wood Chipper Machines/9. TIREX/PHOTOS/PERUZZO_TIREX_4.jpg";
// Spading Machines
import Series150951 from "../img/8. Spading Machines/150.95 Series/SELVATICI_150.95series_MainPhoto.png";
import Series150952 from "../img/8. Spading Machines/150.95 Series/SELVATICI_150.95series_1.jpeg";
import Series150953 from "../img/8. Spading Machines/150.95 Series/SELVATICI_150.95series_2.jpeg";
import Series150954 from "../img/8. Spading Machines/150.95 Series/SELVATICI_150.95series_3.jpeg";
import Series150955 from "../img/8. Spading Machines/150.95 Series/SELVATICI_150.95series_4.jpeg";

import Series150150Main from "../img/8. Spading Machines/150.150 Series/SELVATICI_150.150series_MainPhoto.png";
import Series1501501 from "../img/8. Spading Machines/150.150 Series/SELVATICI_serie-150.150_1.jpeg";
import Series1501502 from "../img/8. Spading Machines/150.150 Series/SELVATICI_serie-150.150_2.jpeg";
import Series1501503 from "../img/8. Spading Machines/150.150 Series/SELVATICI_serie-150.150_3.jpeg";
import Series1501504 from "../img/8. Spading Machines/150.150 Series/SELVATICI_serie-150.150_4.jpeg";
import Series1501505 from "../img/8. Spading Machines/150.150 Series/SELVATICI_serie-150.150_5.jpeg";
// Aerial Working Platform
import Octoplus171 from "../img/9. Aerial Working Platform/1. Octoplus 17/OS_OCTOPLUS17_MainPhoto.png";
import Octoplus172 from "../img/9. Aerial Working Platform/1. Octoplus 17/OS_OCTOPLUS17_1.jpg";
import Octoplus173 from "../img/9. Aerial Working Platform/1. Octoplus 17/OS_OCTOPLUS17_2.jpg";
import Octoplus174 from "../img/9. Aerial Working Platform/1. Octoplus 17/OS_OCTOPLUS17_3.jpg";
import Octoplus175 from "../img/9. Aerial Working Platform/1. Octoplus 17/OS_OCTOPLUS17_4.jpg";

import Octoplus21Main from "../img/9. Aerial Working Platform/2. Octoplus 21/OS_OCTOPLUS21_MainPhoto.png";
import Octoplus211 from "../img/9. Aerial Working Platform/2. Octoplus 21/OS_OCTOPLUS21_10.jpg";
import Octoplus212 from "../img/9. Aerial Working Platform/2. Octoplus 21/OS_OCTOPLUS21_11.jpg";
import Octoplus213 from "../img/9. Aerial Working Platform/2. Octoplus 21/OS_OCTOPLUS21_12.jpg";
import Octoplus214 from "../img/9. Aerial Working Platform/2. Octoplus 21/OS_OCTOPLUS21_3.jpg";
import Octoplus215 from "../img/9. Aerial Working Platform/2. Octoplus 21/OS_OCTOPLUS21_4.jpg";

import Snake1471 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 147/OS_Snake-147_MainPhoto.png";
import Snake1472 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 147/OS_Snake-147_1.jpg";
import Snake1473 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 147/OS_Snake-147_2.jpg";
import Snake1474 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 147/OS_Snake-147_3.jpg";

import Snake1891 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 189/OS_Snake-189_MainPhoto.png";

import Snake2112Main from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 2112/OS_Snake-2112_MainPhoto.png";
import Snake21121 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 2112/OS_Snake-2112-Iveco7_10.jpg";
import Snake21122 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 2112/OS_Snake-2112-Iveco7_11.jpg";
import Snake21123 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 2112/OS_Snake-2112-Iveco7_12.jpg";
import Snake21124 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 2112/OS_Snake-2112-Iveco7_13.jpg";
import Snake21125 from "../img/9. Aerial Working Platform/3. Single Pantograph/Snake 2112/OS_Snake-2112-Iveco7_14.jpg";

import Snake161 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 16 - New/OS_snake16_MainPhoto.png";
import Snake1611 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 16 - New/OS_snake16_1.jpg";
import Snake1612 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 16 - New/OS_snake16_2.jpg";
import Snake1613 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 16 - New/OS_snake16_3.jpg";
import Snake1614 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 16 - New/OS_snake16_4.jpg";

import Snake201 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 20 FB/OS_snake20_MainPhoto.png";
import Snake202 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 20 FB/OS_Snake-20FB-Isuzu5.jpg";
import Snake203 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 20 FB/OS_Snake-20FB-Isuzu6.jpg";
import Snake204 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 20 FB/OS_Snake-20FB-Isuzu7.jpg";

import Snake241 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 24 FB/OS_snake24_MainPhoto.png";
import Snake242 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 24 FB/OS_snake24_fb_1.jpg";
import Snake243 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 24 FB/OS_snake24_fb_2.jpg";
import Snake244 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 24 FB/OS_snake24_fb_5.jpg";
import Snake245 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 24 FB/OS_snake24_fb_4.jpg";

import Snake2010H1 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2010 H Plus/OS_snake2010_MainPhoto.png";
import Snake2010H3 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2010 H Plus/OS_Snake-2010H-Plus-Isuzu6.jpg";
import Snake2010H4 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2010 H Plus/OS_Snake-2010H-Plus-Isuzu5.jpg";
import Snake2010H5 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2010 H Plus/OS_Snake-2010H-Plus-Isuzu8.jpg";
import Snake2010H2 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2010 H Plus/OS_Snake-2010H-Plus-Isuzu9.jpg";

import Snake2111J1 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2111J Plus/OS_snake2111j_MainPhoto.png";
import Snake2111J3 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2111J Plus/Snake-2111-J-Plus-Isuzu_2.jpg";
import Snake2111J4 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2111J Plus/Snake-2111-J-Plus-Isuzu_3.jpg";
import Snake2111J5 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2111J Plus/Snake-2111-J-Plus-Isuzu_4.jpg";
import Snake2111J2 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2111J Plus/Snake-2111-J-Plus-Isuzu_5.jpg";

import Snake2413P1 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2413 Plus/OS_Snake2413-Isuzu-10.jpg";
import Snake2413P2 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2413 Plus/OS_Snake2413-Isuzu-11.jpg";
import Snake2413P3 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2413 Plus/OS_Snake2413-Isuzu-12.jpg";
import Snake2413P4 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2413 Plus/OS_Snake2413-Isuzu-13.jpg";
import Snake2413P5 from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2413 Plus/OS_Snake2413-Isuzu-14.jpg";
import Snake2413PMain from "../img/9. Aerial Working Platform/4. Double Pantograph/Snake 2413 Plus/OS_snake2413_MainPhoto.png";

// Truck Mounted Cranes
import v103Cropped from "../img/10. Truck Mounted Cranes/100 Series/v103_cropped.webp";
import v105Cropped from "../img/10. Truck Mounted Cranes/100 Series/v105_cropped.webp";
import v108 from "../img/10. Truck Mounted Cranes/100 Series/v108.webp";
import v111Cropped from "../img/10. Truck Mounted Cranes/100 Series/V111_cropped.webp";
import v115_2 from "../img/10. Truck Mounted Cranes/100 Series/v115_2.webp";
import v120Cropped from "../img/10. Truck Mounted Cranes/100 Series/v120_cropped.webp";
import v123Cropped from "../img/10. Truck Mounted Cranes/100 Series/V123_cropped.webp";

// Hydraulics Generator
// HG Hydraulic Generator
import HGMain from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HG HYDRAULIC GENERATOR/PHOTOS/DYNASET_HYDRAULICGENERATOR_MainPhoto.png";
import HGPhoto1 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HG HYDRAULIC GENERATOR/PHOTOS/DYNASET_HYDRAULICGENERATOR_10.jpg";
import HGPhoto2 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HG HYDRAULIC GENERATOR/PHOTOS/DYNASET_HYDRAULICGENERATOR_11.jpg";
import HGPhoto3 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HG HYDRAULIC GENERATOR/PHOTOS/DYNASET_HYDRAULICGENERATOR_12.jpg";
import HGPhoto4 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HG HYDRAULIC GENERATOR/PHOTOS/DYNASET_HYDRAULICGENERATOR_13.jpg";

// HGG Hydraulic Ground Power Generator
import HGGMain from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGG Hydraulic Ground Power Generator/PHOTOS/DYNASET_HGGHydraulicGroundPowerGenerator_MainPhoto.png";
import HGGPhoto1 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGG Hydraulic Ground Power Generator/PHOTOS/DYNASET_HGGHydraulicGroundPowerGenerator_1.jpg";

// HGV POWER BOX Variable Hydraulic Generator System
import HGVMain from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGV POWER BOX Variable Hydraulic Generator System/PHOTOS/DYNASET_HGVPowerBoxVariableHydraulicGeneratorSystem_MainPhoto.png";
import HGVPhoto1 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGV POWER BOX Variable Hydraulic Generator System/PHOTOS/DYNASET_HGVPowerBoxVariableHydraulicGeneratorSystem_1.jpg";
import HGVPhoto2 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGV POWER BOX Variable Hydraulic Generator System/PHOTOS/DYNASET_HGVPowerBoxVariableHydraulicGeneratorSystem_2.jpg";

// HGV Variable Hydraulic Generator System
import HGVVarMain from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGV Variable Hydraulic Generator System/PHOTOS/DYNASET_HGVVariableHydraulicGeneratorSystem_MainPhoto.png";
import HGVVarPhoto1 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGV Variable Hydraulic Generator System/PHOTOS/DYNASET_HGVVariableHydraulicGeneratorSystem_1.jpg";
import HGVVarPhoto2 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGV Variable Hydraulic Generator System/PHOTOS/DYNASET_HGVVariableHydraulicGeneratorSystem_2.jpg";
import HGVVarPhoto3 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGV Variable Hydraulic Generator System/PHOTOS/DYNASET_HGVVariableHydraulicGeneratorSystem_3.jpg";

// HWG Hydraulic Welding Generator
import HWGMain from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HWG Hydraulic Welding Generator/PHOTOS/DYNASET_HWGHydraulicWeldingGenerator_MainPhoto.png";
import HWGPhoto1 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HWG Hydraulic Welding Generator/PHOTOS/DYNASET_HWGHydraulicWeldingGenerator_1.jpg";
import HWGPhoto2 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HWG Hydraulic Welding Generator/PHOTOS/DYNASET_HWGHydraulicWeldingGenerator_2.jpg";
import HWGPhoto3 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HWG Hydraulic Welding Generator/PHOTOS/DYNASET_HWGHydraulicWeldingGenerator_4.jpg";
import HWGPhoto4 from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HWG Hydraulic Welding Generator/PHOTOS/DYNASET_HWGHydraulicWeldingGenerator_3.jpg";

// High Pressure Water
// FP Firefighting Piercing Kit
import FPPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/FP Firefighting Piercing Kit/PHOTOS/DYNASET_FPFirePiercingkit_1.jpg";
import FPPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/FP Firefighting Piercing Kit/PHOTOS/DYNASET_FPFirePiercingkit_2.jpg";
import FPPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/FP Firefighting Piercing Kit/PHOTOS/DYNASET_FPFirePiercingkit_3.jpg";
import FPPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/FP Firefighting Piercing Kit/PHOTOS/DYNASET_FPFirePiercingkit_4.jpg";
import FPPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/FP Firefighting Piercing Kit/PHOTOS/DYNASET_FPFirePiercingkit_5.jpg";

// HAC Hydraulic Abrasive Cutting System
import HACPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HAC Hydraulic Abrasive Cutting System/PHOTOS/DYNASET_HACHydraulicAbrasiveCuttingSystem_1.jpg";
import HACPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HAC Hydraulic Abrasive Cutting System/PHOTOS/DYNASET_HACHydraulicAbrasiveCuttingSystem_2.jpg";
import HACPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HAC Hydraulic Abrasive Cutting System/PHOTOS/DYNASET_HACHydraulicAbrasiveCuttingSystem_3.jpg";
import HACPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HAC Hydraulic Abrasive Cutting System/PHOTOS/DYNASET_HACHydraulicAbrasiveCuttingSystem_4.jpg";
import HACPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HAC Hydraulic Abrasive Cutting System/PHOTOS/DYNASET_HACHydraulicAbrasiveCuttingSystem_5.jpg";

// HDF Hydraulic Drilling Fluid Pump
import HDFPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HDF Hydraulic Drilling Fluid Pump/PHOTOS/DYNASET_HDF40_1.jpg";
import HDFPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HDF Hydraulic Drilling Fluid Pump/PHOTOS/DYNASET_HDF40_3.jpg";
import HDFPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HDF Hydraulic Drilling Fluid Pump/PHOTOS/DYNASET_HDF90_2.jpg";

// HPW Hydraulic High Pressure Water Pump
import HPWPPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic High Pressure Water Pump/PHOTOS/DYNASET_HPWHydraulicHighPressureWaterPump_1.jpg";
import HPWPPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic High Pressure Water Pump/PHOTOS/DYNASET_HPWHydraulicHighPressureWaterPump_2.jpg";
import HPWPPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic High Pressure Water Pump/PHOTOS/DYNASET_HPWHydraulicHighPressureWaterPump_3.png";
import HPWPPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic High Pressure Water Pump/PHOTOS/DYNASET_HPWHydraulicHighPressureWaterPump_4.jpg";
import HPWPPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic High Pressure Water Pump/PHOTOS/DYNASET_HPWHydraulicHighPressureWaterPump_5.jpg";

// HPW Hydraulic Power Washer
import HPWPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic Power Washer/PHOTOS/DYNASET_HPWHydraulicPowerWasher_1.jpg";
import HPWPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic Power Washer/PHOTOS/DYNASET_HPWHydraulicPowerWasher_2.jpg";
import HPWPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic Power Washer/PHOTOS/DYNASET_HPWHydraulicPowerWasher_3.png";
import HPWPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic Power Washer/PHOTOS/DYNASET_HPWHydraulicPowerWasher_4.jpg";
import HPWPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW Hydraulic Power Washer/PHOTOS/DYNASET_HPWHydraulicPowerWasher_5.jpg";

// HPW-DUST High Pressure Dust Suppression System
import HPWDustPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-DUST High Pressure Dust Suppression System/PHOTOS/DYNASET_HPWDustHighPressureDustSupressionSystem_1.jpg";
import HPWDustPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-DUST High Pressure Dust Suppression System/PHOTOS/DYNASET_HPWDustHighPressureDustSupressionSystem_2.jpg";
import HPWDustPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-DUST High Pressure Dust Suppression System/PHOTOS/DYNASET_HPWDustHighPressureDustSupressionSystem_3.jpg";
import HPWDustPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-DUST High Pressure Dust Suppression System/PHOTOS/DYNASET_HPWDustHighPressureDustSupressionSystem_4.jpg";
import HPWDustPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-DUST High Pressure Dust Suppression System/PHOTOS/DYNASET_HPWDustHighPressureDustSupressionSystem_5.jpg";

// HPW Fire High Pressure Water Pump
import HPWFPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-FIRE High Pressure Firefighting System/PHOTOS/DYNASET_HPWFireHighPressureFirefightingSystem_1.jpg";
import HPWFPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-FIRE High Pressure Firefighting System/PHOTOS/DYNASET_HPWFireHighPressureFirefightingSystem_2.jpg";
import HPWFPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-FIRE High Pressure Firefighting System/PHOTOS/DYNASET_HPWFireHighPressureFirefightingSystem_3.jpg";
import HPWFPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-FIRE High Pressure Firefighting System/PHOTOS/DYNASET_HPWFireHighPressureFirefightingSystem_4.jpg";
import HPWFPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HPW-FIRE High Pressure Firefighting System/PHOTOS/DYNASET_HPWFireHighPressureFirefightingSystem_5.jpg";

// HSP Hydraulic Submersible Pump
import HSPPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HSP Hydraulic Submersible Pump/PHOTOS/DYNASET_HSPHydraulicSubmersblePump_1.jpg";
import HSPPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HSP Hydraulic Submersible Pump/PHOTOS/DYNASET_HSPHydraulicSubmersblePump_2.jpg";
import HSPPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HSP Hydraulic Submersible Pump/PHOTOS/DYNASET_HSPHydraulicSubmersblePump_3.jpg";
import HSPPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HSP Hydraulic Submersible Pump/PHOTOS/DYNASET_HSPHydraulicSubmersblePump_4.jpg";
import HSPPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/HSP Hydraulic Submersible Pump/PHOTOS/DYNASET_HSPHydraulicSubmersblePump_5.jpg";

// JPL High Pressure Bin Washing System
import JPLPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/JPL High Pressure Bin Washing System/PHOTOS/DYNASET_JPLHighPressureBinWashingSystem_1.jpg";
import JPLPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/JPL High Pressure Bin Washing System/PHOTOS/DYNASET_JPLHighPressureBinWashingSystem_2.jpg";
import JPLPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/JPL High Pressure Bin Washing System/PHOTOS/DYNASET_JPLHighPressureBinWashingSystem_3.jpg";
import JPLPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/JPL High Pressure Bin Washing System/PHOTOS/DYNASET_JPLHighPressureBinWashingSystem_4.jpg";
import JPLPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/JPL High Pressure Bin Washing System/PHOTOS/DYNASET_JPLHighPressureBinWashingSystem_5.jpg";

// KPL Weed High Pressure Weedkiller Unit
import KPLWeedPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL -WEED Weedkiller Unit/PHOTOS/DYNASET_KPLWeedWeedkillerUnit_1.jpg";
import KPLWeedPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL -WEED Weedkiller Unit/PHOTOS/DYNASET_KPLWeedWeedkillerUnit_2.jpg";
import KPLWeedPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL -WEED Weedkiller Unit/PHOTOS/DYNASET_KPLWeedWeedkillerUnit_3.jpg";
import KPLWeedPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL -WEED Weedkiller Unit/PHOTOS/DYNASET_KPLWeedWeedkillerUnit_4.jpg";
import KPLWeedPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL -WEED Weedkiller Unit/PHOTOS/DYNASET_KPLWeedWeedkillerUnit_5.jpg";

// KPL High Pressure Street Washing Unit
import KPLStreetPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL High Pressure Street Washing Unit/PHOTOS/DYNASET_KPLHighPressureStreetWashingUnit_1.jpg";
import KPLStreetPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL High Pressure Street Washing Unit/PHOTOS/DYNASET_KPLHighPressureStreetWashingUnit_2.jpg";
import KPLStreetPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL High Pressure Street Washing Unit/PHOTOS/DYNASET_KPLHighPressureStreetWashingUnit_3.jpg";
import KPLStreetPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL High Pressure Street Washing Unit/PHOTOS/DYNASET_KPLHighPressureStreetWashingUnit_4.jpg";
import KPLStreetPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/KPL High Pressure Street Washing Unit/PHOTOS/DYNASET_KPLHighPressureStreetWashingUnit_5.jpg";

// PPL High Pressure Cleaning Unit
import PPLPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/PPL High Pressure Pipe Cleaning Unit/PHOTOS/DYNASET_PPLHighPressurePipeCleaningUnit_1.jpg";
import PPLPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/PPL High Pressure Pipe Cleaning Unit/PHOTOS/DYNASET_PPLHighPressurePipeCleaningUnit_2.jpg";
import PPLPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/PPL High Pressure Pipe Cleaning Unit/PHOTOS/DYNASET_PPLHighPressurePipeCleaningUnit_3.jpg";
import PPLPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/PPL High Pressure Pipe Cleaning Unit/PHOTOS/DYNASET_PPLHighPressurePipeCleaningUnit_4.jpg";
import PPLPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/PPL High Pressure Pipe Cleaning Unit/PHOTOS/DYNASET_PPLHighPressurePipeCleaningUnit_5.jpg";

// SCU High Pressure Sewer Cleaning Unit
import SCUPhoto1 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/SCU Surface Cleaning Unit/PHOTOS/DYNASET_SCUSurfaceCleaningUnit_1.jpg";
import SCUPhoto2 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/SCU Surface Cleaning Unit/PHOTOS/DYNASET_SCUSurfaceCleaningUnit_2.jpg";
import SCUPhoto3 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/SCU Surface Cleaning Unit/PHOTOS/DYNASET_SCUSurfaceCleaningUnit_3.jpg";
import SCUPhoto4 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/SCU Surface Cleaning Unit/PHOTOS/DYNASET_SCUSurfaceCleaningUnit_4.jpg";
import SCUPhoto5 from "../img/11. Hydraulics Generator/HIGH PRESSURE WATER/SCU Surface Cleaning Unit/PHOTOS/DYNASET_SCUSurfaceCleaningUnit_5.jpg";

// Zoo Technology
// 200 Export
import ZooPhoto1 from "../img/12. Zoo Technology/3. 200 EXPORT/PHOTOS/PERUZZO_200EXPORT_MainPhoto.png";
import ZooPhoto2 from "../img/12. Zoo Technology/3. 200 EXPORT/PHOTOS/PERUZZO_200EXPORT_1.jpg";
import ZooPhoto3 from "../img/12. Zoo Technology/3. 200 EXPORT/PHOTOS/PERUZZO_200EXPORT_2.jpg";
import ZooPhoto4 from "../img/12. Zoo Technology/3. 200 EXPORT/PHOTOS/PERUZZO_200EXPORT_3.jpg";
import ZooPhoto5 from "../img/12. Zoo Technology/3. 200 EXPORT/PHOTOS/PERUZZO_200EXPORT_4.jpg";
import Zoo200Catalog from "../img/12. Zoo Technology/3. 200 EXPORT/PHOTOS/PERUZZO_KATALOG_200EXPORT.pdf";

// 200 Universal
import Zoo200UniversalMain from "../img/12. Zoo Technology/4. 200 UNIVERSAL/PHOTOS/PERUZZO_200UNIVERSAL_MainPhoto.png";
import Zoo200UniversalPhoto1 from "../img/12. Zoo Technology/4. 200 UNIVERSAL/PHOTOS/PERUZZO_200UNIVERSAL_1.jpg";
import Zoo200UniversalPhoto2 from "../img/12. Zoo Technology/4. 200 UNIVERSAL/PHOTOS/PERUZZO_200UNIVERSAL_2.jpg";
import Zoo200UniversalCatalog from "../img/12. Zoo Technology/4. 200 UNIVERSAL/PHOTOS/PERUZZO_KATALOG_200UNIVERSAL  (1).pdf";

// 300 Universal
import Zoo300UniversalMain from "../img/12. Zoo Technology/5. 300 UNIVERSAL/PHOTOS/PERUZZO_300UNIVERSAL_MainPhoto.png";
import Zoo300UniversalPhoto1 from "../img/12. Zoo Technology/5. 300 UNIVERSAL/PHOTOS/PERUZZO_300UNIVERSAL_1.jpg";
import Zoo300UniversalPhoto2 from "../img/12. Zoo Technology/5. 300 UNIVERSAL/PHOTOS/PERUZZO_300UNIVERSAL_2.jpg";
import Zoo300UniversalPhoto3 from "../img/12. Zoo Technology/5. 300 UNIVERSAL/PHOTOS/PERUZZO_300UNIVERSAL_3.jpg";
import Zoo300UniversalPhoto4 from "../img/12. Zoo Technology/5. 300 UNIVERSAL/PHOTOS/PERUZZO_300UNIVERSAL_4.jpg";
import Zoo300UniversalCatalog from "../img/12. Zoo Technology/5. 300 UNIVERSAL/PHOTOS/PERUZZO_KATALOG_300UNIVERSAL (1).pdf";

// 500 Universal
import Zoo500UniversalMain from "../img/12. Zoo Technology/6. 500 UNIVERSAL/PHOTOS/PERUZZO_500UNIVERSAL_MainPhoto.png";
import Zoo500UniversalPhoto1 from "../img/12. Zoo Technology/6. 500 UNIVERSAL/PHOTOS/PERUZZO_500UNIVERSAL_1.jpg";
import Zoo500UniversalPhoto2 from "../img/12. Zoo Technology/6. 500 UNIVERSAL/PHOTOS/PERUZZO_500UNIVERSAL_2.jpg";
import Zoo500UniversalPhoto3 from "../img/12. Zoo Technology/6. 500 UNIVERSAL/PHOTOS/PERUZZO_500UNIVERSAL_3.jpg";
import Zoo500UniversalCatalog from "../img/12. Zoo Technology/6. 500 UNIVERSAL/PHOTOS/PERUZZO_KATALOG_500UNIVERSAL.pdf";

// 700 Universal
import Zoo700UniversalMain from "../img/12. Zoo Technology/7. 700 UNIVERSAL/PHOTOS/PERUZZO_700UNIVERSAL_MainPhoto.png";
import Zoo700UniversalPhoto1 from "../img/12. Zoo Technology/7. 700 UNIVERSAL/PHOTOS/PERUZZO_700UNIVERSAL_1.jpg";
import Zoo700UniversalPhoto2 from "../img/12. Zoo Technology/7. 700 UNIVERSAL/PHOTOS/PERUZZO_700UNIVERSAL_2.jpg";
import Zoo700UniversalPhoto3 from "../img/12. Zoo Technology/7. 700 UNIVERSAL/PHOTOS/PERUZZO_700UNIVERSAL_3.jpg";
import Zoo700UniversalPhoto4 from "../img/12. Zoo Technology/7. 700 UNIVERSAL/PHOTOS/PERUZZO_700UNIVERSAL_4.jpg";
import Zoo700UniversalCatalog from "../img/12. Zoo Technology/7. 700 UNIVERSAL/PHOTOS/PERUZZO_KATALOG_700UNIVERSAL.pdf";

// 1000 Universal
import Zoo1000UniversalMain from "../img/12. Zoo Technology/8. 1000 UNIVERSAL/PHOTOS/PERUZZO_1000UNIVERSAL_MainPhoto.png";
import Zoo1000UniversalPhoto1 from "../img/12. Zoo Technology/8. 1000 UNIVERSAL/PHOTOS/PERUZZO_1000UNIVERSAL_1.jpg";
import Zoo1000UniversalPhoto2 from "../img/12. Zoo Technology/8. 1000 UNIVERSAL/PHOTOS/PERUZZO_1000UNIVERSAL_2.jpg";
import Zoo1000UniversalPhoto3 from "../img/12. Zoo Technology/8. 1000 UNIVERSAL/PHOTOS/PERUZZO_1000UNIVERSAL_3.jpg";
import Zoo1000UniversalPhoto4 from "../img/12. Zoo Technology/8. 1000 UNIVERSAL/PHOTOS/PERUZZO_1000UNIVERSAL_4.jpg";
import Zoo1000UniversalCatalog from "../img/12. Zoo Technology/8. 1000 UNIVERSAL/PHOTOS/PERUZZO_KATALOG_1000UNIVERSAL.pdf";

// Biomass 1000
import Biomass1000Main from "../img/12. Zoo Technology/9. BIOMASS BIOGAS PLANTS UNIVERSAL 1000/PHOTOS/PERUZZO_1000UNIVERSAL_MainPhoto.png";
import Biomass1000Photo1 from "../img/12. Zoo Technology/9. BIOMASS BIOGAS PLANTS UNIVERSAL 1000/PHOTOS/PERUZZO_1000UNIVERSAL_1.jpg";
import Biomass1000Photo2 from "../img/12. Zoo Technology/9. BIOMASS BIOGAS PLANTS UNIVERSAL 1000/PHOTOS/PERUZZO_1000UNIVERSAL_2.jpg";
import Biomass1000Photo3 from "../img/12. Zoo Technology/9. BIOMASS BIOGAS PLANTS UNIVERSAL 1000/PHOTOS/PERUZZO_1000UNIVERSAL_3.jpg";
import Biomass1000Photo4 from "../img/12. Zoo Technology/9. BIOMASS BIOGAS PLANTS UNIVERSAL 1000/PHOTOS/PERUZZO_1000UNIVERSAL_4.jpg";
import Biomass1000Catalog from "../img/12. Zoo Technology/9. BIOMASS BIOGAS PLANTS UNIVERSAL 1000/PHOTOS/PERUZZO_KATALOG_1000UNIVERSAL.pdf";

// Comby
// Comby 85
import Comby85Main from "../img/12. Zoo Technology/10. COMBY 85/PHOTOS/PERUZZO_COMBY85_MainPhoto.png";
import Comby85Photo1 from "../img/12. Zoo Technology/10. COMBY 85/PHOTOS/PERUZZO_COMBY85_1.jpg";
import Comby85Photo2 from "../img/12. Zoo Technology/10. COMBY 85/PHOTOS/PERUZZO_COMBY85_2.jpg";
import Comby85Photo3 from "../img/12. Zoo Technology/10. COMBY 85/PHOTOS/PERUZZO_COMBY85_3.jpg";
import Comby85Photo4 from "../img/12. Zoo Technology/10. COMBY 85/PHOTOS/PERUZZO_COMBY85_4.jpg";
import Comby85Catalog from "../img/12. Zoo Technology/10. COMBY 85/PHOTOS/PERUZZO_KATALOG_COMBY85.pdf";

// Comby MCM
import CombyMCMMain from "../img/12. Zoo Technology/11. COMBY MCM/PHOTOS/PERUZZO_COMBYMCM_MainPhoto.png";
import CombyMCM1 from "../img/12. Zoo Technology/11. COMBY MCM/PHOTOS/PERUZZO_COMBYMCM_1.jpg";
import CombyMCM2 from "../img/12. Zoo Technology/11. COMBY MCM/PHOTOS/PERUZZO_COMBYMCM_2.jpg";
import CombyMCM3 from "../img/12. Zoo Technology/11. COMBY MCM/PHOTOS/PERUZZO_COMBYMCM_3.jpg";
import CombyMCMPDF from "../img/12. Zoo Technology/11. COMBY MCM/PHOTOS/PERUZZO_KATALOG_COMBY MCM.pdf";

// Comby Special
import CombySpecialMain from "../img/12. Zoo Technology/12. COMBY SPECIAL/PHOTOS/PERUZZO_COMBYSPECIAL_MainPhoto.png";
import CombySpecial1 from "../img/12. Zoo Technology/12. COMBY SPECIAL/PHOTOS/PERUZZO_COMBYSPECIAL_1.jpg";
import CombySpecial2 from "../img/12. Zoo Technology/12. COMBY SPECIAL/PHOTOS/PERUZZO_COMBYSPECIAL_2.jpg";
import CombySpecial3 from "../img/12. Zoo Technology/12. COMBY SPECIAL/PHOTOS/PERUZZO_COMBYSPECIAL_3.jpg";
import CombySpecial4 from "../img/12. Zoo Technology/12. COMBY SPECIAL/PHOTOS/PERUZZO_COMBYSPECIAL_4.jpg";
import CombySpecialPDF from "../img/12. Zoo Technology/12. COMBY SPECIAL/PHOTOS/PERUZZO_KATALOG_COMBYSPECIAL.pdf";

// Rised Flour Mixer
import RisedFlourMixerMain from "../img/12. Zoo Technology/13. RISED FLOUR MIXER/PHOTOS/PERUZZO_RISEDFLOURMIXER_MainPhoto.png";
import RisedFlourMixer1 from "../img/12. Zoo Technology/13. RISED FLOUR MIXER/PHOTOS/PERUZZO_RISEDFLOURMIXER_1.jpg";
import RisedFlourMixer2 from "../img/12. Zoo Technology/13. RISED FLOUR MIXER/PHOTOS/PERUZZO_RISEDFLOURMIXER_2.jpg";
import RisedFlourMixerPDF from "../img/12. Zoo Technology/13. RISED FLOUR MIXER/PHOTOS/PERUZZO_KATALOG_RISEDFLOURMIXER.pdf";

// Buried Flour Mixer
import BuriedFlourMixerMain from "../img/12. Zoo Technology/14. BURIED FLOUR MIXERS/PHOTO/PERUZZO_BURIEDFLOURMIXER_MainPhoto.png";
import BuriedFlourMixer1 from "../img/12. Zoo Technology/14. BURIED FLOUR MIXERS/PHOTO/PERUZZO_BURIEDFLOURMIXER_1.jpg";
import BuriedFlourMixer2 from "../img/12. Zoo Technology/14. BURIED FLOUR MIXERS/PHOTO/PERUZZO_BURIEDFLOURMIXER_2.jpg";
import BuriedFlourMixerPDF from "../img/12. Zoo Technology/14. BURIED FLOUR MIXERS/PHOTO/PERUZZO_KATALOG_BURIEDFLOURMIXER.pdf";

// Crush
import CrushMain from "../img/12. Zoo Technology/15. CRUSH/PHOTOS/PERUZZO_CRUSH_MainPhoto.png";
import Crush1 from "../img/12. Zoo Technology/15. CRUSH/PHOTOS/PERUZZO_CRUSH_1.jpg";
import Crush2 from "../img/12. Zoo Technology/15. CRUSH/PHOTOS/PERUZZO_CRUSH_2.jpg";
import Crush3 from "../img/12. Zoo Technology/15. CRUSH/PHOTOS/PERUZZO_CRUSH_3.jpg";
import Crush4 from "../img/12. Zoo Technology/15. CRUSH/PHOTOS/PERUZZO_CRUSH_4.jpg";
import CrushPDF from "../img/12. Zoo Technology/15. CRUSH/PHOTOS/PERUZZO_KATALOG_CRUSH.pdf";

// A-17 R-17
import A17R17Main from "../img/12. Zoo Technology/1. A-17 R-17/PHOTOS/PERUZZO_A17R17_MainPhoto.png";
import A17R171 from "../img/12. Zoo Technology/1. A-17 R-17/PHOTOS/PERUZZO_A17R17_1.jpg";
import A17R172 from "../img/12. Zoo Technology/1. A-17 R-17/PHOTOS/PERUZZO_A17R17_2.jpg";
import A17R173 from "../img/12. Zoo Technology/1. A-17 R-17/PHOTOS/PERUZZO_A17R17_3.jpg";
import A17R174 from "../img/12. Zoo Technology/1. A-17 R-17/PHOTOS/PERUZZO_A17R17_4.jpg";
import A17R17Catalog from "../img/12. Zoo Technology/1. A-17 R-17/PHOTOS/PERUZZO_TECHNICALDATA_A17R17.jpg";

// Peruzzo C-17
import C17Main from "../img/12. Zoo Technology/2. C-17/PHOTOS/PERUZZO__C17R17_MainPhoto.png";
import C171 from "../img/12. Zoo Technology/2. C-17/PHOTOS/PERUZZO_C17R17_1.jpg";
import C172 from "../img/12. Zoo Technology/2. C-17/PHOTOS/PERUZZO_C17R17_2.jpg";
import C173 from "../img/12. Zoo Technology/2. C-17/PHOTOS/PERUZZO_C17R17_3.jpg";
import C174 from "../img/12. Zoo Technology/2. C-17/PHOTOS/PERUZZO_C17R17_4.jpg";
import C17Catalog from "../img/12. Zoo Technology/2. C-17/PHOTOS/PERUZZO_KATALOG_C17R17   (1).pdf";

// PDF
// Loader Mounted Tree Spade
import DL42PDF from "../img/1TreeSpades/2LoaderMounted/42DL/BigJohn_42DL_PDF_FILE.pdf";
import DL52PDF from "../img/1TreeSpades/2LoaderMounted/52DL/BigJohn_52DL_PDF_FILE.pdf";
import DL62PDF from "../img/1TreeSpades/2LoaderMounted/62DL/BigJohn_62DL_PDF_FILE.pdf";
import DL90PDF from "../img/1TreeSpades/2LoaderMounted/90DL/BigJohn_90DL_PDF_FILE.pdf";
import DLLP90PDF from "../img/1TreeSpades/2LoaderMounted/90DLLP/BigJohn_90DLLP_PDF_FILE.pdf";
import DL100PDF from "../img/1TreeSpades/2LoaderMounted/100DL/BigJohn_100DL_PDF_FILE.pdf";

// Truck Mounted
import D45PDF from "../img/1TreeSpades/3TruckMounted/45D/BigJohn_45D_PDF_FILE.pdf";
import D55PDF from "../img/1TreeSpades/3TruckMounted/55D/BigJohn_55D_PDF_FILE.pdf";
import D65PDF from "../img/1TreeSpades/3TruckMounted/65D/BigJohn_65D_PDF_FILE.pdf";
import D80PDF from "../img/1TreeSpades/3TruckMounted/80D/BigJohn_80D_PDF_FILE.pdf";
import D90PDF from "../img/1TreeSpades/3TruckMounted/90D/BigJohn_90D_PDF_FILE.pdf";
import DAG90PDF from "../img/1TreeSpades/3TruckMounted/90DAG/BigJohn_90DAG_PDF_FILE.pdf";
import DLP90PDF from "../img/1TreeSpades/3TruckMounted/90DLP/BigJohn_90DLP_PDF_FILE.pdf";

// Skid Steer Mounted
import Model20PDF from "../img/1TreeSpades/4SkidSteerMounted/MODEL 20/BigJohn_MODEL20_PDF_FILE.pdf";
import Model28PDF from "../img/1TreeSpades/4SkidSteerMounted/MODEL 28/BigJohn_MODEL28_PDF_FILE.pdf";
import Model36PDF from "../img/1TreeSpades/4SkidSteerMounted/MODEL 36/BigJohn_MODEL36_PDF_FILE.pdf";
import Model40PDF from "../img/1TreeSpades/4SkidSteerMounted/MODEL 40/BigJohn_MODEL40_PDF_FILE.pdf";
import Model44PDF from "../img/1TreeSpades/4SkidSteerMounted/MODEL 44/BigJohn_MODEL44_PDF_FILE.pdf";
import Model48PDF from "../img/1TreeSpades/4SkidSteerMounted/MODEL 48/BigJohn_MODEL48_PDF_FILE.pdf";
import Model54PDF from "../img/1TreeSpades/4SkidSteerMounted/MODEL 54/BigJohn_MODEL54_PDF_FILE.pdf";

// Trailer Mounted
import DTG44PDF from "../img/1TreeSpades/5TrailerMounted/44DTG/BigJohn_44DTG_PDF_FILE.pdf";
import DTG54PDF from "../img/1TreeSpades/5TrailerMounted/54/BigJohn_54_PDF_FILE.pdf";
import DTD55PDF from "../img/1TreeSpades/5TrailerMounted/55DTD/BigJohn_55DTD_PDF_FILE.pdf";
import DTD65PDF from "../img/1TreeSpades/5TrailerMounted/65DTD/BigJohn_65DTD_PDF_FILE.pdf";

// Tree Spades Acc
import PT44PDF from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/44 Pod Trailer/BigJohn_44POD_PDF_FILE.pdf";
import PT55PDF from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/55 Pod Trailer/BigJohn_55POD_PDF_FILE.pdf";
import PT65PDF from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/65 Pod Trailer/BigJohn_65POD_PDF_FILE.pdf";
import PT90PDF from "../img/1TreeSpades/7TreeSpadesAcc/PodsTrailer/90 Pod Trailer/BigJohn_90POD_PDF_FILE.pdf";

// Beach Cleaning Machine
// Ride On Machines
import NemoPDF from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo/PFG_NEMO2WD_PDF_FILE.pdf";
import NemoTrackPDF from "../img/2. Beach Cleaning Machine/Ride On Machines/Nemo Track/PFG_NEMOTRACK_PDF_FILE.pdf";
import SqualoPDF from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo/PFG_SQUALO_PDF_FILE.pdf";
import Squalo20PDF from "../img/2. Beach Cleaning Machine/Ride On Machines/Squalo 2.0/squalo-20-inl.pdf";

// Tractor Towed Machines
import CaimanoPDF from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Caimano/PFG_CAIMANO_PDF_FILE.pdf";
import CerniaPDF from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Cernia/PFG_CERNIA_PDF_FILE.pdf";
import MantaPDF from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta/PFG_MANTA_PDF_FILE.pdf";
import MantaGoldPDF from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Manta Gold/PFG_MANTAGOLD_PDF_FILE.pdf";
import Model400SRPDF from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400 Surf Rake/Barber_SurfRake400_PDF_FILE.pdf";
import Model400SRHDPDF from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 400HD Surf Rake/Barber_SurfRake400HD_PDF_FILE.pdf";
import Model600SRPDF from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600HD Surf Rake/Barber_SurfRake600HD_PDF_FILE.pdf";
import Model600XLPDF from "../img/2. Beach Cleaning Machine/Tractor Towed Machines/Model 600XL Surf Rake/Barber_SurfRake600XL_PDF_FILE.pdf";

// Walk Behind Machines
import BarracudaPDF from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Barracuda/PFG_BARRACUDA_PDF_FILE.pdf";
import DolphinPDF from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin/PFG_DELFINO_PDF_FILE.pdf";
import DolphinElectricPDF from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Dolphin 2.0 Electric/PFG_DELFINO20_PDF_FILE.pdf";
import SandManPDF from "../img/2. Beach Cleaning Machine/Walk Behind Machines/Sand Man/MODEL 850/Barber_SandMan_PDF_FILE.pdf";

// Grass Collector Machines
import KoalaPDF from "../img/3. Grass Collector Machines/20. KOALA/PHOTOS/PERUZZO_KATALOG_KOALA.pdf";
import KoalaProfessionalPDF from "../img/3. Grass Collector Machines/21. KOALA PROFESSIONAL/PHOTOS/PERUZZO_KATALOG_KOALAPROFESSIONAL.pdf";
import PhanterPDF from "../img/3. Grass Collector Machines/22. PHANTER/PHOTOS/PERUZZO_KATALOG_PANTHER.pdf";
import PhanterMultifitPDF from "../img/3. Grass Collector Machines/23. PHANTER MULTIFIT/PHOTOS/PERUZZO_KATALOG_PANTHERMULTIFIT.pdf";
import PhanterProfessionalPDF from "../img/3. Grass Collector Machines/24. PHANTER PROFESSIONAL/PHOTOS/PERUZZO_KATALOG_PANTHERPROFESSIONAL.pdf";
import TigerPDF from "../img/3. Grass Collector Machines/25. TIGER/PHOTOS/PERUZZO_KATALOG_TIGER.pdf";
import CanguroNormalPDF from "../img/3. Grass Collector Machines/26. CANGURO NORMAL SUPER/PHOTOS/PERUZZO_KATALOG_CANGURONORMALSUPER.pdf";
import CanguroProfessionalPDF from "../img/3. Grass Collector Machines/27. CANGURO PROFESSIONAL SUPER/PHOTOS/PERUZZO_KATALOG_CANGUROPROFESSIONALSUPER.pdf";
import ElephantPDF from "../img/3. Grass Collector Machines/28. ELEPHANT SUPER/PHOTOS/PERUZZO_KATALOG_ELEPHANTSUPER.pdf";

// Grass Mower Machines
import MotofrogPDF from "../img/4. Grass Mower Machines/3. MOTOFROG 75/PHOTOS/PERUZZO_KATALOG_MOTOFROG75.pdf";
import FrogPDF from "../img/4. Grass Mower Machines/4. FROG/PHOTOS/PERUZZO_KATALOG_FROG.pdf";
import TegSpecialPDF from "../img/4. Grass Mower Machines/5. TEG SPECIAL - TEG SPECIAL HD/PHOTOS/PERUZZO_KATALOG_TEGSPECIALTEGSPECIALHD.pdf";
import ScorpionPDF from "../img/4. Grass Mower Machines/6. SCORPION/PHOTOS/PERUZZO_KATALOG_SCORPION.pdf";
import FoxPDF from "../img/4. Grass Mower Machines/7. FOX/PHOTOS/PERUZZO_KATALOG_FOX.pdf";
import FoxS4PDF from "../img/4. Grass Mower Machines/8. FOX-S/PHOTOS/PERUZZO_KATALOG_FOXS.pdf";
import MotoFoxPDF from "../img/4. Grass Mower Machines/9. MOTOFOX/PHOTOS/PERUZZO_KATALOG_MOTOFOX.pdf";
import PumaPDF from "../img/4. Grass Mower Machines/10. PUMA/PHOTOS/PERUZZO_KATALOG_PUMA.pdf";
import ElkPDF from "../img/4. Grass Mower Machines/11. ELK/PHOTOS/PERUZZO_KATALOG_ELK.pdf";
import TriflexPDF from "../img/4. Grass Mower Machines/12. TRIFLEX/PHOTOS/PERUZZO_KATALOG_TRIFLEX.pdf";
import FoxCrossPDF from "../img/4. Grass Mower Machines/13. FOX CROSS/PHOTOS/PERUZZO_KATALOG_FOXCROSS.pdf";
import ElkCrossPDF from "../img/4. Grass Mower Machines/14. ELK CROSS/PHOTOS/PERUZZO_KATALOG_ELKCROSS.pdf";
import ElkCrossFrontPDF from "../img/4. Grass Mower Machines/15. ELK CROSS FRONT/PHOTOS/PERUZZO_KATALOG_ELKCROSSFRONT.pdf";
import BullCrossPDF from "../img/4. Grass Mower Machines/16. BULL CROSS/PHOTOS/PERUZZO_KATALOG_BULLCROSS.pdf";
import BullSuperPDF from "../img/4. Grass Mower Machines/17. BULL SUPER/PHOTOS/PERUZZO_KATALOG_BULLSUPER.pdf";
import BullReversePDF from "../img/4. Grass Mower Machines/18. BULL REVERSE/PHOTOS/PERUZZO_KATALOG_BULLREVERSE.pdf";
import RotoPDF from "../img/4. Grass Mower Machines/19. ROTO/PHOTOS/PERUZZO_KATALOG_ROTO.pdf";

// Remote Controlled Grass Mower
import RobofoxElectricPDF from "../img/5. Remote Controlled Grass Mower/1. ROBOFOX ELECTRIC/PHOTOS/PERUZZO_ROBOFOX_KATALOG.pdf";
import RobofoxHybridPDF from "../img/5. Remote Controlled Grass Mower/2. ROBOFOX HYBRID/PHOTOS/PERUZZO_ROBOFOX_KATALOG.pdf";

const category = [
  {
    name: "Tree Spades",
    type: [
      // Excavator Mounted
      {
        name: "Excavator Mounted",
        description:
          "BIG JOHN is excited to announce the excavator mounted tree spades to our line up. We offer them in a model 65, 80, and 90. Depending on the model they are made to move trees from 15 cm to 30 cm in diameter and comes complete with electric valve bank an wireless remote control. Joining the BIG JOHN family means getting exceptional customer services for the life of your spade.",
        imgLink: ExcavatorMountedMain,
        variants: [
          {
            variantName: "65D",
            imgLink: ExcavatorMountedMain,
            downloadLink: ExcavatorMountedPDF,
            highlight: "Compact and Sturdy",
            descriptionMain:
              "BIG JOHN is excited to announce the excavator mounted tree spades to our line up. We offer them in a model 65, 80, and 90. Depending on the model they are made to move trees from 15 cm to 30 cm in diameter and comes complete with electric valve bank an wireless remote control. Joining the BIG JOHN family means getting exceptional customer services for the life of your spade.",
            photos: [
              ExcavatorMounted1,
              ExcavatorMounted2,
              ExcavatorMounted3,
              ExcavatorMounted4,
              ExcavatorMounted5,
              ExcavatorMounted6,
              ExcavatorMounted7,
              ExcavatorMounted8,
              ExcavatorMounted9,
              ExcavatorMounted10,
              ExcavatorMounted11
            ],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "15 – 30 cm"
              },
              {
                parameter: "Root Ball Width",
                value: "157 – 229 cm"
              },
              {
                parameter: "Root Ball Depth",
                value: "135 – 152 cm"
              },
              {
                parameter: "Root Ball Weight",
                value: "1.950 – 5.350 kg"
              },
              {
                parameter: "Machine Weight",
                value: "2.630 – 4.760 kg"
              },
              {
                parameter: "Blade Tower Height",
                value: "217 – 267 cm"
              },
              {
                parameter: "Gate Opening",
                value: "102 – 183 cm"
              },
              {
                parameter: "Opening Width",
                value: "234 – 251 cm"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Blade Material",
                value: "AR550"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "20"
              }
            ]
          }
        ]
      },
      // Loader Mounted Tree Spade
      {
        name: "Loader Mounted Tree Spade",
        description:
          "With our loader-mounted tree spades, you can elevate your tree-moving projects, ensuring they are not only successful but also marked by efficiency and ease. Explore our range of loader-mounted tree spades and discover the perfect synergy between robust performance and precise handling.",
        imgLink: LoaderMountedMain,
        variants: [
          {
            variantName: "42DL",
            imgLink: DL42Main,
            downloadLink: DL42PDF,
            highlight: "Move Smaller Trees in Tough Conditions",
            descriptionMain:
              "Move Smaller Trees in Tough Conditions Whatever your task, if you have 4” and smaller trees that need to be dug in any conditions, this is the machine for you.The 42DL Loader Mounted Tree Spade gives you the full capabilities of a robust BIG JOHN tree spade made for digging in unprepared soils in a flexible size. Designed to fit on large skid steers and smaller loaders, the 42DL features the robust blade design of our larger tree spades.The Model 42DL comes standard with an electric valve bank and wireless remote as well as additional specifications listed below.",
            photos: [DL421, DL422, DL423, DL424],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "1 - 10 CM"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "106 CM"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "96 CM"
              },
              {
                parameter: "Root Ball Weight",
                value: "680 KG"
              },
              {
                parameter: "Total Machine Weight",
                value: "1360 KG"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "152 CM"
              },
              {
                parameter: "Gate Opening",
                value: "63 CM"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "162 CM"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Hydraulic Pads",
                value: "No"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "No"
              },
              {
                parameter: "Spade Material",
                value: "AR500"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "10 – 16 GPM / 37 - 60 LPM"
              }
            ]
          },
          {
            variantName: "52DL",
            imgLink: DL52Main,
            downloadLink: DL52PDF,
            highlight: "Dig in Tough Conditions",
            descriptionMain:
              "Dig in Tough Conditions. Whatever your task, if you have 6” and smaller trees that need to be dug in tough conditions, this is the tree spade for you. Blank attaching plates to mate the BIG JOHN transplanter to the host vehicle come with the purchase of your tree spade. Some in-field fabrication will be necessary to couple the tree spade to your specific wheel loader.The Model 52DL Loader Mounted Tree Spade comes standard with an electric valve bank and wireless remote.",
            photos: [DL521, DL522, DL523, DL524],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "10 - 15 CM"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "132 CM"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "121 CM"
              },
              {
                parameter: "Root Ball Weight",
                value: "1632 KG"
              },
              {
                parameter: "Total Machine Weight",
                value: "2267 KG"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "203 CM"
              },
              {
                parameter: "Gate Opening",
                value: "76 CM"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "226 CM"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Hydraulic Pads",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR5500"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "20 GPM / 75 LPM"
              }
            ]
          },
          {
            variantName: "62DL",
            imgLink: DL62Main,
            downloadLink: DL62PDF,
            highlight: "Versatility in a Manageable Size",
            descriptionMain:
              "Designed to handle digging and landscaping jobs in unprepared soil, BIG JOHN's Model 62DL loader-mounted spade is made to withstand tough conditions. Made with a loader attachment, this spade brings the robust features of our truck-mounted tree spades to a loader attachment. Blank attaching plates to mate the BIG JOHN transplanter to the host vehicle come with the purchase of your tree spade. Some in-field fabrication will be necessary to couple the BIG JOHN to your specific wheel loader.",
            photos: [DL621, DL622, DL623, DL624],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "15 - 18 CM"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "157 CM"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "134 CM"
              },
              {
                parameter: "Root Ball Weight",
                value: "1950 KG"
              },
              {
                parameter: "Total Machine Weight",
                value: "2630 KG"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "246 CM"
              },
              {
                parameter: "Gate Opening",
                value: "100 CM"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "233 CM"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Hydraulic Pads",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR5500"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "20 GPM / 75 LPM"
              }
            ]
          },
          {
            variantName: "80DL",
            imgLink: DL80Main,
            downloadLink: "",
            highlight: "Our most popular Loader Mounted Tree Spade",
            descriptionMain:
              "Our most popular size of loader-mounted tree spade, the 80DL offers rugged versatility for trees up to 10″ in diameter in unprepared soils. Popular in sandy soil conditions, the 80DL allows you to run a spade with the same durable standard as a truck spade from a loader mount! Blank attaching plates to mate the BIG JOHN transplanter to the host vehicle come with the purchase of your tree spade. Some in-field fabrication will be necessary to couple the BIG JOHN to your specific wheel loader.",
            photos: [DL801, DL802, DL803, DL804],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "20 - 25 CM"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "203 CM"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "137 CM"
              },
              {
                parameter: "Root Ball Weight",
                value: "3855 KG"
              },
              {
                parameter: "Total Machine Weight",
                value: "4300 KG"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "251 CM"
              },
              {
                parameter: "Gate Opening",
                value: "182 CM"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "246 CM"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Hydraulic Pads",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR5500"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "20 GPM / 75 LPM"
              }
            ]
          },
          {
            variantName: "90DL",
            imgLink: DL90Main,
            downloadLink: DL90PDF,
            highlight:
              "Robust Loader Mounted Tree Spade for 12” Diameter Trees",
            descriptionMain:
              "The BIG JOHN Model 90DL is a loader mounted version of our most popular model for large tree movers that moves up to a 12” caliper tree. It is a durable, fully contained, one-operator system built to perform in the most rigorous tree moving conditions. Move up to 12” diameter trees in unprepared soil with the durability of a BIG JOHN tree spade on a go-anywhere loader. The low-profile design allows for easier storage and access to tight spaces.",
            photos: [DL901, DL902, DL903, DL904],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "25 - 30 CM"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "228 CM"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "152 CM"
              },
              {
                parameter: "Root Ball Weight",
                value: "5352 KG"
              },
              {
                parameter: "Total Machine Weight",
                value: "4762 KG"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "264 CM"
              },
              {
                parameter: "Gate Opening",
                value: "182 CM"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "251 CM"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Hydraulic Pads",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR5500"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "20 GPM / 75 LPM"
              }
            ]
          },
          {
            variantName: "90DLLP",
            imgLink: DLLP90Main,
            downloadLink: DLLP90PDF,
            highlight: "Popular for Large Tree Movers",
            descriptionMain:
              "The BIG JOHN Model 90DLLP is a low-profile version of our most popular model for large tree movers that moves up to a 12” caliper tree. It is a durable, fully contained, one-operator system built to perform in the most rigorous tree-moving conditions. The low-profile design allows for easier storage and access to tight spaces. Best for unprepared soils, the 90DLLP is deal for sandy conditions and landscaping needs. The Model 90DLLP comes standard with a 400-gallon water tank and 45-gallon oil reservoir. This model operates at 3000 psi of hydraulic pressure at 20gpm of flow.",
            photos: [DLLP901, DLLP902, DLLP903, DLLP904],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "25 - 30 CM"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "228 CM"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "152 CM"
              },
              {
                parameter: "Root Ball Weight",
                value: "5352 KG"
              },
              {
                parameter: "Total Machine Weight",
                value: "4762 KG"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "264 CM"
              },
              {
                parameter: "Gate Opening",
                value: "182 CM"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "251 CM"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Hydraulic Pads",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR5500"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "20 GPM / 75 LPM"
              }
            ]
          },
          {
            variantName: "100DL",
            imgLink: DL100Main,
            downloadLink: DL100PDF,
            highlight: "Our Largest Loader Mounted Tree Spade",
            descriptionMain:
              "The Model 100DL Loader Mount is the largest and most durable production digger available anywhere. Made to move trees up to 14” in diameter and a rootball of 100” in diameter in rugged conditions! The 100DL Loader Mounted Tree Spade comes standard with an electric valve bank, wireless remote, and blank attaching plate to mount to your host vehicle.",
            photos: [DL1001, DL1002, DL1003, DL1004],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "30 - 35 CM"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "254 CM"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "172 CM"
              },
              {
                parameter: "Root Ball Weight",
                value: "6800 KG"
              },
              {
                parameter: "Total Machine Weight",
                value: "5443 KG"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "279 CM"
              },
              {
                parameter: "Gate Opening",
                value: "185 CM"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "261 CM"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Hydraulic Pads",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR55q 00"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "20 GPM / 75 LPM"
              }
            ]
          }
        ]
      },
      // Truck Mounted
      {
        name: "Truck Mounted",
        description:
          "Efficiency and reliability are priorities in tree farming and forestry. After all, one wrong move or delay can mean losing a tree and sometimes risking its entire life cycle. That’s where our truck-mounted tree spades come into play. Big John Manufacturing understands these challenges and offers a solution that fits your needs perfectly. Our truck-mounted spades are meticulously designed with over 40 years of industry expertise, delivering solid performance tailored to your operations. Explore what we have to offer! Transform Your Operations with Truck Mounted Spades Enhance your tree transplanting efficiency with our truck-mounted spade options. Each model is equipped with features that streamline the process, including: Stabilizing Pads Large Water Tank & Hose Attachment Internal Leveling Pads Heavy Duty Gate Hinges Heavy Duty Blade Edges Easy to Use and Maintain Durable Slide Blocks Climbable Towers ",
        imgLink: TruckMountedMain,
        variants: [
          {
            variantName: "45D",
            imgLink: D45Main,
            downloadLink: D45PDF,
            highlight: "Compact and Sturdy",
            descriptionMain:
              "The BIG JOHN Model 45D truck-mounted tree spade is used by nurseries, landscapers, and tree-moving professionals. The 45D gets the job done. Whether you’re B&B’ing or what we call “Dig & Delivering”, the appeal of the M45D is in its compact yet sturdy design and perfect for moving 7,5 - 10 cm caliper trees. The Model 45D comes standard with a 473 litres water tank and 94 litres hydraulic oil reservoir.",
            photos: [D451, D452, D453, D454],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "7,5 - 10 CM"
              },
              {
                parameter: "Weight of Transplanter",
                value: "2630 KG"
              },
              {
                parameter: "Height Closed (for Transportation, approx.)",
                value: "341 CM"
              },
              {
                parameter: "Width Closed (for Transportation, approx.)",
                value: "143 CM"
              },
              {
                parameter: "Nominal Root Ball Width (Adjustable)",
                value: "106 CM"
              },
              {
                parameter: "Root Ball Depth (approx.)",
                value: "96 CM"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "680 KG"
              },
              {
                parameter: "Hydraulic Pressure Relief (Preset)",
                value: "2,500 PSI"
              },
              {
                parameter: "Hydraulic GPM Rating (Gallons Per Minute)",
                value: "12 – 15 GPM / 45 - 56 LPM"
              },
              {
                parameter: "Single Axle Truck Length",
                value: "213 CM"
              },
              {
                parameter: "Minimum HP",
                value: "250"
              }
            ]
          },
          {
            variantName: "55D",
            imgLink: D55Main,
            downloadLink: D55PDF,
            highlight: "12,5 – 15 CM Trees",
            descriptionMain:
              "The Model 55D is built with all the rugged characteristics of the larger spades and works great on class 7 single-axle trucks. You can move 12,5 – 15 cm caliper trees on a truck that is highly maneuverable and able to get into those tight places. Also, you can operate the smaller chassis without a CDL. The Model 55D comes standard with a 1514 L water tank and 170 L oil reservoir. This model operates at 3000psi of hydraulic pressure at 75 LPM of flow.",
            photos: [D551, D552, D553, D554],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "12,5 - 15 CM"
              },
              {
                parameter: "Weight of Transplanter",
                value: "5560 KG"
              },
              {
                parameter: "Height Closed (for Transportation, approx.)",
                value: "338 CM"
              },
              {
                parameter: "Width Closed (for Transportation, approx.)",
                value: "259 CM"
              },
              {
                parameter: "Nominal Root Ball Width (Adjustable)",
                value: "132 CM"
              },
              {
                parameter: "Root Ball Depth (approx.)",
                value: "121 CM"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "1632 KG"
              },
              {
                parameter: "Hydraulic Pressure Relief (Preset)",
                value: "3,000 PSI"
              },
              {
                parameter: "Hydraulic GPM Rating (Gallons Per Minute)",
                value: "20 – 22 GPM / 75 - 83 LPM"
              },
              {
                parameter: "Tandem Axle Truck Length",
                value: "304 CM"
              }
            ]
          },
          {
            variantName: "65D",
            imgLink: D65Main,
            downloadLink: D65PDF,
            highlight: "15 – 17,5 CM Trees",
            descriptionMain:
              "One of our most requested and most versatile-sized transplanters, the Model 65, is capable of moving up to 17,5 cm caliper trees and is durable and operator friendly. Built to withstand rigorous tree moving conditions; from B & B operations to on-site, high-volume jobs; the Model 65 could be the perfect machine for your application. The Model 65D comes standard with a 1514 L water tank and 170 L oil reservoir. This model operates at 3000psi of hydraulic pressure at 75 LPM of flow.",
            photos: [D651, D652, D653, D654],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "15 - 17,5 CM"
              },
              {
                parameter: "Weight of Transplanter",
                value: "5787 KG"
              },
              {
                parameter: "Height Closed (for Transportation, approx.)",
                value: "371 CM"
              },
              {
                parameter: "Width Closed (for Transportation, approx.)",
                value: "259 CM"
              },
              {
                parameter: "Nominal Root Ball Width (Adjustable)",
                value: "157 CM"
              },
              {
                parameter: "Root Ball Depth (approx.)",
                value: "134 CM"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "1950 KG"
              },
              {
                parameter: "Hydraulic Pressure Relief (Preset)",
                value: "3,000 PSI"
              },
              {
                parameter: "Hydraulic GPM Rating (Gallons Per Minute)",
                value: "20 – 22 GPM / 75 - 83 LPM"
              },
              {
                parameter: "Tandem Axle Truck Length",
                value: "304 CM"
              }
            ]
          },
          {
            variantName: "80D",
            imgLink: D80Main,
            downloadLink: D80PDF,
            highlight: "Up to 25 CM Trees",
            descriptionMain:
              "BIG JOHN has been building the Model 80 since 1983. It’s the original large tree transplanter. It is a fully contained, one-operator system that is built to perform and is the machine of choice for some of our most loyal, long-term customers. The tree spade truck is built to tackle big jobs with ease. The Model 80D comes standard with a 1514 L water tank and 170 L oil reservoir. This model operates at 3000psi of hydraulic pressure at 20gpm of flow. Made with AR550 standard spade material and can handle tree trunks up to 25 cm in diameter.",
            photos: [D801, D802, D803, D804],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "Up to 25 CM"
              },
              {
                parameter: "Weight of Transplanter",
                value: "7148 KG"
              },
              {
                parameter: "Height Closed (for Transportation, approx.)",
                value: "414 CM"
              },
              {
                parameter: "Width Closed (for Transportation, approx.)",
                value: "259 CM"
              },
              {
                parameter: "Nominal Root Ball Width (Adjustable)",
                value: "203 CM"
              },
              {
                parameter: "Root Ball Depth (approx.)",
                value: "137 CM"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "3855 KG"
              },
              {
                parameter: "Hydraulic Pressure Relief (Preset)",
                value: "3,000 PSI"
              },
              {
                parameter: "Hydraulic GPM Rating (Gallons Per Minute)",
                value: "20 – 22 GPM / 75 - 83 LPM"
              },
              {
                parameter: "Tandem Axle Truck Length",
                value: "396 – 472 CM"
              }
            ]
          },
          {
            variantName: "90D",
            imgLink: D90Main,
            downloadLink: D90PDF,
            highlight: "25 – 30 CM Trees",
            descriptionMain:
              "The BIG JOHN Model 90 sets the standard for large truck mounted tree spades and is the most popular model for large tree movers wanting to move up to a 30 cm caliper tree. It is a durable, fully contained, one-operator system built to perform in the most rigorous tree-moving conditions. It can handle trees up to 30 cm in diameter and has a 170 L oil reservoir. Made in America of highly durable cold-formed steel, our dual contoured blades stand up to tough, rocky, and sandy soils for on-site moves without prepare ground. Each 90 inch tree spade is mounted to the truck of your choice, with additional specifications below.",
            photos: [D901, D902, D903, D904],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "25 – 30 CM"
              },
              {
                parameter: "Weight of Transplanter",
                value: "7602 KG"
              },
              {
                parameter: "Height Closed (for Transportation, approx.)",
                value: "414 CM"
              },
              {
                parameter: "Width Closed (for Transportation, approx.)",
                value: "259 CM"
              },
              {
                parameter: "Nominal Root Ball Width (Adjustable)",
                value: "228 CM"
              },
              {
                parameter: "Root Ball Depth (approx.)",
                value: "152 CM"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "5352 KG"
              },
              {
                parameter: "Hydraulic Pressure Relief (Preset)",
                value: "3,000 PSI"
              },
              {
                parameter: "Hydraulic GPM Rating (Gallons Per Minute)",
                value: "20 – 22 GPM / 75 - 83 LPM"
              },
              {
                parameter: "Tandem Axle Truck Length",
                value: "396 – 472 CM"
              }
            ]
          },
          {
            variantName: "90DAG",
            imgLink: DAG90Main,
            downloadLink: DAG90PDF,
            highlight: "25 – 30 CM Trees",
            descriptionMain:
              "Like the traditional 90D, the BIG JOHN 90-inch pecan tree spade for the pecan industry is made in America of highly durable, cold-formed steel with dual contoured blades. Used in loamy soils pecan trees love across the United States, our pecan tree spades are used by some of the largest pecan nurseries and producers in the country. Each 90 inch pecan tree spade is mounted to the truck of your choice, with additional specifications below.",
            photos: [DAG901, DAG902, DAG903, DAG904],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "25 – 30 CM"
              },
              {
                parameter: "Weight of Transplanter",
                value: "8055 KG"
              },
              {
                parameter: "Height Closed (for Transportation, approx.)",
                value: "414 CM"
              },
              {
                parameter: "Width Closed (for Transportation, approx.)",
                value: "259 CM"
              },
              {
                parameter: "Nominal Root Ball Width (Adjustable)",
                value: "228 CM"
              },
              {
                parameter: "Root Ball Depth (approx.)",
                value: "152 CM"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "5352 KG"
              },
              {
                parameter: "Hydraulic Pressure Relief (Preset)",
                value: "3,000 PSI"
              },
              {
                parameter: "Hydraulic GPM Rating (Gallons Per Minute)",
                value: "20 – 22 GPM / 75 - 83 LPM"
              },
              {
                parameter: "Tandem Axle Truck Length",
                value: "396 – 472 CM"
              }
            ]
          },
          {
            variantName: "90DLP",
            imgLink: DLP90Main,
            downloadLink: DLP90PDF,
            highlight: "Up to 12” Tree Diameter",
            descriptionMain:
              "The BIG JOHN Model 90DLP is a low-profile version of our most popular model for large tree movers that moves up to a 12” cliper tree. It is durable, fully contained, one-operator system built to perform in the most rigorous tree moving conditions. The low-profile design allows for easier storage and access to tight spaces.",
            photos: [DLP901, DLP902, DLP903, DLP904],
            specifications: []
          },
          {
            variantName: "100D",
            imgLink: D100Main,
            downloadLink: "",
            highlight: "30 – 35 CM Trees",
            descriptionMain:
              "Built and designed for the professional tree moving company looking to provide fully mature tree moving and transplanting services, operators love the BIG JOHN 100” truck-mounted tree spade for tackling their largest tree moving jobs. Because of the extra-large size, trees can be moved any time of year with high survivability rates. Designed and built for the professional mover. The biggest and best production tree spade available anywhere at any price. Move larger trees; move throughout the “off season“. Whatever your needs, the Model 100 can do the job.",
            photos: [D1001, D1002, D1003, D1004],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "30 – 35 CM"
              },
              {
                parameter: "Weight of Transplanter",
                value: "9525 KG"
              },
              {
                parameter: "Height Closed (for Transportation, approx.)",
                value: "414 CM"
              },
              {
                parameter: "Width Closed (for Transportation, approx.)",
                value: "259 CM"
              },
              {
                parameter: "Nominal Root Ball Width (Adjustable)",
                value: "254 CM"
              },
              {
                parameter: "Root Ball Depth (approx.)",
                value: "172 CM"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "6800 – 8164 KG"
              },
              {
                parameter: "Hydraulic Pressure Relief (Preset)",
                value: "3,500 PSI"
              },
              {
                parameter: "Hydraulic GPM Rating (Gallons Per Minute)",
                value: "20 – 22 GPM / 75 - 83 LPM"
              }
            ]
          }
        ]
      },
      // Skid Steer Mounted
      {
        name: "Skid Steer Mounted",
        description:
          "Models ranging from 20” to 60” in nursery diggers offer a wide array of configurations to suit diverse requirements. These configurations include 22° (truncated), 25° (semi-truncated), and 30° (pointed) spade angles, each tailored to specific digging conditions and tree types. Whether you’re working on-site, navigating rugged terrain in the wild, or transplanting trees with or without baskets, we have the expertise to fabricate the perfect spade for your needs. Our team is dedicated to understanding your unique requirements and crafting a solution that optimizes efficiency and precision in your tree-moving process. Discover the ultimate in versatility and efficiency with Big John’s skid steer tree spade attachments. Our attachments are designed to integrate seamlessly with your skid steer loaders, providing enhanced performance for your tree transplanting needs.",
        imgLink: SkidMountedMain,
        variants: [
          {
            variantName: "Model 20",
            imgLink: Model20,
            downloadLink: Model20PDF,
            highlight: "1 – 5 CM Trees",
            descriptionMain:
              "Built and designed for the professional tree moving company looking to provide fully mature tree moving and transplanting services, operators love the BIG JOHN 100” truck-mounted tree spade for tackling their largest tree moving jobs. Because of the extra-large size, trees can be moved any time of year with high survivability rates. Designed and built for the professional mover. The biggest and best production tree spade available anywhere at any price. Move larger trees; move throughout the “off season“. Whatever your needs, the Model 100 can do the job.",
            photos: [Model201],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "30 – 35 CM"
              },
              {
                parameter: "Weight of Transplanter",
                value: "9525 KG"
              },
              {
                parameter: "Height Closed (for Transportation, approx.)",
                value: "414 CM"
              },
              {
                parameter: "Width Closed (for Transportation, approx.)",
                value: "259 CM"
              },
              {
                parameter: "Nominal Root Ball Width (Adjustable)",
                value: "254 CM"
              },
              {
                parameter: "Root Ball Depth (approx.)",
                value: "172 CM"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "6800 – 8164 KG"
              },
              {
                parameter: "Hydraulic Pressure Relief (Preset)",
                value: "3,500 PSI"
              },
              {
                parameter: "Hydraulic GPM Rating (Gallons Per Minute)",
                value: "20 – 22 GPM / 75 - 83 LPM"
              }
            ]
          },
          {
            variantName: "Model 28",
            imgLink: Model28,
            downloadLink: Model28PDF,
            highlight: "1 – 7,5 cm Trees",
            descriptionMain:
              "The Model 28 BIG JOHN nursery digger is light weight and hosts cold formed straight blades. It’s made to move trees 1” to 3” in diameter and comes complete with electric valve bank and wireless remote control. Joining the BIG JOHN family means getting exceptional customer service for the life of your spade as well as customized options suited to your nursery needs. We offer wireless remote or cable controls to make operating your spade easier and faster for different conditions. Available in pointed, semi-truncated, or truncated blades.",
            photos: [Model281, Model282, Model283, Model284],
            specifications: [
              {
                parameter: "Inside Frame",
                value: "1 – 7,5 cm"
              },
              {
                parameter: "Outside Frame",
                value: "1 – 7,5 cm"
              },
              {
                parameter: "Tree Trunk Diameter",
                value: "1 – 7,5 cm"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "70 cm"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "55 cm"
              },
              {
                parameter: "Root Ball Weight",
                value: "135 kg"
              },
              {
                parameter: "Total Machine Weight",
                value: "680 kg"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "115 cm"
              },
              {
                parameter: "Gate Opening",
                value: "38 cm"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "162 cm"
              },
              {
                parameter: "Number of Spades",
                value: "3"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR400"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "10 – 16 GPM / 37 – 60 LPM"
              }
            ]
          },
          {
            variantName: "Model 36",
            imgLink: Model36Main,
            downloadLink: Model36PDF,
            highlight: "1 – 7,5 cm Trees",
            descriptionMain:
              "The Model 36 BIG JOHN nursery digger is light weight and hosts cold formed straight blades. It’s made to move trees 1” to 3” in diameter and comes complete with electric valve bank and wireless remote control. Joining the BIG JOHN family means getting exceptional customer service for the life of your spade as well as customized options suited to your nursery needs. We offer wireless remote or cable controls to make operating your spade easier and faster for different conditions. Available in pointed, semi-truncated, or truncated blades.",
            photos: [Model36, Model361, Model362, Model363],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "1 – 7,5 cm"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "91 cm"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "75 cm"
              },
              {
                parameter: "Root Ball Weight",
                value: "360 kg"
              },
              {
                parameter: "Total Machine Weight",
                value: "860 kg"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "144 cm"
              },
              {
                parameter: "Gate Opening",
                value: "33 cm"
              },
              {
                parameter: "Opening Width",
                value: "280 cm"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "No"
              },
              {
                parameter: "Spade Material",
                value: "AR400"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "10 – 16 GPM / 37 – 60 LPM"
              }
            ]
          },
          {
            variantName: "Model 40",
            imgLink: Model40Main,
            downloadLink: Model40PDF,
            highlight: "1 – 10 cm Trees",
            descriptionMain:
              "The Model 40 skid steer tree spade moves trees 1” to 4” in diameter and is designed for prepared ground nursery digging that fits a myriad of skid steer loaders; comes complete with electric valve bank and wireless remote control. Joining the BIG JOHN family means getting exceptional customer service for the life of your spade as well as customized options suited to your nursery needs. We offer wireless remote or control cables to make operating your spade easier and faster for different conditions.",
            photos: [Model401, Model402, Model403, Model40],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "1 – 10 cm"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "100 cm"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "80 cm"
              },
              {
                parameter: "Root Ball Weight",
                value: "450 kg"
              },
              {
                parameter: "Total Machine Weight",
                value: "1050 kg"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "187 cm"
              },
              {
                parameter: "Gate Opening",
                value: "58 cm"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "315 cm"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR400"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "10 – 16 GPM / 37 – 60 LPM"
              }
            ]
          },
          {
            variantName: "Model 44",
            imgLink: Model44Main,
            downloadLink: Model44PDF,
            highlight: "1 – 10 cm Trees",
            descriptionMain:
              'The Model 44 BIG JOHN nursery digger is lightweight and hosts cold-formed straight blades. This digger can handle trees up to 4" in diameter and comes with a hydraulic gate lock and standard wireless remote. We also offer truncated and semi-truncated versions of our Model 44.',
            photos: [Model441, Model442, Model443, Model444, Model445],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "1 – 10 cm"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "110 cm"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "90 cm"
              },
              {
                parameter: "Root Ball Weight",
                value: "544 kg"
              },
              {
                parameter: "Total Machine Weight",
                value: "900 kg"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "210 cm"
              },
              {
                parameter: "Gate Opening",
                value: "60 cm"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "243 cm"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR400"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "10 – 16 GPM / 37 – 60 LPM"
              }
            ]
          },
          {
            variantName: "Model 48",
            imgLink: Model48Main,
            downloadLink: Model48PDF,
            highlight: "1 – 12,5 cm Trees",
            descriptionMain:
              "The Model 48 skid steer tree spade moves trees 1” to 5” in diameter and is designed for prepared ground nursery digging that fits a myriad of skid steer loaders; comes complete with electric valve bank and wireless remote control.",
            photos: [Model481, Model482, Model48],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "1 – 12,5 cm"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "120 cm"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "99 cm"
              },
              {
                parameter: "Root Ball Weight",
                value: "798 kg"
              },
              {
                parameter: "Total Machine Weight",
                value: "1220 kg"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "215 cm"
              },
              {
                parameter: "Gate Opening",
                value: "66 cm"
              },
              {
                parameter: "Operating Width (Closed)",
                value: "410 cm"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR400"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "10 – 16 GPM / 37 – 60 LPM"
              }
            ]
          },
          {
            variantName: "Model 54",
            imgLink: Model54Main,
            downloadLink: Model54PDF,
            highlight: "1 – 12,5 cm Trees",
            descriptionMain:
              'The Model 54 BIG JOHN nursery digger is light weight and hosts cold formed straight blades, which are 30 degrees truncated. This digger can move trees that are 1" to 5" in diameter and fits a myriad of skid steer loaders.',
            photos: [Model541, Model542, Model543, Model544, Model54],
            specifications: [
              {
                parameter: "Tree Trunk Diameter",
                value: "1 – 12,5 cm"
              },
              {
                parameter: "Root Ball Width (Adjustable)",
                value: "137 cm"
              },
              {
                parameter: "Root Ball Depth (Adjustable)",
                value: "105 cm"
              },
              {
                parameter: "Root Ball Weight",
                value: "1085 kg"
              },
              {
                parameter: "Total Machine Weight",
                value: "1360 kg"
              },
              {
                parameter: "Blade Tower Height",
                value: "245 cm"
              },
              {
                parameter: "Gate Opening",
                value: "88 cm"
              },
              {
                parameter: "Operating Width",
                value: "422 cm"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR400"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "10 – 16 GPM / 37 – 60 LPM"
              }
            ]
          }
        ]
      },
      // Trailer Mounted
      {
        name: "Trailer Mounted",
        description:
          "Big John’s trailer-mounted tree spades are your solution for efficient and reliable tree transplanting. Designed for ease of transport and exceptional durability, our spades help you elevate your farming and landscaping projects to the next level. Experience the difference that quality equipment can make. Contact us today to discuss your needs and get the best trailer-mounted tree spades on the market!",
        imgLink: TrailerMountedMain,
        variants: [
          {
            variantName: "44DTG",
            imgLink: Main44DTG,
            downloadLink: DTG44PDF,
            highlight: "1 – 10 cm Trees",
            descriptionMain:
              "The 44DTG is one of the smaller trailer spades that operates with simplicity and durability. Made with AR400 spade material, the Model 44 is made for trailers 449 cm in length and comes with hydraulic rear stabilizers and an extendable trailer tongue.",
            photos: [
              DTG441,
              DTG442,
              DTG443,
              DTG444
              // DTG445,
              // DTG446,
              // DTG447,
              // DTG448,
              // DTG449,
              // DTG4410,
              // DTG4411
            ],
            specifications: [
              {
                parameter: "Trailer Length",
                value: "449 cm"
              },
              {
                parameter: "Trailer Width",
                value: "250 cm"
              },
              {
                parameter: "Tree Trunk Diameter",
                value: "1 – 10 cm"
              },
              {
                parameter: "Root Ball Width",
                value: "111 cm"
              },
              {
                parameter: "Root Ball Depth",
                value: "91 cm"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "612 kg"
              },
              {
                parameter: "Machine Weight (empty/loaded)",
                value: "2490/3100 kg"
              },
              {
                parameter: "Transport Height",
                value: "305 cm"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "210 cm"
              },
              {
                parameter: "Gate Opening",
                value: "60 cm"
              },
              {
                parameter: "Opening Width",
                value: "225 cm"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR400"
              },
              {
                parameter: "Drive System (minimum GPM)",
                value: "14"
              },
              {
                parameter: "Hydraulic Tongue Ext",
                value: "Yes"
              },
              {
                parameter: "Tongue Swivel Left/Right",
                value: "30°/30°"
              },
              {
                parameter: "Hydraulic Jack Stand",
                value: "Yes"
              },
              {
                parameter: "Adjust. Hydraulic Pads",
                value: "No"
              },
              {
                parameter: "Adjust. Mechanical Pads",
                value: "No"
              }
            ]
          },
          {
            variantName: "54",
            imgLink: Main54,
            downloadLink: DTG54PDF,
            highlight: "1 – 10 cm Trees",
            descriptionMain:
              "The 54 Trailer Spade features our newest trailer design. It is a versatile trailer that comes in various sizes to fit any BIG JOHN customer's needs. The 54 Trailer Spade comes with an extendable trailer tongue, hydraulic jack, and hydraulic rear stabilizers.",
            photos: [
              D541,
              D542,
              D543,
              D544
              // D545,
              // D546,
              // D547,
              // D548,
              // D549,
              // D5410,
              // D5411
            ],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "1 – 10 cm"
              },
              {
                parameter: "Root Ball Width",
                value: "111 cm"
              },
              {
                parameter: "Root Ball Depth",
                value: "91 cm"
              },
              {
                parameter: "Root Ball Weight",
                value: "544 kg"
              },
              {
                parameter: "Total Machine Weight",
                value: "952 kg"
              },
              {
                parameter: "Blade Tower Height",
                value: "210 cm"
              },
              {
                parameter: "Gate Opening",
                value: "60 cm"
              },
              {
                parameter: "Opening Width",
                value: "243 cm"
              },
              {
                parameter: "Number of Spades",
                value: "4"
              },
              {
                parameter: "Hydraulic Gate Lock",
                value: "Yes"
              },
              {
                parameter: "Adjustable Hydraulic Pads",
                value: "Yes"
              },
              {
                parameter: "Adjustable Mechanical Pads",
                value: "Yes"
              },
              {
                parameter: "Spade Material",
                value: "AR400"
              },
              {
                parameter: "Drive System (Minimum GPM)",
                value: "10 – 16 GPM / 37 – 60 LPM"
              }
            ]
          },
          {
            variantName: "55DTD",
            imgLink: Main55DTD,
            downloadLink: DTD55PDF,
            highlight: "10 – 12,5 cm Trees",
            descriptionMain:
              "The model 55DTD is part of the Trailer Mounted family that comes with the same durability and reliability as the rest. It can handle trees up to 12,5 cm in diameter, comes with a hydraulic lock and tongue, and is made with AR500 spade material.",
            photos: [
              DTD551,
              DTD552,
              DTD553,
              DTD554
              // DTD555,
              // DTD556,
              // DTD557,
              // DTD558,
              // DTD559,
              // DTD5510
            ],
            specifications: [
              {
                parameter: "Trailer Length",
                value: "599 cm"
              },
              {
                parameter: "Trailer Width",
                value: "243 cm"
              },
              {
                parameter: "Tree Trunk Diameter",
                value: "10 – 12,5 cm"
              },
              {
                parameter: "Root Ball Width",
                value: "132 cm"
              },
              {
                parameter: "Root Ball Depth",
                value: "121 cm"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "1630 kg"
              },
              {
                parameter: "Total Machine Weight",
                value: "4762 kg"
              },
              {
                parameter: "Transport Height",
                value: "335 cm"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "200 cm"
              },
              {
                parameter: "Gate Opening",
                value: "76 cm"
              }
            ]
          },
          {
            variantName: "65DTD",
            imgLink: Main65DTD,
            downloadLink: DTD65PDF,
            highlight: "15 – 17,5 cm Trees",
            descriptionMain:
              "The 65DTD is another standard Trailer Mounted spade that comes with the same quality as the rest. The Model 65DTD can handle trees up to 17,5 cm in diameter and is made with AR500 spade material. It comes with a hydraulic lock and tongue.",
            photos: [
              DTD651,
              DTD652,
              DTD653,
              DTD654
              // DTD655,
              // DTD656,
              // DTD657,
              // DTD658,
              // DTD659
            ],
            specifications: [
              {
                parameter: "Trailer Length",
                value: "599 cm"
              },
              {
                parameter: "Trailer Width",
                value: "243 cm"
              },
              {
                parameter: "Tree Trunk Diameter",
                value: "15 – 17,5 cm"
              },
              {
                parameter: "Root Ball Width",
                value: "157 cm"
              },
              {
                parameter: "Root Ball Depth",
                value: "134 cm"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "1950 kg"
              },
              {
                parameter: "Total Machine Weight",
                value: "4985 kg"
              },
              {
                parameter: "Transport Height",
                value: "353 cm"
              },
              {
                parameter: "Blade Tower Height (down position)",
                value: "218 cm"
              },
              {
                parameter: "Gate Opening",
                value: "101 cm"
              }
            ]
          }
        ]
      },
      // Tractor Mounted
      {
        name: "Tractor Mounted",
        description:
          "BIG JOHN offers a range of tractor-mounted tree spades, specifically designed to meet the diverse needs of the landscaping and agricultural industries. With models ranging from 20″ to 60″, our tractor tree spades are crafted to handle a wide variety of tasks, making them essential tools for any operation that involves tree transplanting or earthmoving.",
        imgLink: TractorMountedMain,
        variants: [
          {
            variantName: "Tractor Tree Spades",
            imgLink: TractorMounted2,
            downloadLink: "13pqmR27HQwJa-3mZA2eSAilR2T7s8cKO",
            highlight: "1 – 5 CM Trees",
            descriptionMain:
              "Built and designed for the professional tree moving company looking to provide fully mature tree moving and transplanting services, operators love the BIG JOHN 100” truck-mounted tree spade for tackling their largest tree moving jobs. Because of the extra-large size, trees can be moved any time of year with high survivability rates. Designed and built for the professional mover. The biggest and best production tree spade available anywhere at any price. Move larger trees; move throughout the “off season“. Whatever your needs, the Model 100 can do the job.",
            photos: [
              TractorMounted1,
              TractorMounted2,
              TractorMounted3,
              TractorMounted4,
              TractorMounted5
            ],
            specifications: [
              {
                parameter: "Nominal Tree Trunk Diameter",
                value: "30 – 35 CM"
              },
              {
                parameter: "Weight of Transplanter",
                value: "9525 KG"
              },
              {
                parameter: "Height Closed (for Transportation, approx.)",
                value: "414 CM"
              },
              {
                parameter: "Width Closed (for Transportation, approx.)",
                value: "259 CM"
              },
              {
                parameter: "Nominal Root Ball Width (Adjustable)",
                value: "254 CM"
              },
              {
                parameter: "Root Ball Depth (approx.)",
                value: "172 CM"
              },
              {
                parameter: "Root Ball Weight (approx.)",
                value: "6800 – 8164 KG"
              },
              {
                parameter: "Hydraulic Pressure Relief (Preset)",
                value: "3,500 PSI"
              },
              {
                parameter: "Hydraulic GPM Rating (Gallons Per Minute)",
                value: "20 – 22 GPM / 75 - 83 LPM"
              }
            ]
          }
        ]
      },
      // Tree Spades Accessories
      {
        name: "Tree Spades Accessories",
        description:
          "Save Time, Money, and Miles. Move multiple trees per trip, resulting in fewer miles traveled and less fuel consumption. Keep receiving hole dirt plugs containerized for less shovel work. A BIG JOHN pod trailer or free-standing tree pod can help increase your efficiency by saving time and money.Our pod sizes come in 44, 55, 65, 80, 90, & 100 and have various configurations from multiple pods on a trailer or a free standing tree pod.",
        imgLink: TreeSpadesAccMain,
        variants: [
          {
            variantName: "44 Pod Trailer",
            imgLink: PodTrailer44Main,
            downloadLink: PT44PDF,
            highlight: "Move Multiple Trees in a Single Move",
            descriptionMain:
              'Custom designed for the BIG JOHN 45" Tree Spade, the 45" tree pod trailer allows you to move multiple trees in a single trip. We offer a range of customizations to allow multiple trees in a single trip, from single pods up to 6.',
            photos: [PodTrailer44],
            specifications: [
              {
                parameter: "Empty Weight",
                value: "1450 kg / 1800 kg / 2200 kg / 3400 kg"
              },
              {
                parameter: "Length",
                value: "300 cm / 485 cm / 695 cm / 850 cm"
              },
              {
                parameter: "Axles",
                value: "1 — 3150 kg / 2 — 3150 kg / 2 — 3150 kg / 2 — 4500 kg"
              },
              {
                parameter: "Brakes",
                value: "Electric"
              },
              {
                parameter: "Engine",
                value: "Honda"
              },
              {
                parameter: "Engine HP",
                value: "8"
              }
            ]
          },
          {
            variantName: "55 Pod Trailer",
            imgLink: PodTrailer55Main,
            downloadLink: PT55PDF,
            highlight: "Move More Trees in Less Time",
            descriptionMain:
              'Custom designed for the BIG JOHN 55" Tree Spade, the 55" tree pod trailer allows you to move multiple trees in a single trip. We offer a range of customizations to allow multiple trees in a single trip, from single pods up to 3.',
            photos: [PodTrailer55],
            specifications: [
              {
                parameter: "Empty Weight",
                value: "2000 kg / 2900 kg"
              },
              {
                parameter: "Length",
                value: "595 cm / 822 cm"
              },
              {
                parameter: "Axles",
                value: "2 — 3150 kg / 2 — 4500 kg"
              },
              {
                parameter: "Brakes",
                value: "Electric / Electric & Air"
              },
              {
                parameter: "Engine",
                value: "Honda"
              },
              {
                parameter: "Engine HP",
                value: "8"
              }
            ]
          },
          {
            variantName: "65 Pod Trailer",
            imgLink: PodTrailer65Main,
            downloadLink: PT65PDF,
            highlight: "Move More Trees in Less Time",
            descriptionMain:
              'Custom designed for the BIG JOHN 65" Tree Spade, the 65" tree pod trailer allows you to move multiple trees in a single trip. We offer a range of customizations to allow multiple trees in a single trip, from single pods up to 2.',
            photos: [PodTrailer65],
            specifications: [
              {
                parameter: "Empty Weight",
                value: "2000 kg / 2900 kg"
              },
              {
                parameter: "Length",
                value: "595 cm / 822 cm"
              },
              {
                parameter: "Axles",
                value: "2 — 3150 kg / 2 — 4500 kg"
              },
              {
                parameter: "Brakes",
                value: "Electric / Electric & Air"
              },
              {
                parameter: "Engine",
                value: "Honda"
              },
              {
                parameter: "Engine HP",
                value: "8"
              }
            ]
          },
          {
            variantName: "90 Pod Trailer",
            imgLink: PodTrailer90Main,
            downloadLink: PT90PDF,
            highlight: "Move More Trees in Less Time",
            descriptionMain:
              'The BIG JOHN 90" Tree Pod Trailer is the best way to move multiple large trees at the same time, allowing you to free up your spade during transport.',
            photos: [PodTrailer90],
            specifications: [
              {
                parameter: "Empty Weight",
                value: "2500 kg / 2800 kg / 6500 kg"
              },
              {
                parameter: "Length",
                value: "475 cm / 975 cm / 1050 cm"
              },
              {
                parameter: "Axles",
                value: "2 — 4500 kg / 2 — 4500 kg / 2 — 9000 kg"
              },
              {
                parameter: "Brakes",
                value: "Electric / Electric / Air"
              },
              {
                parameter: "Engine",
                value: "Honda"
              },
              {
                parameter: "Engine HP",
                value: "8"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: "Beach Cleaning Machines",
    type: [
      {
        name: "Ride On Machines",
        description:
          "BIG JOHN is excited to announce the excavator mounted tree spades to our line up. We offer them in a model 65, 80, and 90. Depending on the model they are made to move trees from 15 cm to 30 cm in diameter and comes complete with electric valve bank an wireless remote control. Joining the BIG JOHN family means getting exceptional customer services for the life of your spade.",
        imgLink: ROMMain,
        variants: [
          {
            variantName: "Nemo",
            imgLink: ROMNemo,
            downloadLink: NemoPDF,
            highlight: "Champion Performance, Compact and Maneuverable",
            descriptionMain:
              "Nemo is a fully hydrostatic man-on-board beach cleaner that is extremely maneuverable and practical to use, even in tight spaces. Equipped with a Honda 22 hp engine, it cleans sand from both large waste and microplastics.",
            photos: [ROMNemo2, ROMNemo3, ROMNemo4, ROMNemo5, ROMNemo6],
            specifications: [
              {
                parameter: "Engine",
                value: "Honda 22 hp"
              },
              {
                parameter: "Working Depth",
                value: "0 to 10 cm"
              },
              {
                parameter: "Working Width",
                value: "100 cm"
              },
              {
                parameter: "Working Capacity",
                value: "6000 sq m/h"
              },
              {
                parameter: "Width",
                value: "1050 mm"
              },
              {
                parameter: "Height",
                value: "1310 mm"
              },
              {
                parameter: "Length",
                value: "2410 mm"
              },
              {
                parameter: "Weight",
                value: "600 kg"
              }
            ]
          },
          {
            variantName: "Nemo Track",
            imgLink: ROMNemoTrack,
            downloadLink: NemoTrackPDF,
            highlight: "Built-in Strength, Agility, and Speed",
            descriptionMain:
              "Nemo Track offers advanced technology and performance. It’s designed to adapt to both large and microplastic waste on beaches, with a Honda 22 hp engine and a working capacity of about 6000 sq m/h.",
            photos: [
              ROMNemoTrack2,
              ROMNemoTrack3,
              ROMNemoTrack4,
              ROMNemoTrack5,
              ROMNemoTrack6
            ],
            specifications: [
              {
                parameter: "Engine",
                value: "Honda 22 hp"
              },
              {
                parameter: "Working Depth",
                value: "0 to 10 cm"
              },
              {
                parameter: "Working Width",
                value: "100 cm"
              },
              {
                parameter: "Working Capacity",
                value: "6000 sq m/h"
              },
              {
                parameter: "Width",
                value: "1050 mm"
              },
              {
                parameter: "Height",
                value: "1310 mm"
              },
              {
                parameter: "Length",
                value: "2410 mm"
              },
              {
                parameter: "Weight",
                value: "600 kg"
              }
            ]
          },
          {
            variantName: "Squalo",
            imgLink: ROMSqualo,
            downloadLink: SqualoPDF,
            highlight: "Power, Productivity, and Elegance at the Highest Level",
            descriptionMain:
              "The Squalo beach cleaner is a fully hydrostatic man-on-board machine with excellent power and comfort. It is equipped with a Yanmar 30 hp engine and is perfect for cleaning beaches with considerable waste.",
            photos: [ROMSqualo2, ROMSqualo3, ROMSqualo4, ROMSqualo5],
            specifications: [
              {
                parameter: "Engine",
                value: "Yanmar 30 hp"
              },
              {
                parameter: "Working Depth",
                value: "0 to 10 cm"
              },
              {
                parameter: "Working Width",
                value: "160 cm"
              },
              {
                parameter: "Working Capacity",
                value: "9000 sq m/h"
              },
              {
                parameter: "Width",
                value: "1600 mm"
              },
              {
                parameter: "Height",
                value: "1600 mm"
              },
              {
                parameter: "Length",
                value: "3000 mm"
              },
              {
                parameter: "Weight",
                value: "1050 kg"
              }
            ]
          },
          {
            variantName: "Squalo 2.0",
            imgLink: ROMSqualo20Main,
            downloadLink: Squalo20PDF,
            highlight: "Power, Productivity, and Elegance at the Highest Level",
            descriptionMain:
              "Equipped with Yanmar engine 30 Hp Working depth 0 to 10 cm for 160 cm working width. Work capacity approx. 9000 sm. /h. Self-driven sand cleaning machine wholly hydrostatic, extremely manoeuvrable and agile also in small spaces. It is driven through two joysticks, which adapt the speed, direction and working depth. Squalo is adapt to work also in beaches where big-sized waste is present.",
            photos: [ROMSqualo201, ROMSqualo203, ROMSqualo204, ROMSqualo202],
            specifications: []
          }
        ]
      },
      {
        name: "Tractor Towed Machines",
        description:
          "The best compromise between size and performance. Our machines form a very compact tractor-machine combination. This type of beach cleaner is ideal for carrying out work on the shoreline and removing even large pieces of trash. ",
        imgLink: TTMMain,
        variants: [
          {
            variantName: "Cernia",
            imgLink: CerniaMain,
            downloadLink: CerniaPDF,
            highlight: "The Best Compromise Between Size and Performance",
            descriptionMain:
              "Cernia is a compact and reliable beach cleaner suitable for small tractors (16-20 Hp), ideal for shoreline work and removing large pieces of trash.",
            photos: [Cernia, Cernia2, Cernia3],
            specifications: [
              {
                parameter: "Working Depth",
                value: "0 to 15 cm"
              },
              {
                parameter: "Working Width",
                value: "120 cm"
              },
              {
                parameter: "Working Capacity",
                value: "7000 sq m/h"
              },
              {
                parameter: "Width",
                value: "1200 mm"
              },
              {
                parameter: "Height",
                value: "870 mm"
              },
              {
                parameter: "Length",
                value: "1050 mm"
              },
              {
                parameter: "Weight",
                value: "110 kg"
              }
            ]
          },
          {
            variantName: "Manta",
            imgLink: MantaMain,
            downloadLink: MantaPDF,
            highlight: "Innovation and Quality",
            descriptionMain:
              "Manta is a state-of-the-art beach cleaner, perfect for tractors from 35 Hp, offering excellent performance on beaches with considerable waste.",
            photos: [Manta, Manta2, Manta3, Manta4],
            specifications: [
              {
                parameter: "Working Depth",
                value: "0 to 20 cm"
              },
              {
                parameter: "Working Width",
                value: "160 cm"
              },
              {
                parameter: "Working Capacity",
                value: "20000 sq m/h"
              },
              {
                parameter: "Width",
                value: "1600 mm"
              },
              {
                parameter: "Height",
                value: "1000 mm"
              },
              {
                parameter: "Length",
                value: "1040 mm"
              },
              {
                parameter: "Weight",
                value: "280 kg"
              }
            ]
          },
          {
            variantName: "Manta Gold",
            imgLink: MantaGoldMain,
            downloadLink: MantaGoldPDF,
            highlight: "Excellence in Beach Cleaning",
            descriptionMain:
              "Manta Gold offers superior quality with a rear hydraulic collection drawer and a capacity of 500 liters, perfect for tractors from 70 Hp.",
            photos: [MantaGold, MantaGold2, MantaGold3],
            specifications: [
              {
                parameter: "Working Depth",
                value: "0 to 20 cm"
              },
              {
                parameter: "Working Width",
                value: "160 cm"
              },
              {
                parameter: "Working Capacity",
                value: "20000 sq m/h"
              },
              {
                parameter: "Width",
                value: "1720 mm"
              },
              {
                parameter: "Height",
                value: "1550 mm"
              },
              {
                parameter: "Length",
                value: "1700 mm"
              },
              {
                parameter: "Weight",
                value: "430 kg"
              }
            ]
          },
          {
            variantName: "Caimano",
            imgLink: CaimanoMain,
            downloadLink: CaimanoPDF,
            highlight: "Innovative and Powerful",
            descriptionMain:
              "Caimano is an advanced beach cleaner suitable for tractors from 120 Hp, designed for large-scale beach cleaning with a working capacity of up to 30,000 sq m/h.",
            photos: [Caimano, Caimano2, Caimano3, Caimano4, Caimano5],
            specifications: [
              {
                parameter: "Working Depth",
                value: "0 to 25 cm"
              },
              {
                parameter: "Working Width",
                value: "220 cm"
              },
              {
                parameter: "Working Capacity",
                value: "30000 sq m/h"
              },
              {
                parameter: "Width",
                value: "2400 mm"
              },
              {
                parameter: "Height",
                value: "1350 mm"
              },
              {
                parameter: "Length",
                value: "2400 mm"
              },
              {
                parameter: "Weight",
                value: "700 kg"
              }
            ]
          },
          {
            variantName: "Model 400",
            imgLink: Model400SRMain,
            downloadLink: Model400SRPDF,
            highlight: "Compact Beach Raking Maching",
            descriptionMain:
              "The 400 is the most compact beach rake in the SURF RAKE lineup. It weighs 1,900 pounds and can lift up to 2,400 pounds in its one (1) cubic yard hopper. Its hydraulic operated hopper places collected material neatly on the ground. Within one (1) hour, the 400 can effectively clean up to five (5) acres of beach sand.",
            photos: [Model400SR1, Model400SR2, Model400SR3, Model400SR4],
            specifications: [
              {
                parameter: "Dimensions",
                value: "H: 1.4 m x L: 3.0 m x W: 2.3 m"
              },
              { parameter: "Weight", value: "Approximately 860 kg" },
              { parameter: "Cleaning Width", value: "1.8 m" },
              { parameter: "Cleaning Depth", value: "Adjustable to 15 cm" },
              { parameter: "Operating Speed", value: "1.0 to 25 mph" },
              {
                parameter: "Debris Removed",
                value:
                  "Broken glass, plastic, syringes, cigarette butts, pop-tops, straws, cans, tar balls, stones 3/8″ to 6″ (0.9 cm to 15.24 cm) in diameter, sea grass, seaweed, fish, small pieces of wood."
              },
              {
                parameter: "Performance",
                value: "Cleans up to 1.6 hectares/hr"
              },
              {
                parameter: "Hopper",
                value: "0.75 cubic meters (1100 kg cap.)"
              },
              { parameter: "Dump Height", value: "Ground" },
              {
                parameter: "Tires",
                value: "78.7 x 34.3 x 38.1 cm high flotation design"
              },
              {
                parameter: "Conveyor",
                value:
                  "Bar flight type, covered with continuous 1.2 m wide belt, with stainless steel spring tines mounted on it."
              },
              {
                parameter: "Hydraulic Drive",
                value:
                  "Completely sealed and protected by the full flow filter. Large capacity spline mounted pump, hydraulic motor, flow control, and built-in overflow protection."
              },
              { parameter: "Hydraulic Flow", value: "45 L/min" },
              { parameter: "Hydraulic Capacity", value: "42 L" },
              {
                parameter: "Cylinders",
                value: "Trip 2.54 cm x 25.40 cm single acting"
              },
              { parameter: "Paint", value: "Dupont IMRON Polyurethane enamel" },
              {
                parameter: "Tractor",
                value:
                  "30 PTO horsepower 4-wheel drive agricultural type tractor with 71 cm rear wheels."
              },
              {
                parameter: "Other Tractor Requirements",
                value:
                  "540 RPM rear PTO, 3-point hitch and depending on model and options, up to two remote hydraulic valves with raise, hold and float positions. Larger or smaller tractors may be used depending on beach conditions."
              }
            ]
          },
          {
            variantName: "Model 400HD",
            imgLink: Model400SRHDMain,
            downloadLink: Model400SRHDPDF,
            highlight: "Mid Sized Mechanical Beach Rake",
            descriptionMain:
              "The 400HD has proven to be an excellent choice for resorts, hotels and lakeshore communities. At 2,700 pounds, it is the medium-sized beach rake in the SURF RAKE lineup. It is equipped with a two (2) cubic yard hopper that will lift 3,500 pounds of debris from the sand to a dumping height of nine (9) feet. This mid-size beach rake uses the same heavy-duty conveyor and dump components as the 600HD. The 400HD can clean beaches at up to seven (7) acres per hour.",
            photos: [
              Model400SRHD1,
              Model400SRHD2,
              Model400SRHD3,
              Model400SRHD4
            ],
            specifications: [
              {
                parameter: "Dimensions",
                value: "H: 2,2 m x L: 3,6 m x W: 2,3 m"
              },
              { parameter: "Weight", value: "Approximately 1225 kg" },
              { parameter: "Cleaning Width", value: "1,8 m" },
              { parameter: "Cleaning Depth", value: "Adjustable to 15 cm" },
              { parameter: "Operating Speed", value: "1.0 to 25 kmph" },
              {
                parameter: "Debris Removed",
                value:
                  "Broken glass, plastic, syringes, cigarette butts, pop-tops, straws, cans, tar balls, stones 3/8″ to 6″ in (,95 cm to 15,24 cm) diameter, sea grass, seaweed, fish, small pieces of wood."
              },
              {
                parameter: "Performance",
                value: "Cleans up to 2.8 hectares/hr"
              },
              {
                parameter: "Hopper",
                value: "1,52 cubic meters (1600 kg cap.)"
              },
              { parameter: "Dump Height", value: "2,75 m" },
              {
                parameter: "Tires",
                value: "78.7 x 34.3 x 38.1 cm high flotation design"
              },
              {
                parameter: "Conveyor",
                value:
                  "Bar flight type, covered with continuous 1,2 m wide belt, with stainless steel spring tines mounted on it."
              },
              {
                parameter: "Hydraulic Drive",
                value:
                  "Completely sealed and protected by the full flow filter. Large capacity spline mounted pump, hydraulic motor, flow control, and built-in overflow protection."
              },
              { parameter: "Hydraulic Flow", value: "45 L/min" },
              { parameter: "Hydraulic Capacity", value: "42 L" },
              {
                parameter: "Cylinders",
                value:
                  "Lift 7.62 cm x 45.72 cm single acting .60 m x 1.52 m single acting"
              },
              { parameter: "Paint", value: "Dupont IMRON Polyurethane enamel" },
              {
                parameter: "Tractor",
                value:
                  "35 PTO horsepower 4-wheel drive agricultural type tractor with 71 cm rear wheels."
              },
              {
                parameter: "Other Tractor Requirements",
                value:
                  "540 RPM rear PTO, 3-point hitch and depending on model and options, up to two remote hydraulic valves with raise, hold and float positions. Larger or smaller tractors may be used depending on beach conditions."
              }
            ]
          },
          {
            variantName: "Model 600HD",
            imgLink: Model600SRHDMain,
            downloadLink: Model600SRPDF,
            highlight: "BARBER'S Most Popular Beach Rake",
            descriptionMain:
              "At 3,800 pounds, the 600HD is the most widely-used beach cleaner by municipalities to clean expansive beaches. Cleaning sand up to nine (9) acres an hour with a seven (7) foot wide cleaning path, the 600HD has the greatest sand cleaning capacity of any beach cleaner in its class. The three (3) cubic yard hopper can hydraulically lift up to 4,500 pounds of material to a clearance height of nine (9) feet and dump its contents.",
            photos: [
              Model600SRHD1,
              Model600SRHD2,
              Model600SRHD3,
              Model600SRHD4
            ],
            specifications: [
              {
                parameter: "Dimensions",
                value: "H: 2,3 m x L: 4,0 m W: 2,3 m"
              },
              { parameter: "Weight", value: "Approximately 1800 kg" },
              { parameter: "Cleaning Width", value: "2,14 m" },
              { parameter: "Cleaning Depth", value: "Adjustable to 15 cm" },
              { parameter: "Operating Speed", value: "1.0 to 25 kmph" },
              {
                parameter: "Debris Removed",
                value:
                  "Broken glass, plastic, syringes, cigarette butts, pop-tops, straws, cans, tar balls, stones 3/8″ to 6″ (,95 cm to 15,24 cm) in diameter, sea grass, seaweed, fish, small pieces of wood."
              },
              {
                parameter: "Performance",
                value: "Cleans up to 3.3 hectares/hr"
              },
              {
                parameter: "Hopper",
                value: "2,3 cubic meters (2000 kg cap.)"
              },
              { parameter: "Dump Height", value: "2,75 m" },
              {
                parameter: "Cleaning Depth",
                value: "Adjustable to 15 cm"
              },
              {
                parameter: "Operating Speed",
                value: "1.0 to 25 kmph"
              },
              {
                parameter: "Debris Removed",
                value:
                  "Broken glass, plastic, syringes, cigarette butts, pop-tops, straws, cans, tar balls, stones 3/8″ to 6″ (,95 cm to 15,24 cm) in diameter, sea grass, seaweed, fish, small pieces of wood."
              },
              {
                parameter: "Performance",
                value: "Cleans up to 3.3 hectares/hr"
              },
              {
                parameter: "Hopper",
                value: "2,3 cubic meters (2000 kg cap.)"
              },
              { parameter: "Dump Height", value: "2,75 m" },
              {
                parameter: "Tires",
                value: "91.4 x 34.3 x 38.1 cm high flotation design"
              },
              {
                parameter: "Conveyor",
                value:
                  "Of bar flight type, covered with continuous 1,8 m wide belt, with stainless steel spring tines mounted on it."
              },
              {
                parameter: "Hydraulic Drive",
                value:
                  "Completely sealed and protected by the full flow filter. Large capacity spline mounted pump, hydraulic motor, flow control, and built-in overflow protection."
              },
              { parameter: "Hydraulic Flow", value: "45 L/min" },
              { parameter: "Hydraulic Capacity", value: "61 L" },
              {
                parameter: "Cylinders",
                value:
                  "Lift 7.62 cm x 45.72 cm single acting .60 m x 1.52 m single acting"
              },
              { parameter: "Paint", value: "Dupont IMRON Polyurethane enamel" },
              {
                parameter: "Tractor",
                value:
                  "60 PTO horsepower 4-wheel drive agricultural type tractor with 76 cm rear wheels."
              },
              {
                parameter: "Other Tractor Requirements",
                value:
                  "540 RPM rear PTO, 3-point hitch and depending on model and options, up to two remote hydraulic valves with raise, hold and float positions. Larger or smaller tractors may be used depending on beach conditions."
              }
            ]
          },
          {
            variantName: "Model 600XL",
            imgLink: Model600XLMain,
            downloadLink: Model600XLPDF,
            highlight: "Barber's Largest Beach Rake Machine",
            descriptionMain:
              "With a cleaning width of 15 feet (5m), the SURF RAKE 600XL is the largest beach cleaning machine in Barber’s lineup. Intended for use with vast beaches, it enables beach maintenance teams to clean up to 15 acres per hour. Based on the time-tested reliability, ease-of-operation, and efficiency of the 600HD, the 600XL doubles its cleaning capacity while cutting cleaning times in half.",
            photos: [Model600XL1, Model600XL2, Model600XL3, Model600XL4],
            specifications: [
              {
                parameter: "Dimensions",
                value: "H: 2,3 m x L: 5,2 m W: 4,6 m"
              },
              { parameter: "Weight", value: "Approximately 3629 kg" },
              { parameter: "Cleaning Width", value: "5 m" },
              { parameter: "Cleaning Depth", value: "Adjustable to 15 cm" },
              { parameter: "Operating Speed", value: "1.0 to 25 kmph" },
              {
                parameter: "Debris Removed",
                value:
                  "Broken glass, plastic, syringes, cigarette butts, pop-tops, straws, cans, tar balls, stones 3/8″ to 6″ (,95 cm to 15,24 cm) in diameter, sea grass, seaweed, fish, small pieces of wood."
              },
              {
                parameter: "Performance",
                value: "Cleans up to 16 acres/hr, 6.6 hectares/hr"
              },
              {
                parameter: "Hopper",
                value: "4,6 cubic meters (2000 kg cap.)"
              },
              { parameter: "Dump Height", value: "2,75 m" },
              {
                parameter: "Tires",
                value: "91.4 x 34.3 x 38.1 cm high flotation design"
              },
              {
                parameter: "Conveyor",
                value:
                  "Of bar flight type, covered with two 6 ft/ 1,8 m wide belts, with stainless steel spring tines mounted on it."
              },
              {
                parameter: "Hydraulic Drive",
                value:
                  "Completely sealed and protected by the full flow filter. Large capacity spline mounted pump, hydraulic motor, flow control, and built-in overflow protection."
              },
              { parameter: "Hydraulic Flow", value: "80 L/min" },
              { parameter: "Hydraulic Capacity", value: "122 L" },
              {
                parameter: "Cylinders",
                value:
                  "Lift 7.62 cm x 45.72 cm single acting .60 m x 1.52 m single acting"
              },
              { parameter: "Paint", value: "Dupont IMRON Polyurethane enamel" },
              {
                parameter: "Tractor",
                value:
                  "110 PTO horsepower 4-wheel drive agricultural type tractor with minimum 460/85R34 rear tires (460/85R38 preferred)"
              },
              {
                parameter: "Other Tractor Requirements",
                value:
                  "540 RPM rear PTO, 3-point hitch and depending on model and options, up to two remote hydraulic valves with raise, hold and float positions. Larger or smaller tractors may be used depending on beach conditions."
              }
            ]
          }
        ]
      },
      {
        name: "Walk Behind Machines",
        description:
          "Designed to cope with any type of beach. Our manual beach cleaners are fast and maneuverable, and because of their design, they lend themselves very well to working in small spaces, such as under umbrellas.",
        imgLink: WBMMain,
        variants: [
          {
            variantName: "Electric Barracuda 2.0",
            imgLink: BarracudaElectricMain,
            downloadLink: "",
            highlight: "Innovative and Eco-Friendly",
            descriptionMain:
              "Electric Barracuda 2.0 is an all-electric, emission-free beach cleaner designed for efficiency and precision in cleaning beaches, including microplastics.",
            photos: [
              BarracudaElectric,
              BarracudaElectric1,
              BarracudaElectric2,
              BarracudaElectric3
            ],
            specifications: [
              {
                parameter: "Working Depth",
                value: "0 to 10 cm"
              },
              {
                parameter: "Working Width",
                value: "90 cm"
              },
              {
                parameter: "Working Capacity",
                value: "2500 sq m/h"
              },
              {
                parameter: "Width",
                value: "900 mm"
              },
              {
                parameter: "Height",
                value: "1000 mm"
              },
              {
                parameter: "Length",
                value: "1900 mm"
              },
              {
                parameter: "Battery Life",
                value: "3 hours of work"
              }
            ]
          },
          {
            variantName: "Delfino",
            imgLink: DolphinMain,
            downloadLink: DolphinPDF,
            highlight: "Unique and Inimitable",
            descriptionMain:
              "Delfino is a small, maneuverable beach cleaner with a 5.5 Hp engine, ideal for cleaning small to medium beaches and capable of removing microplastics.",
            photos: [Dolphin, Dolphin1, Dolphin2, Dolphin3],
            specifications: [
              {
                parameter: "Working Depth",
                value: "0 to 10 cm"
              },
              {
                parameter: "Working Width",
                value: "75 cm"
              },
              {
                parameter: "Working Capacity",
                value: "2500 sq m/h"
              },
              {
                parameter: "Width",
                value: "890 mm"
              },
              {
                parameter: "Height",
                value: "900 mm"
              },
              {
                parameter: "Length",
                value: "1950 mm"
              },
              {
                parameter: "Weight",
                value: "180 kg"
              }
            ]
          },
          {
            variantName: "Electric Delfino 2.0",
            imgLink: DolphinElectricMain,
            downloadLink: DolphinElectricPDF,
            highlight: "Electric and Eco-Friendly Innovation",
            descriptionMain:
              "Electric Delfino 2.0 is an all-electric version of the Delfino, offering emission-free operation with a focus on cleaning microplastics.",
            photos: [
              DolphinElectric,
              DolphinElectric1,
              DolphinElectric2,
              DolphinElectric3,
              DolphinElectric4
            ],
            specifications: [
              {
                parameter: "Working Depth",
                value: "0 to 10 cm"
              },
              {
                parameter: "Working Width",
                value: "75 cm"
              },
              {
                parameter: "Working Capacity",
                value: "2500 sq m/h"
              },
              {
                parameter: "Width",
                value: "890 mm"
              },
              {
                parameter: "Height",
                value: "900 mm"
              },
              {
                parameter: "Length",
                value: "1950 mm"
              },
              {
                parameter: "Weight",
                value: "180 kg"
              },
              {
                parameter: "Battery Life",
                value: "3 hours of work"
              }
            ]
          },
          {
            variantName: "Sand Man 850",
            imgLink: SandManMain,
            downloadLink: SandManPDF,
            highlight: "Sand Sifting And Soil Screening Applications",
            descriptionMain:
              "The SAND MAN 850 is a versatile sand sifter and soil screener that has a wide variety of applications. Its maneuverability, effectiveness, and ease of operation make it a valuable tool for golf course owners, small beach owners, and anyone who maintains smaller sandy areas. By screening stones, litter, shells, glass, and other finer objects, the SAND MAN ensures your property will be debris-free.",
            photos: [SandMan1, SandMan2, SandMan3, SandMan4]
          },
          {
            variantName: "Barracuda",
            imgLink: BarracudaMain,
            downloadLink: BarracudaPDF,
            highlight: "Safe and Unstoppable",
            descriptionMain:
              "Barracuda is a powerful beach cleaner with a 6.5 Hp engine, designed to clean large beaches, remove organic debris, and microplastics.",
            photos: [Barracuda, Barracuda1, Barracuda2, Barracuda3],
            specifications: [
              {
                parameter: "Working Depth",
                value: "0 to 10 cm"
              },
              {
                parameter: "Working Width",
                value: "90 cm"
              },
              {
                parameter: "Working Capacity",
                value: "2500 sq m/h"
              },
              {
                parameter: "Engine Power",
                value: "6.5 Hp"
              },
              {
                parameter: "Speed",
                value: "2 forward speeds and 1 reverse gear"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: "Grass Collector Machines",
    type: [
      {
        name: "Koala",
        description:
          "The Koala Professional model with its high lift collector system is an ideal compact mower for contractors, greenkeepers and those who use it for fast and professional maintenance. Its powerful vacuum and verticut blades help the users to mow with perfect grass cutting, aeration, collection in a tide way and short time up to 2,5cm / 1 inch depth.",
        imgLink: KoalaMain,
        variants: [
          {
            variantName: "Koala",
            imgLink: Koala1,
            downloadLink: KoalaPDF,
            highlight: "Rear Mounted Flail Collector Mower",
            descriptionMain:
              "The PERUZZO FLAIL MOWER MOD. KOALA is a small machine that fits low weight (900 kg.) 25HP compact tractors. This flail mower uses the patented flails for a perfect grass cut performance with verticut operation. The FLAIL MOWER MOD. KOALA is an ideal compact mower for contractors, greenkeepers thanks to its ground discharge collector system and it’s useful for a fast and professional maintenance. Its powerful vacuum and verticut blades help the users to mow with perfect grass cutting, aeration, collection in a tide way and short time up to 2,5cm / 1 inch depth. Koala mowers are used on sport fields and parks where verticut and collection operation is widely performed: it is also great to pass over soft grounds and roll them with their rear roller. Koala mowers are successfully used to cut grass, collect leaves, green waste, horse manure etc. on public parks and private properties.",
            photos: [Koala1, Koala2, Koala3, Koala4],
            specifications: []
          },
          {
            variantName: "Koala Professional",
            imgLink: KoalaProMain,
            downloadLink: KoalaProfessionalPDF,
            highlight: "Rear Mounted Flail Collection Mower With Catcher Lift",
            descriptionMain:
              "The flail mower PERUZZO mod. KOALA PROFESSIONAL  that fits on 25HP on low weight compact tractors (900 kg). This flail mower uses the patented flails for perfect grass cut performance with verticut operation. The Koala Professional model with its high lift collector system is an ideal compact mower for contractors, greenkeepers and those who use it for fast and professional maintenance. Its powerful vacuum and verticut blades help the users to mow with perfect grass cutting, aeration, collection in a tide way and short time up to 2,5cm / 1 inch depth. Its powerful vacuum and vertical blades help users to cut grass perfectly, aerate, collect smoothly and quickly up to 2.5 cm/ 1 cm depth. Koala Professional mowers are used on sport fields and parks where verticut and collection operation are widely performed: it is also great to pass over soft grounds and consecutively rolled by their rear roller. Koala Professional mowers are also successfully used to cut grass, collect leaves, green waste, horse manure etc. on public parks and private properties.",
            photos: [KoalaPro1, KoalaPro2, KoalaPro3, KoalaPro4],
            specifications: []
          }
        ]
      },
      {
        name: "Phanter",
        description:
          "The flail collection mower PERUZZO mod. PANTHER PROFESSIONAL with high lift discharge is suitable for rear application on tractors of medium power 40-50CV and with excellent cut and collection capacity up to 1800 liters. The unloading height can reach over 2.20m by lifting it with 3-point hitch tractor according to the tractor used.",
        imgLink: PhanterMain,
        variants: [
          {
            variantName: "Phanter",
            imgLink: Phanter1,
            downloadLink: PhanterPDF,
            highlight:
              "Rear Mounted Flail Collection Mower For 30 To 50 Tractor Hp",
            descriptionMain:
              "The flail collection mower PERUZZO mod. PANTHER is suitable for rear application on tractors of medium power 40-50CV. It makes excellent cuts and has a collection capacity of 1800 liters. The grass catcher discharges the product directly on the ground. This flail mower mod. PANTHER is aimed for greenkeepers and professional contractors whom perform cutting + verticut + collection in one pass and millimeter cutting and aeration height adjustments. The mower PERUZZO mod. PANTHER drastically reduces maintenance times with high working autonomy due to large collectors. These machines are shredders adapted by Peruzzo to deal with high quality grass cuts with special accessories such as patented knives, high speed rotation knives, roller cleaning brushes, millimeter adjustments and internal openings for easy maintenance.",
            photos: [Phanter1, Phanter2, Phanter3, Phanter4],
            specifications: []
          },
          {
            variantName: "Phanter Multi Fit",
            imgLink: PhanterMultifitMain,
            downloadLink: PhanterMultifitPDF,
            highlight:
              "Rear Mounted Flail Collection Mower For 30 To 70 Tractor Hp.",
            descriptionMain:
              "The mower PANTHER MULTIFIT is suitable for rear application on medium power tractors. Engineered for grass, verticut action and collection in the same time, leaves a clean and ventilated soil. The processed product can be discharged on the ground or high discharged by hydraulic jack. This machine is suitable for municipality and sport courses maintenance and it is equipped with rear wheels for an easy transport; it can be used with 30 HP tractors.",
            photos: [
              PhanterMultifit,
              PhanterMultifit1,
              PhanterMultifit2,
              PhanterMultifit3
            ],
            specifications: []
          },
          {
            variantName: "Phanter Professional",
            imgLink: PhanterProfessionalMain,
            downloadLink: PhanterProfessionalPDF,
            highlight: "Tractor Harvester For 40 - 50 Hp Tractors",
            descriptionMain:
              "The flail collection mower PERUZZO mod. PANTHER PROFESSIONAL with high lift discharge is suitable for rear application on tractors of medium power 40-50CV and with excellent cut and collection capacity up to 1800 liters. The unloading height can reach over 2.20m by lifting it with 3-point hitch tractor according to the tractor used. This flail mower mod. PANTHER PROFESSIONAL is aimed for greenkeepers and professional contractors whom perform cutting + verticut + collection in one pass and millimeter cutting and aeration height adjustments. This machine drastically reduces maintenance times with high working autonomy due to large collectors. The PERUZZO mod. PANTHER PROFESSIONAL flail mowers are shredders adapted by Peruzzo to deal with high quality grass cuts with special accessories such as patented knives, high speed rotation knives, roller cleaning brushes, millimeter adjustments and internal openings for easy maintenance.",
            photos: [
              PhanterProfessional,
              PhanterProfessional1,
              PhanterProfessional2,
              PhanterProfessional3
            ],
            specifications: []
          }
        ]
      },
      {
        name: "Tiger",
        description:
          "Flail Collector Mower TIGER engineered to help professional municipality and sport courses contractors to cut, verticut and collect. Supplied with large capacity collector with 235cm / 94” high discharge. The cutting head follows uneven grounds floating on any direction to cut and verticut independently from machine frame allowing a perfect maintenance for the most exigent Greenkeeper.",
        imgLink: TigerMain,
        variants: [
          {
            variantName: "Tiger",
            imgLink: Tiger1,
            downloadLink: TigerPDF,
            highlight: "Flail Collector Mower For Professional Contractors",
            descriptionMain:
              "Flail Collector Mower TIGER engineered to help professional municipality and sport courses contractors to cut, verticut and collect. Supplied with large capacity collector with 235cm / 94” high discharge. The cutting head follows uneven grounds floating on any direction to cut and verticut independently from machine frame allowing a perfect maintenance for the most exigent Greenkeeper.",
            photos: [Tiger1, Tiger2, Tiger3, Tiger4],
            specifications: []
          }
        ]
      },
      {
        name: "Canguro",
        description:
          "The Canguro Professional model with its high lift collector system is an ideal compact mower for contractors, greenkeepers and those who use it for fast and professional maintenance. Its powerful vacuum and verticut blades help the users to mow with perfect grass cutting, aeration, collection in a tide way and short time up to 2,5cm / 1 inch depth.",
        imgLink: CanguroMain,
        variants: [
          {
            variantName: "Canguro",
            imgLink: CanguroNormal,
            downloadLink: CanguroNormalPDF,
            highlight:
              "Heavy Duty Flail Collection Mower For 40 To 70 Tractor Hp.",
            descriptionMain:
              "The grass/pruning shredder CANGURO NORMAL / CANGURO NORMAL SUPER is used for a good grass cutting and pruning shredding with brunches up to 5 cm of diameter, collecting all processed products in the same time, discharging it directly to the ground by a hydraulic jack collector opening. Its good performance cut and pruning reduction with consequent collection make all the CANGURO models the perfect machines for municipality fields as well as agriculture and forestry ones. CANGURO NORMAL / CANGURO NORMAL SUPER is the new heavy duty flail collector mower fitted with heavier hammer flails with special heavy duty bearings advised for those customers that need to shred branches continuously with 8cm diameter.",
            photos: [
              CanguroNormal,
              CanguroNormal1,
              CanguroNormal2,
              CanguroNormal3
            ],
            specifications: []
          },
          {
            variantName: "Canguro Professional",
            imgLink: CanguroProfessional,
            downloadLink: CanguroProfessionalPDF,
            highlight:
              "Heavy Duty Flail Collection Mower For 50 To 60 Tractor Hp.",
            descriptionMain:
              "The grass/pruning shredder Peruzzo mod. CANGURO PROFESSIONAL SUPER is used for grinding high grass and pruning up to 6/7 cm – 2/3 inch. in diameter and the collection and discharge on the ground or in height, by means of hydraulic cylinders. The flail mower with collection mod. CANGURO PROFESSIONAL SUPER performs a clean cut of grass and pruning that make it prefect for a use in public and roads areas, in agricultural and wooded areas with drastic reduction in maintenance time. The unloading of the shredded product with Canguro can be done at a 2 meters height depending on the tractor model. The flail mower with collection mod. CANGURO PROFESSIONAL SUPER has 1kg hammers each that guarantee a good cut and collection in any condition. This machine is the new model with a robust hammers and shaft with special reinforced bearings for continuous pruning with branches diameters up to 8cm in diameter.",
            photos: [
              CanguroProfessional,
              CanguroProfessional1,
              CanguroProfessional2,
              CanguroProfessional3
            ],
            specifications: []
          }
        ]
      },
      {
        name: "Elephant",
        description:
          "This equipment makes it possible to ensure a constant wood branches and heavy grass cut on rough grounds for a long lasting work. Used on municipality, motorways, airports, agriculture fields as orchards or forestry.",
        imgLink: ElephantMain,
        variants: [
          {
            variantName: "Elephant Super",
            imgLink: ElephantMain,
            downloadLink: ElephantPDF,
            highlight: "Heavy Duty Flail Collection Mower For 90 Tractor HP.",
            descriptionMain:
              "The grass/pruning shredder CANGURO NORMAL / CANGURO NORMAL SUPER is used for a good grass cutting and pruning shredding with brunches up to 5 cm of diameter, collecting all processed products in the same time, discharging it directly to the ground by a hydraulic jack collector opening. Its good performance cut and pruning reduction with consequent collection make all the CANGURO models the perfect machines for municipality fields as well as agriculture and forestry ones. CANGURO NORMAL / CANGURO NORMAL SUPER is the new heavy duty flail collector mower fitted with heavier hammer flails with special heavy duty bearings advised for those customers that need to shred branches continuously with 8cm diameter.",
            photos: [Elephant4, Elephant1, Elephant2, Elephant3],
            specifications: []
          }
        ]
      }
    ]
  },
  {
    name: "Grass Mower Machines",
    type: [
      {
        name: "Motofrog",
        description:
          "The professional self-propelled flail mower PERUZZO MOTOFROG 75 comes with a functional welded and molded steel frame and combines a remarkable amount of innovative technical solutions. These characteristics make this machine the only tractor mower which has 6 different configurations on the same machine.",
        imgLink: MotofrogMain,
        variants: [
          {
            variantName: "Motofrog 75",
            imgLink: Motofrog1,
            downloadLink: MotofrogPDF,
            highlight: "Multi-Functional Walk Behind Mower",
            descriptionMain:
              "The professional self-propelled flail mower PERUZZO MOTOFROG 75 comes with a functional welded and molded steel frame and combines a remarkable amount of innovative technical solutions. These characteristics make this machine the only tractor mower which has 6 different configurations on the same machine. It mounts a standard set of wheels clawed from 16 inch at the rear, and pirouetting and safety locking system operated directly from driver handlebars positioned at the front. All these features make the MOTOFROG 75 unique: 3 types of traction easily interchangeable and, at the same time, 3 types of mowing: flexibility and adaptability are the key words of this new professional flail mower.",
            photos: [Motofrog1, Motofrog2, Motofrog3, Motofrog4],
            specifications: []
          }
        ]
      },
      {
        name: "TEG Special",
        description:
          "The front flail PERUZZO mod. TEG SPECIAL is suitable for front application to tractors from 25/30HP for John Deere, Kubota, Grasshopper, Iseki and Grillo. The grass is perfectly cut, small pruning with simultaneous rolling of the turf.",
        imgLink: TEGSpMain,
        variants: [
          {
            variantName: "TEG Special",
            imgLink: TEGSp1,
            downloadLink: TegSpecialPDF,
            highlight: "Front Flail Peruzzo Mod. Teg Special",
            descriptionMain:
              "The front flail PERUZZO mod. TEG SPECIAL thanks to its high rotor speed and number of knives, reduces the turf wave effect and performs a remarkable mulching action. Thanks to vertical blades, an excellent aeration action is achieved, on gardens, lawns and urban areas, where the cut or ventilated residue is uniformly distributed over the entire cutting width. The cutting adjustment in the PERUZZO front mower mod. TEG SPECIAL takes place on the front wheels with spacers and on the rear roller by means of a bolt and key supplied as standard for millimetric adjustment.",
            photos: [TEGSp1, TEGSp2, TEGSp3, TEGSp4],
            specifications: []
          }
        ]
      },
      {
        name: "Scorpion",
        description:
          "The front flail mower mod. SCORPION is suitable for fitting on front tractor 3 point linkage or A-triangle linkage. It is used for grass cut and verticut on grass sport or municipality courses.",
        imgLink: ScorpionMain,
        variants: [
          {
            variantName: "Scorpion",
            imgLink: Scorpion1,
            downloadLink: ScorpionPDF,
            highlight: "Front Flail Mower",
            descriptionMain:
              "The SCORPION model front flail mower can be fitted to any tractor 540/1000/2000 rpm on PTO, with clockwise or anticlockwise rotation. The front flail mower SCORPION Peruzzo is Engineered to be mounted on light tractors three points or triangle linkage with low power. It is also available the hydraulic engine version suitable for light tractors.",
            photos: [Scorpion1, Scorpion2, Scorpion3, Scorpion4],
            specifications: []
          }
        ]
      },
      {
        name: "FOX",
        description:
          "It is Engineered to be mounted on light tractors three points linkage with low HP power and high PTO shaft linkage position. This machine can be used for grass cut (Mulching) and verticut on grass fields for areation activity.",
        imgLink: FOXMain,
        variants: [
          {
            variantName: "FOX",
            imgLink: FOX1,
            downloadLink: FoxPDF,
            highlight: "Rear Mounted Flail Mower For 15 To 22 Tractor HP",
            descriptionMain:
              "The flail mower mod. FOX is used for grass cut (Mulching) and verticut on grass fields. It is Engineered to be mounted on light tractors three points linkage with low HP power and high PTO shaft linkage position. This flail mower can be fitted on rear tractor three points linkage only, performing an excellent grass cutting (mulching). The flail mower Fox can be fitted with different flails for cutting grass or small branches.",
            photos: [FOX1, FOX2, FOX3, FOX4],
            specifications: []
          },
          {
            variantName: "FOX-S",
            imgLink: FOXSMain,
            downloadLink: FoxS4PDF,
            highlight:
              "Rear Mounted Flail Collection Mower For 18 To 22 Tractor HP.",
            descriptionMain:
              "The new flail mower mod. FOX-S has been engineered following customer’s requests of a light flail mower with manual or hydraulic offset possibility. This machine can be used for grass cut (Mulching) and verticut on grass fields for areation activity. The flail mower FOX-S  is engineered to be mounted on light tractors three points linkage with low HP power and with high PTO shaft linkage position. This flail mower can be fitted on rear tractor three points linkage only, performing an excellent grass cutting (mulching).The flail mower Fox can be fitted with different flails for cutting grass or small branches",
            photos: [FOXS1, FOXS2, FOXS3, FOXS4],
            specifications: []
          },
          {
            variantName: "MOTOFOX",
            imgLink: MotoFOXMain,
            downloadLink: MotoFoxPDF,
            highlight: "Self-Propelled Flail Mower For Quad Or Atv.",
            descriptionMain:
              "The slope flail mowers Peruzzo mod. FOX Cross grass/pruning shredder is used for grass cutting and pruning cutting up to 4-5 cm of diameter. This model is mainly used on municipality and agriculture fields to cut high grass, branches and bushes on banks, slopes, embankments, ditches or hedges, bending from +90% to –50% for small and medium tractor size (from 35 HP to 50 HP), with 3-point hitch category 1 and 2. The FOX Cross flail mowers has an articulated arm with hydraulic movement, controlled by the tractor seat, that can move from the center of the tractor to a maximum 130 cm lateral extension, cutting easily grass on ditches or hedges.",
            photos: [MotoFOX1, MotoFOX2, MotoFOX3, MotoFOX4],
            specifications: []
          },
          {
            variantName: "FOX Cross",
            imgLink: FOXCrossMain,
            downloadLink: FoxCrossPDF,
            highlight: "Self-Propelled Flail Mower For Quad Or Atv.",
            descriptionMain:
              "The self-propelled flail mower mod. MOTOFOX is used for grass cut, small branches shred and verticut/aeration on sport, municipality and agriculture fields. This machine is engineered to be mounted on rear side of QUAD or ATV an it is equipped with petrol Honda engine 11/16hp, rear roller and rear transport wheels of easy adjustment. The self-propelled flail mower MOTOFOX has a towing bar shifting the mower for side cutting even one meter outside the ATV roadway.Special feature of Peruzzo is the fine grass cutting due to the overlapping flails quantity and high flail shaft rpm rotation.",
            photos: [FOXCross1, FOXCross2, FOXCross3, FOXCross4],
            specifications: []
          }
        ]
      },
      {
        name: "PUMA",
        description:
          "The PUMA flail mower is used for cutting grass (mulching), small pruning cut (max. 2 cm of diameter) and for verticut action on grass fields. Engineered for working on wide grass areas. The same machine can be fitted on front or rear tractor 3 points linkage.",
        imgLink: PumaMain,
        variants: [
          {
            variantName: "PUMA",
            imgLink: Puma1,
            downloadLink: PumaPDF,
            highlight: "Front And Rear Flail Mower For 25 To 40 Tractor Hp.",
            descriptionMain:
              "The PUMA flail mower is used for cutting grass (mulching), small pruning cut (max. 2 cm of diameter) and for verticut action on grass fields. Engineered for working on wide grass areas. The same machine can be fitted on front or rear tractor 3 points linkage.",
            photos: [Puma1, Puma2, Puma3, Puma4],
            specifications: []
          }
        ]
      },
      {
        name: "ELK",
        description:
          "The ELK flail mower is used for cutting grass (mulching), small pruning cut (max. 2 cm of diameter) and for verticut action on grass fields. Engineered for working on wide grass areas. The same machine can be fitted on front or rear tractor 3 points linkage.",
        imgLink: ELKMain,
        variants: [
          {
            variantName: "ELK",
            imgLink: ELK1,
            downloadLink: ElkPDF,
            highlight: "Front And Rear Flail Mower For 25 To 40 Tractor HP.",
            descriptionMain:
              "The ELK flail mower is used for grass cutting and small pruning reduction of 1-3 cm in diameter on grass lands. This machine is used on front or rear tractor three points linkage with side offset possibility and it has been engineered for a use on wide areas to reduce grass in small pieces (mulching).",
            photos: [ELK1, ELK2, ELK3, ELK4],
            specifications: []
          },
          {
            variantName: "ELK Cross",
            imgLink: ELKCrossMain,
            downloadLink: ElkCrossPDF,
            highlight: "Trincia Argini Per Trattori Da 35-45CV",
            descriptionMain:
              "The slope flail mowers Peruzzo mod. FOX Cross grass/pruning shredder is used for grass cutting and pruning cutting up to 4-5 cm of diameter. This model is mainly used on municipality and agriculture fields to cut high grass, branches and bushes on banks, slopes, embankments, ditches or hedges, bending from +90% to –50% for small and medium tractor size (from 35 HP to 50 HP), with 3-point hitch category 1 and 2. The FOX Cross flail mowers has an articulated arm with hydraulic movement, controlled by the tractor seat, that can move from the center of the tractor to a maximum 130 cm lateral extension, cutting easily grass on ditches or hedges.",
            photos: [ELKCross1, ELKCross2, ELKCross3, ELKCross4],
            specifications: []
          },
          {
            variantName: "ELK Cross Front",
            imgLink: ELKCrossFMain,
            downloadLink: ElkCrossFrontPDF,
            highlight:
              "The Elk Cross Front Slope Flail Mower Is Applicable To Compact Tractors From 50 To 70 HP.",
            descriptionMain:
              "The slope flail mower Peruzzo mod. ELK Cross  FRONT for small and medium power tractors, it is mounted at the front on reversible tractors or tractors equipped with the front PDF. Used for grinding grass and prunings with a diameter of 3-4 cm, the ELK CROSS FRONT  slope flail mower is used for both maintenance work and public areas, highways, cutting, hedges, ditches, embankments. This frontal configuration makes it easier for the operator to control the machine during the cutting operation or moving around obstacles, such as poles, trees, guardrails, up to a vertical use of the machine from +90° to -50°. It is also a medium-light machine that adapts to category 1 and 2 3-point hitch tractors and is applicable to compact tractors from 50 to 70 hp. The ELK CROSS FRONT  slope flail mower with its articulated arm with hydraulic movement controlled by the tractor controls can move from the center of the tractor to the maximum lateral extension, operating safely for cutting grass in ditches or reducing hedges, tall grass or various prunings.",
            photos: [ELKCrossF1, ELKCrossF2, ELKCrossF3, ELKCrossF4],
            specifications: []
          }
        ]
      },
      {
        name: "Bull",
        description:
          "Thanks to its versatility, can be used in combination with tractors of minimum power of 70 HP, for the cleaning of green areas (parks, airports, highways, ditches ...), for the crushing of prunings in orchards and vineyards, as well as for scrub clearance on wooded land or uncultivated. The use of strong hammers, specifically created for this model, allows to obtain a defibrated and finely chopped residue even with prunings of 5/7 cm in diameter.",
        imgLink: BullMain,
        variants: [
          {
            variantName: "Bull Cross",
            imgLink: BullCross1,
            downloadLink: BullCrossPDF,
            highlight:
              "Heavy Duty Rear Mounted Flail Mower For 70 To 90 Tractor HP",
            descriptionMain:
              "The BULL CROSS REAR SHREDDER, thanks to its versatility, can be used in combination with tractors of minimum power of 70 HP, for the cleaning of green areas (parks, airports, highways, ditches ...), for the crushing of prunings in orchards and vineyards, as well as for scrub clearance on wooded land or uncultivated. The use of strong hammers, specifically created for this model, allows to obtain a defibrated and finely chopped residue even with prunings of 5/7 cm in diameter. The BULL CROSS REAR SHREDDER PERUZZO is easily adapted to heavy work on high grass, pruning or uneven and sloping terrain in the presence of stones or other residues. Unlike other models, this specific one is equipped with a wider track that allows a greater cutting width, from 1.80 mt to 2.20 mt.The REAR SHREDDER AND FLAIL MOWER PERUZZO mod. BULL CROSS 1800-2000-2200 applied to tractors of adequate power performs a cut of grass, hedges and shrubs reducing the residue for a consequent and fast decomposition. The version CROSS in fact is characterized by a robust structure and equipped with lateral displacement, folding from +90% to -65%. It is also equipped with ANTI-SHOCK valve to absorb accidental blows to the machine.",
            photos: [BullCross1, BullCross2, BullCross3, BullCross4],
            specifications: []
          },
          {
            variantName: "Bull Super",
            imgLink: BullSuper1,
            downloadLink: BullSuperPDF,
            highlight:
              "Heavy Duty Rear Mounted Flail Mower For 30 To 130 Tractor HP.",
            descriptionMain:
              "The BULL SUPER rear shredder is a versatile machine thanks to its multiple uses. It can be used for cleaning green areas (parks, airports, highways ...), the shredding of shoots in the orchards and vineyards, as well as for clearing on woodlands or meadows and with tractors with a minimum power of 30 hp. The use of robust hammers makes it possible to obtain a very finely ground product even on stony ground and with hardwood shoots. The use of robust hammers, specifically created for this model, allows to obtain a defibrated and finely chopped residue even with prunings of 5/6 cm of diameter.  The BULL SUPER rear shredder easily adapts to heavy work on high grass, pruning or rough terrain in the presence of stones or other debris and unlike other models, it has specific components that allow a wider cutting width that ranges from 1.20 m to 2.80 m. The BULL SUPER rear shredder has been applied to tractors of medium power performing a cut of grass and shrubs reducing the residue for a consequent and rapid decomposition.  The Super version is characterized by an even more robust structure and a system that makes it easier to use it in case of frequent lateral movements.  You can apply to the BULL SUPER certain accessories to facilitate the mowing of grass around the plant by the hydraulic contouring machine and the hydraulic pistons for lateral movement.  On request, it can be sold with a version with 3 connection points, excellent solution to obtain an efficient and precise work in case of lateral displacement of the contents.",
            photos: [BullSuper1, BullSuper2, BullSuper3, BullSuper4],
            specifications: []
          },
          {
            variantName: "Bull Reverse",
            imgLink: BullReverse1,
            downloadLink: BullReversePDF,
            highlight:
              "Grass/Pruning Shredder For Tractors Between 50 To 100 HP.",
            descriptionMain:
              "The grass/pruning shredders BULL REVERSE is used for shredding grass and prunings with a diameter of 4-5 cm. This machine with closed hood is used for maintenance work near public areas, highways and for the high reduction of the shredded material, as well as for shredding and consecutive rear ejection of the product increasing the speed of operation and mulching. The BULL REVERSE MULCHER are used on extensive crops such as grinding of corn stalks, cotton, vineyards and orchards. They’re supplied with 1.6 kg hammers each, rear roller adjustable in height, belt adjustment with tensioner, 3-point hitch category 1 and 2, 540 rpm multiplier with double free wheel, hydraulic piston movement and a reinforced body with double sheet of reinforcement of 5mm thick on the working area. At customer's request the cardan shaft and the central 3-point linkage, equipped with lateral displacement of the same size for both sides.",
            photos: [BullReverse1, BullReverse2, BullReverse3, BullReverse4],
            specifications: []
          }
        ]
      },
      {
        name: "ROTO",
        description:
          "The hydraulic rotary mower mod. ROTO BULL - mounts an oil tank and a hydraulic engine plus a blade disk that is manufactured according to CE norms for the underfoliage cutting on road or photovoltaic systems.",
        imgLink: ROTOMain,
        variants: [
          {
            variantName: "ROTO",
            imgLink: ROTO1,
            downloadLink: RotoPDF,
            highlight:
              "Косилка Для Газонов И Веток Для Тракторов От 30 Л.С. До 100 Л.С.",
            descriptionMain:
              "The hydraulic rotary mower mod. ROTO BULL - mounts an oil tank and a hydraulic engine plus a blade disk that is manufactured according to CE norms for the underfoliage cutting on road or photovoltaic systems. The blades of the disc have a return-plate system that prevents the blades from touching the ground. In case of cutting around the base of small plants, the return system of the mower is regulated by springs. The cutting height is easily adjustable from 3 to 10 cm. It is available in different versions depending on the use required: ROTO HYDRO: specially designed for loaders with power between 40 and 65 liters/min., available with special connection on request for different types of wheel loaders and equipped with anti-shock and anti-avitation valve system with free-wheel, in order to prevent a damage during sudden increases of pressure inside the hydraulic engine. The Roto-Hydro coupled with a Loader is a compact equipment ideal for the maintenance of the grass along the roads as it is not cumbersome and easily manoeuvertable. ROTO PTO: equipped with oil tank and hydraulic engine. It is ideal in presence of tractors of minimum 18 hp. The Roto PTO can be applied to the 3-point coupling of the tractor and has an autonomous oil pump. In this way the ROTO PTOcan be moved sideways to easily reach difficult cutting areas as under canopy in orchards or solar panels. ROTO BULL: hydraulic mower with independent hydraulic system and suitable for the shredder Peruzzo Mod. BULL.",
            photos: [ROTO2, ROTO5, ROTO3, ROTO4],
            specifications: []
          }
        ]
      },
      {
        name: "Triflex",
        description:
          "The flail mower mod. TRIFLEX is a machine with a wide cutting width of 420 or 500 cm. This model has an innovative double-jointed system, made of 3 independent flail decks, that allows mowing on any uneven ground without damaging the turf making it unique among the 3-unit horizontal cutting machines.",
        imgLink: TRIFLEXMain,
        variants: [
          {
            variantName: "Triflex",
            imgLink: TRIFLEX1,
            downloadLink: TriflexPDF,
            highlight:
              "Trinciaerba Universale Multipla Posteriore Per Trattori Da 80 A 90 HP",
            descriptionMain:
              "The flail mower mod. TRIFLEX is a machine with a wide cutting width of 420 or 500 cm. This model has an innovative double-jointed system, made of 3 independent flail decks, that allows mowing on any uneven ground without damaging the turf making it unique among the 3-unit horizontal cutting machines. The cutting height is adjusted, millimetrically, on each machine by the rear roller and on the side shredders by the front wheels Various models of knives are available depending on the intended use, such as Y knives for mulching on public parks, light delta knives for sports surfaces or heavy hammers for rough areas with pruning up to 3 cm in diameter and verticut knives for aerating turf. The gang flail mower mod. TRIFLEX performs mulching cut and uniform grass distribution on each pass. Some robust hydraulic cylinders lift mowing decks up to a total width of 225 cm for transport in complete safety. This machine is used by contractors for cutting large public or sports areas. Used by Airports, Golf Courses or large grass surfaces for fast maintenance where grass must be quickly absorbed from the ground. The flail mower mod. TRIFLEX has got a special PATENTED electro-hydraulic accessory that can be installed on request, used by public amenities personnel, which allows the lateral decks to be lifted and automatically blocking the flail shaft in 3 seconds so as to overcome any obstacles present during cutting in complete safety and fast way.",
            photos: [TRIFLEX5, TRIFLEX2, TRIFLEX3, TRIFLEX4],
            specifications: []
          }
        ]
      }
    ]
  },
  {
    name: "Remote Controlled Grass Mower",
    type: [
      {
        name: "Robofox",
        description:
          "The self-propelled remote-controlled flail mower Peruzzo mod. ROBOFOX ELECTRA, a top-notable novelty in the world of professional shredding, is equipped with FULL ELECTRIC propulsion, for both the advancement and for the drive of the cutting roller shaft.",
        imgLink: RobofoxMain,
        variants: [
          {
            variantName: "Robofox Electric",
            imgLink: RobofoxMain,
            downloadLink: RobofoxElectricPDF,
            highlight:
              "Full Electric Self-Propelled Remote-Controlled Flail Mower Mod. Robofox Electra",
            descriptionMain:
              "The self-propelled remote-controlled flail mower Peruzzo mod. ROBOFOX ELECTRA, a top-notable novelty in the world of professional shredding, is equipped with FULL ELECTRIC propulsion, for both the advancement and for the drive of the cutting roller shaft. Equipped with 48 sturdy Y-knives or, optionally, 24 forged hammers, it is the ideal machine to cut grass and shrubs up to 2/3cm in diameter and brush on steep slopes: all in full respect of the surrounding environment. The powerful batteries supplied with the ROBOFOX ELECTRA, guarantee a range of about 2/3 hours (in relation to working conditions), without any emission of fumes in the atmosphere, nor of noise pollution, in absolute silence at all stages of work. An additional battery pack is easily replaceable, allowing the machine's working range to double. These prerogatives allow a widespread use in urban areas, where there is an increasing demand for a low sound impact and a precise compliance with anti-pollution regulations, which are now more stringent than ever before. The self-propelled remote-controlled flail mower Peruzzo mod. ROBOFOX ELECTRA is operated through an easy-to-use multifunction radio control, with a range of up to 300 meters and adjusted according to the CE safety frequencies. This allows the operator to always work in maximum safety.In optimal ground conditions, the work inclination achievable by the machine during the work phases is 55°. For every extreme need, a sophisticated electronic slope tilt sensor is available on demand that manages the limit tilt level, preventing the machine from tipping over. This machine comes with a standard safety rollbar added in order to preserve the most delicate components in the event of a rollover. La ROBOFOX ELECTRA is equipped with a drift control system, always managed comfortably by the remote control, which ensures its linear progress in the phases of work, even in the presence of slippery slopes. The compact dimensions of the ROBOFOX ELECTRA lead it to be the perfect solution in the phases of work in small spaces, such as for mowing the grass under solar panels, in the presence of narrow access, in particularly inclined areas or of poor access. The volumes and size of the flail mower allow a smooth loading-discharge on vans and pick-ups of different types. If you have any doubts and/or clarification regarding the ROBOFOX ELECTRA, don't hesitate to contact us directly.",
            photos: [
              RobofoxElectric1,
              RobofoxElectric2,
              RobofoxElectric3,
              RobofoxElectric4
            ],
            specifications: []
          },
          {
            variantName: "Robofox Hybrid",
            imgLink: RobofoxHybridMain,
            downloadLink: RobofoxHybridPDF,
            highlight:
              "Self-Propelled Remote-Controlled Flail Mower Robofox Hybrid",
            descriptionMain:
              "The self-propelled remote-controlled flail mower Peruzzo mod. ROBOFOX HYBRID, a top-notable novelty in the world of professional shredding, is equipped with a 28CV engine branded Briggs&Stratton with special oil tank that not only guarantees a job in slopes of more than 45 degrees, but also allows a limited overheating, stretching up to 5 times the duration of the engine oil. This powered engine moves the 900mm-wide hammer cutting shaft. At the same time, the self-propelled remote controlled flail mower mod. ROBOFOX HYBRID takes advantage of the propulsion provided by two other powerful brushless electric motors. These engines are constantly powered by two other batteries, which are connected to a generator that takes the motion from the endothermal engine. The two powerful buffer batteries supplied to the ROBOFOX HYBRID machine, however, guarantee the ability to move the machine for 2 KM even without the ignition of the thermal engine. Equipped with 48 sturdy Y-knives or, optionally, 24 forged hammers, it is the perfect machine to cut grass and shrubs up to 2/3cm in diameter, as well as brush on steep slopes: all in total respect of the surrounding environment. This function permits to the operator to move the machine indoors without breathing in exhaust fumes, as well as the solution of returning the machine to its base in case of any failure of the thermal engine. The self-propelled remote-controlled flail mower Peruzzo mod. ROBOFOX HYBRID is operated through an easy-to-use multifunction radio control, with a range of up to 300 meters and adjusted according to the CE safety frequencies. This allows the operator to always work in maximum safety. In optimal ground conditions, the work inclination achievable by the machine during the work phases is 45 degrees. For each extreme need, a sophisticated electronic slope tilt sensor is available on demand that manages the limit tilt level, preventing the machine from tipping over. In addition, a standard safety rollbar is added in order to preserve the most delicate components in the event of a rollover. The compact dimensions of the ROBOFOX HYBRID make it the perfect solution to work in small spaces, such as mowing the grass under solar panels, in the presence of narrow access, in particularly inclined areas or of poor access. The volumes and size of the flail mower allow a smooth loading-discharge on vans and pick-ups of different types.",
            photos: [
              RobofoxHybrid1,
              RobofoxHybrid2,
              RobofoxHybrid3,
              RobofoxHybrid4
            ],
            specifications: []
          }
        ]
      }
    ]
  },
  {
    name: "Litter Collection Equipment",
    type: [
      {
        name: "Vacuum Units",
        description:
          "The vacuum machine mounted to your tractor. Starting from a 40HP PTO, this is a very powerful machine.",
        imgLink: PTO570Main,
        variants: [
          {
            variantName: "521M",
            imgLink: M5211,
            downloadLink: "NemoDownloadLink",
            highlight:
              "A Reliable Vacuum Machine Always Ready When You Need It.",
            descriptionMain:
              "It's compact, easy to mount onto a trailer or pickup, and designed for convenience. This professional vacuum unit features tool-free setup and breakdown, a durable fan and casing, a professional Honda GX petrol engine with oil control, and an indirect drive train with a v-belt to protect the engine from unexpected fan obstructions. The Votex 521M – Always ready to go.",
            photos: [M5211],
            specifications: []
          },
          {
            variantName: "525M",
            imgLink: M5251,
            downloadLink: "NemoDownloadLink",
            highlight:
              "A Portable Vacuum Machine That Can Be Easily Attached And Taken To Any Job Location.",
            descriptionMain:
              "The 525M shares the same features as the 521M but is mounted on a fast-traffic carrier with large wheels and a spring shaft for a safe ride. It is equipped with a rotatable blow bend and directional valve to direct materials into containers, trailers, or over fences and ditches. The vertically adjustable ball coupling allows for easy attachment to cars, trucks, or tractors. The Votex 521M vacuum unit is a reliable, compact, and easy-to-mount machine designed for convenience. It features tool-free setup and breakdown, a durable fan and casing, a professional Honda GX petrol engine with oil control, and an indirect drive train with a V-belt for engine protection against unexpected fan obstructions. Always ready to go - the Votex 521M.",
            photos: [M5251],
            specifications: []
          },
          {
            variantName: "541M",
            imgLink: M541Main,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Easy To Mount On A Trailer Or Pick Up Truck. It Is Equipped With A 20hp Honda Gx Petrol Engine With Electric Start.",
            descriptionMain:
              "Introducing the powerful 541M Vacuum Unit, designed for heavy-duty operations. With its 20hp Honda GX petrol engine and high vacuum capacity, this professional vacuum unit is the ultimate choice for top performance. Its durable construction, V-belt drive, and hardox® turbine and housing make it reliable and long-lasting. Mount it on a trailer or pick-up truck for easy transportation. Choose the Votex 541M for a commercial-grade solution that delivers exceptional results every time.",
            photos: [M541Main],
            specifications: []
          },
          {
            variantName: "546M",
            imgLink: M546Main,
            downloadLink: "NemoDownloadLink",
            highlight:
              "All The Qualities Of Our Vacuum Machines Are United In One Machine. The Convenience Of The 525m And The Capacity Of The 541.",
            descriptionMain:
              "The 546 M vacuum unit, mounted on a fast traffic carrier, is powered by a professional GX 2 cylinder Honda petrol engine with electric start and oil control. It features a rotatable blow bend and a 5-meter transparent suction hose. This portable unit can be taken to any location, making it ideal for unexpected cleaning activities that require fast results. The Votex 546M. Always ready for action.",
            photos: [M546Main],
            specifications: []
          },
          {
            variantName: "570PTO",
            imgLink: PTO5701,
            downloadLink: "NemoDownloadLink",
            highlight:
              "The vacuum machine mounted to your tractor. Starting from a 40HP PTO, this is a very powerful machine. The fan and the manganese steel casing assure a long life.",
            descriptionMain:
              "The rotatable blow bend makes this machine very versatile. The robust three point frame is the undercarriage for the machine at the same time. The Votex 570PTO. Best possible performance at least possible.",
            photos: [PTO5702, PTO5703],
            specifications: []
          }
        ]
      },
      {
        name: "Turf Rake",
        description:
          "The TURF RAKE stone picker removes stones from scarified soil and expedites a variety of turf restoration & grooming processes. Adapted from the same tine-raking technology as the proven SURF RAKE, the TURF RAKE is a fast and effective stone picker for medium to large areas, like horse arenas, golf course developments, and farms. The TURF RAKE stone picking machine excels at removing rock and debris from soil to prepare it for multiple applications. Among its stone picking applications the TURF RAKE facilitate horse track and arena maintenance, golf course creation, farm seed bed preparation, and strafing range munitions removal.",
        imgLink: Model600HDMain,
        variants: [
          {
            variantName: "Model 400 Turf Rake",
            imgLink: Model400Main,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Stones 3/8 In. (,95 Cm)  to 4 In. (10 Cm) In Diameter, Sod, Roots, Wood, Branches And Broken Glass.",
            descriptionMain:
              "DIMENSIONS: H: 1.4 m, L: 3.0 m, W: 2.3 m. WEIGHT: Approximately 860 kg. CLEANING WIDTH: 1.8 m. CLEANING DEPTH: Adjustable to 15 cm. OPERATING SPEED: 1 to 8 km/hr. DEBRIS REMOVED: Stones 3/8 in. (0.95 cm) to 4 in. (10 cm) in diameter, sod, roots, wood, branches, and broken glass. PERFORMANCE: Cleans up to 8,093 m² per hour. HOPPER: 0.75 cubic meters (1,100 kg capacity). DUMP HEIGHT: Ground. CONVEYOR: Bar flight type, covered with a continuous 1.2 m-wide belt, with stainless steel spring tines mounted on it. HYDRAULIC DRIVE: Completely sealed and protected by the full flow filter. Large capacity spline mounted pump, hydraulic motor, flow control, and built-in overflow protection. HYDRAULIC FLOW: 45 L per minute. HYDRAULIC CAP: 42 L. CYLINDERS: Trip: 3.8 cm x 25 cm single-acting. PAINT: Dupont IMRON Polyurethane enamel. TRACTOR: 25 PTO horsepower agricultural type tractor. OTHER TRACTOR REQUIREMENTS: 540 RPM rear PTO, 3-point hitch, and remote hydraulic valve with raise, hold, and float positions. This is a general guideline. Larger or smaller tractors may be used depending on soil conditions.",
            photos: [Model4001, Model4002, Model4003, Model4004],
            specifications: []
          },
          {
            variantName: "Model 400HD Turf Rake",
            imgLink: Model400HDMain,
            downloadLink: "NemoDownloadLink",
            highlight: "Cleans up to 2 acres (8,093 m2) per hour",
            descriptionMain:
              "DIMENSIONS: H: 2.3 m, L: 3.6 m, W: 2.3 m. WEIGHT: Approximately 1,225 kg. CLEANING WIDTH: 1.8 m. CLEANING DEPTH: Adjustable to 15 cm. OPERATING SPEED: 1 to 8 km/hr. DEBRIS REMOVED: Stones 3/8 in. (0.95 cm) to 4 in. (10 cm) in diameter, sod, roots, wood, branches, and broken glass. PERFORMANCE: Cleans up to 2 acres (8,093 m²) per hour. HOPPER: 1.52 cubic meters (1,600 kg capacity). DUMP HEIGHT: 2.75 m. CONVEYOR: Bar flight type, covered with a continuous 4 ft (1.2 m)-wide belt, with stainless steel spring tines mounted on it. HYDRAULIC DRIVE: Completely sealed and protected by the full flow filter. Large capacity spline mounted pump, hydraulic motor, flow control, and built-in overflow protection. HYDRAULIC FLOW: 45 L per minute. HYDRAULIC CAP: 42 L. CYLINDERS: Lift: 8.9 cm x 45.7 cm single-acting, Trip: 5 cm x 13 cm single-acting. PAINT: Dupont IMRON Polyurethane enamel. TRACTOR: 30 PTO horsepower agricultural type tractor. OTHER TRACTOR REQUIREMENTS: 540 RPM rear PTO, 3-point hitch, and remote hydraulic valve with raise, hold, and float positions. This is a general guideline. Larger or smaller tractors may be used depending on soil conditions.",
            photos: [Model400HD1, Model400HD2, Model400HD3, Model400HD4],
            specifications: []
          },
          {
            variantName: "Model 600HD Turf Rake",
            imgLink: Model600HDMain,
            downloadLink: "NemoDownloadLink",
            highlight:
              " covered with continuous 6 ft (1,8 m) -wide belt, with stainless steel spring tines mounted on it.",
            descriptionMain:
              "DIMENSIONS: H: 2.3 m, L: 4.0 m, W: 2.3 m. WEIGHT: Approximately 1,800 kg. CLEANING WIDTH: 2.14 m. CLEANING DEPTH: Adjustable to 15 cm. OPERATING SPEED: 8 km/hr. DEBRIS REMOVED: Stones 3/8 in. (0.95 cm) to 4 in. (10 cm) in diameter, sod, roots, wood, branches, and broken glass. PERFORMANCE: Cleans up to 3 acres (12,140 m²) per hour. HOPPER: 2.3 cubic meters (2,000 kg capacity). DUMP HEIGHT: 9 ft (2.75 m). CONVEYOR: Bar flight type, covered with a continuous 6 ft (1.8 m)-wide belt, with stainless steel spring tines mounted on it. HYDRAULIC DRIVE: Completely sealed and protected by the full flow filter. Large capacity spline mounted pump, hydraulic motor, flow control, and built-in overflow protection. HYDRAULIC FLOW: 12 gal (45 L) per minute. HYDRAULIC CAP: 16 gal (61 L). CYLINDERS: Lift: 3.5 in. x 18 in. single-acting (8.9 cm x 45.7 cm single-acting), Trip: 2 in. x 5 in. single-acting (5 cm x 13 cm single-acting). PAINT: Dupont IMRON Polyurethane enamel. TRACTOR: 45 PTO horsepower agricultural type tractor. OTHER TRACTOR REQUIREMENTS: 540 RPM rear PTO, 3-point hitch, and remote hydraulic valve with raise, hold, and float positions. This is a general guideline. Larger or smaller tractors may be used depending on soil conditions.",
            photos: [Model600HD1, Model600HD2, Model600HD3, Model600HD4],
            specifications: []
          }
        ]
      },
      {
        name: "Model LP1",
        description:
          "The Litter Picker helps grounds maintenance teams clean large venues or longs stretches of grass, soil, or pavement faster than ever before. A tine-lined conveyor belt removes debris as large as full garbage bags and as small as cigarette butts with ease.",
        imgLink: ModelLP1Main,
        variants: [
          {
            variantName: "Model LP1",
            imgLink: ModelLP11,
            downloadLink: "NemoDownloadLink",
            highlight: "Clean Up Trash Quickly With The Litter Picker",
            descriptionMain:
              "The LITTER PICKER Model LP1 is completely operated by one person from the seat of the towing tractor. The LP1 is connected to the tractor via a three-point hitch, which allows the driver to adjust the machine from the comfort of the tractor’s cab. A PTO-powered hydraulic line powers the LITTER PICKER’s conveyor belt, and two hydraulic hoses use the tractor’s hydraulic oil to raise and trip the bucket. Setup takes only a few minutes, and operation is simple, intuitive, and safe.",
            photos: [ModelLP11, ModelLP12, ModelLP13, ModelLP14],
            specifications: []
          }
        ]
      },
      {
        name: "Road Rake",
        description:
          "The Barber ROAD RAKE is specifically designed to remove large debris that usually requires human labor. It is a safe and efficient way to remove large debris from roadways, parks, parking lots, bridges, after automobile accidents and along curbs and Jersey barriers. Operated electronically by one person from the cab of the towing unit, the the Barber ROAD RAKE collects large road hazards: retreads, mufflers, wood and litter. It is designed to collect the large debris, which might clog or damage street sweepers.",
        imgLink: RR200TMain,
        variants: [
          {
            variantName: "Road Rake Model 200",
            imgLink: RR2001,
            downloadLink: "NemoDownloadLink",
            highlight:
              "19 HP water-cooled engine powers the hydraulic motors that turns two gutter brushes and the conveyor belt.",
            descriptionMain:
              "The Model 200 is Barber’s independently-powered ROAD RAKE. A 19 hp water-cooled engine powers the hydraulic motors that turns two gutter brushes and the conveyor belt. It also powers the cylinders that lift up to 1900 lbs. of debris in the hopper to dumping height. Because it does not require an outside hydraulic power source, the Model 200 Road Rake can be paired with any truck that weighs more than one ton and is equipped with a pintle hitch.",
            photos: [RR2001, RR2002, RR2003, RR2004],
            specifications: []
          },
          {
            variantName: "Road Rake Model 200T",
            imgLink: RR200T1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Excellent Option For Operators That Have Access To A Towing Vehicle With Rear Hydraulic Ports",
            descriptionMain:
              "The Model 200T is Barber’s truck-powered ROAD RAKE. The rear remote hydraulic valves of the towing truck power all the hydraulic functions of the ROAD RAKE 200T. It is an excellent option for operators that have access to a towing vehicle with rear hydraulic ports. The Barber ROAD RAKE is specifically designed to remove large debris that usually requires human labor. It is a safe and efficient way to remove large debris from roadways, parks, parking lots, bridges, after automobile accidents and along curbs and Jersey barriers.",
            photos: [RR200T1, RR200T2, RR200T3, RR200T4],
            specifications: []
          }
        ]
      },
      {
        name: "ROTOVAC",
        description:
          "The Barber ROTOVAC is specifically designed to remove large debris that usually requires human labor. It is a safe and efficient way to remove large debris from roadways, parks, parking lots, bridges, after automobile accidents and along curbs and Jersey barriers. Operated electronically by one person from the cab of the towing unit, the the Barber ROTOVAC collects large road hazards: retreads, mufflers, wood and litter. It is designed to collect the large debris, which might clog or damage street sweepers.",
        imgLink: RotovacMain,
        variants: [
          {
            variantName: "ROTOVAC 1600",
            imgLink: Rotovac1,
            downloadLink: "NemoDownloadLink",
            highlight: "Sweeper Collector For Communal And Sport Grounds",
            descriptionMain:
              "The Sweeper Collector Rotovac 1600 is a collector for leaves and any type of product waste. The catcher of this machine has a capacity of 1800 litres hydraulic discharge. Its collecting capacity is adjustable thanks to a special engineered frame that adapts to product quantity. The hydraulic engine side cleaning brush can be added on request.",
            photos: [Rotovac5, Rotovac2, Rotovac3, Rotovac4],
            specifications: []
          }
        ]
      },
      {
        name: "Vacuum Machine",
        description:
          "The Vacuum leaves and debris loader turbo 400 is a vacuum grass and leaves machine used for cleaning places where entrance is not permitted with others equipment. This vacuum model can be placed on truck sides or mounted on tractor 3 points linkage.",
        imgLink: Turbo400Main,
        variants: [
          {
            variantName: "Turbo 400",
            imgLink: Turbo4001,
            downloadLink: "NemoDownloadLink",
            highlight: "Professional Vacuum Grass And Leaves Machine.",
            descriptionMain:
              "The Vacuum leaves and debris loader turbo 400 is a vacuum grass and leaves machine used for cleaning places where entrance is not permitted with others equipment. This vacuum model can be placed on truck sides or mounted on tractor 3 points linkage. The TURBO model is equipped with all safety norms as European standards.",
            photos: [Turbo4005, Turbo4002, Turbo4003, Turbo4004],
            specifications: []
          }
        ]
      },
      {
        name: "Vacuum Trailers",
        description:
          "Perfectly suitable to be used in conjunction with flail mowers.",
        imgLink: VT1100Main,
        variants: [
          {
            variantName: "VT420",
            imgLink: VT4201,
            downloadLink: "NemoDownloadLink",
            highlight: "Compact High-Tipping Vacuum Trailer.",
            descriptionMain:
              "The VT420 is a compact vacuum trailer with a high tipping container of 4,2 m3. With a low total weight and a low centre of gravity, this trailer is ideally combined with compact tractors from 45 HP and more. The turbine offers lots of power. Because it is made of durable steel, it has a long life. The VT420 comes standard with a 1,7-meter vacuum funnel with a weight transfer system. Because of this system, the funnel is best capable of following the terrain without damaging it. The VT420 can be equipped with several options like a manual suction pipe, a scarifier and a flail mower. With both the scarifier and the flail mower, the material is collected in the same pass. Therefore, the VT420 is versatile and almost year-round employable. The Votex VT420. Compact size, ",
            photos: [VT4205, VT4202, VT4203, VT4204],
            specifications: []
          },
          {
            variantName: "VT850",
            imgLink: VT8501,
            downloadLink: "NemoDownloadLink",
            highlight: "Robust Vacuum Trailer.",
            descriptionMain:
              "The VT850 offers the same benefits as the VT420 but has more capacity. Looking at the net capacity of 8.5 m3 as well as the 2-meter wide vacuum funnel and the scarification bin (30 cm wider than the VT420), the VT850 beats the VT420. Besides the vacuum funnel and the scarification bin, an oscillating suction hose is an option. The VT850 has a robust, simple and functional construction. The collecting part has a French rear door provided with an automatic opening system. The rear door is double-walled. The pump and pump casing are made of longwearing manganese steel. The Votex VT850. The all-rounder amongst the vacuum trailers.",
            photos: [VT8505, VT8502, VT8503, VT8504],
            specifications: []
          },
          {
            variantName: "VT1100",
            imgLink: VT11001,
            downloadLink: "NemoDownloadLink",
            highlight: "Large Vacuum Trailer.",
            descriptionMain:
              "With 11m3, the Votex VT1100 has the biggest net capacity of all Votex vacuum trailers. The VT1100 can be provided with the same options as the VT850. The larger volume makes it perfectly suitable to be used in conjunction with flail mowers. The amount of unloading moments decreases with no less than 30% compared to the VT850. The Votex VT1100. Beats all the others.",
            photos: [VT11002],
            specifications: []
          }
        ]
      }
    ]
  },
  {
    name: "Wood Chipper Machines",
    type: [
      {
        name: "T Series",
        description:
          "Used to reduce vegetable waste for professional use from 8 to 15 m3/hour.",
        imgLink: T5Main,
        variants: [
          {
            variantName: "Chipper Shredder T3",
            imgLink: T3Main,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Chipper/Shredder For Chipping Up To 8 Cm In Diameter And Ground Discharge.",
            descriptionMain:
              "The CHIPPER SHREDDER MOD. T3 is used to reduce green waste for private or professional needs of small branches quantities each time of use (up to 8 m³/hour).",
            photos: [T31, T32, T33, T34],
            specifications: []
          },
          {
            variantName: "Chipper Shredder T5",
            imgLink: T5Main,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Chipper/Shredder For Chipping Up To 10 Cm In Diameter And Ground Discharge.",
            descriptionMain:
              "The CHIPPER SHREDDER mod. T5 and T5 with belt conveyer is a sturdy machine used to reduce green waste for professional needs. It uses a chipping disk to reduce branches up to 10 cm of diameter and a shredding hammer group for smaller branches up to 3 cm of diameter. The T5 model is available with ground or high discharge (production up to 12 m3/hour). The obtained biomass from T5 is useful for composting, providing wood boilers and producing briquettes or pellets.",
            photos: [T51, T52, T53, T54],
            specifications: []
          }
        ]
      },
      {
        name: "TB Series",
        description:
          "This chipper is used to reduce pruning with many branches and foliage where the hydraulic roller makes it easy to drag it to the cutting drum.",
        imgLink: TB120CProMain,
        variants: [
          {
            variantName: "Chipper TB 50",
            imgLink: TB50Main,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Bio-Shredder/Drum Chipper For Pruning Up To 7 Cm In Diameter.",
            descriptionMain:
              "The bio-shredder/chipper PERUZZO mod. TB50 is a drum model suitable for cutting dry branches up to 5 – 6 cm in diameter and wet branches up to 6- 7 cm. Intended mainly for private users, renters and small green maintainers, it is the ideal machine for shredding small pruning, while maintaining a high work productivity. The cutting drum available to the machine is made up of two high-strength blades, reversible and to which is then added a control blade also in tempered steel. Depending on the processed product, this is expelled from the chipper's unloading mouth at a height of 142 cm and 2/3 meters away, thus facilitating the unloading inside boxes or special containers.",
            photos: [TB501, TB502, TB503, TB504],
            specifications: []
          },
          {
            variantName: "Chipper TB 100",
            imgLink: TB100Main,
            downloadLink: "NemoDownloadLink",
            highlight: "A Compact Machine For Chipping Branches Up To 10 CM.",
            descriptionMain:
              "The new CHIPPER PERUZZO mod. TB100 is a drum chipper. It is a compact machine for chipping branches up to 10 cm in diameter and organic dry or wet products. This machine is mainly aimed at business users and it’s the one with the most 'high productivity in its class, with two large rotor blades reversible steel long-term before their sharpening. Thanks to the design of the rotor, branches, twigs and cuttings are dragged automatically inside without the aid of driving rollers.",
            photos: [TB1001, TB1002, TB1003, TB1004],
            specifications: []
          },
          {
            variantName: "Chipper TB 100 C Professional",
            imgLink: TB100CProMain,
            downloadLink: "NemoDownloadLink",
            highlight: "A Compact Machine For Chipping Branches Up To 11CM",
            descriptionMain:
              "The new chipper PERUZZO mod. TB100-C PRO is a drum chipper with hydraulic feeding roller, a compact machine for chipping branches up to 11cm / 4,33'' in lenght diameter, performing on both, dry and wet organic products. It is intended for professional users and has a wide rotor with 2 long-lasting reversible steel blades. Thanks to the hydraulic feeding rollers designed with high teeth, the material (branches, twigs and cuttings) can be grabbed easily.",
            photos: [TB100CPro1, TB100CPro2, TB100CPro3, TB100CPro4],
            specifications: []
          },
          {
            variantName: "Chipper TB 120 C Professional",
            imgLink: TB120CProMain,
            downloadLink: "NemoDownloadLink",
            highlight: "A Compact Machine For Chipping Branches Up To 12CM.",
            descriptionMain:
              "The PERUZZO shredder/chipper mod. TB120-C PRO is used to shred branches of all kinds, including fibrous ones, for chipping branches from 8 to 12cm Ø, with an hourly output from 3 to 10 m³/hour. This chipper is used to reduce pruning with many branches and foliage where the hydraulic roller makes it easy to drag it to the cutting drum. Supplied with No-Stress system to facilitate the shredding of larger logs without weighing down the engine with net fuel savings.",
            photos: [TB120CPro1, TB120CPro2, TB120CPro3, TB120CPro4],
            specifications: []
          },
          {
            variantName: "Chipper TB 100 C",
            imgLink: TB100CMain,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Drum Chipper With Track System, Compact Machine For Chipping Branches Up To 10 Cm In Diameter.",
            descriptionMain:
              "The new chipper PERUZZO mod. TB100-C is equipped with a caterpillar tractor base. With this new accessory customers and contractors will be able to move on any terrain and load/ unload the wood chipper from their vans in complete autonomy. The new chipper PERUZZO mod. TB100-C is aimed at business users and it is the machine with the most 'high productivity in its class, with two large rotor blades reversible steel long-term before their sharpening. Thanks to the design of the rotor, branches, twigs and cuttings are dragged automatically inside without the aid of driving rollers.",
            photos: [TB100C1, TB100C2, TB100C3, TB100C4],
            specifications: []
          },
          {
            variantName: "Chipper TB 100 T",
            imgLink: TB100TMain,
            downloadLink: "NemoDownloadLink",
            highlight:
              "A Drum Chipper With Hydraulic Feeding Roller, A Compact Machine For Chipping Branches Up To 10cm.",
            descriptionMain:
              "The bio-shredder/chipper PERUZZO mod. TB 100-T PRO is a machine with hydraulic drive roller, which can be combined with tractors with a minimum power of 30 hp via PTO connection. It is a compact machine for chipping branches up to 10cm in diameter, performing on both dry and wet organic products. Specifically intended for professional users, it has a large rotor equipped with two reversible blades made of high-strength steel.Thanks to the design of the hydraulic drag roller with teeth that adhere strongly to the processed material, branches, twigs and cuttings are dragged inside the cutting assembly with ease.The centrifugal force created by the rotor expels the finely shredded material.",
            photos: [TB100T1, TB100T2, TB100T3, TB100T4],
            specifications: []
          }
        ]
      },
      {
        name: "TIREX",
        description:
          "This chipper removes all jamming during the working phase thanks to an innovative feeding system branches, using hydraulic tooth chain. Prunings are cut in very fine and uniform chips, using accessories on request.",
        imgLink: TIREXMain,
        variants: [
          {
            variantName: "Chipper TIREX",
            imgLink: TIREX1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Chipper For 17cm Diameter Branches For Tractor Operation.",
            descriptionMain:
              "The chipper mod. TIREX is a sturdy machine with 30mm thick cutting disk and 620mm diameter, well combined with a very compact design. This chipper removes all jamming during the working phase thanks to an innovative feeding system branches, using hydraulic tooth chain. Prunings are cut in very fine and uniform chips, using accessories on request. The chips produced by the chipper TIREX can be used not only for mulching and composting, but also for biomass heating systems.",
            photos: [TIREX1, TIREX2, TIREX3, TIREX4],
            specifications: []
          }
        ]
      }
    ]
  },
  {
    name: "Spading Machines",
    type: [
      {
        name: "150 Series",
        description: "Heavy Spading Machines For Medium Depth.",
        imgLink: Series150150Main,
        variants: [
          {
            variantName: "Series 150.95",
            imgLink: Series150951,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Reinforced Frame And Mechanics. Ideal Under The Most Severe Conditions.",
            descriptionMain:
              "3-Speed Lever Gearbox. Lubrication Connecting Rods With Patented Steel Seal And Valve For Filling Control. External Supports. Support Wheels.",
            photos: [Series150955, Series150952, Series150953, Series150954],
            specifications: []
          },
          {
            variantName: "Series 150.150",
            imgLink: Series1501501,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Exclusive Three-Point Hitch With Variable Distance Allows You To Position The Spading Machine Closer To The Tractor: Easier Manoeuvres - Less Effort For Lifting, More Safety And Especially In The Most Critical Conditions.",
            descriptionMain:
              "The Selvatici 150.150 Wood Spader is a powerful and versatile machine designed for efficient soil cultivation across various terrains. Featuring a heavy-duty three-point hitch with variable distance compatibility (Cat II) and a protected PTO shaft with a clutch, it ensures reliable and safe operation. The depth adjustment slides allow for precise soil penetration up to 18 cm, while the 3-speed lever gear shift (M9.5 Helicoidal) provides flexibility with different speed settings, depending on the power take-off (PdF 540 or 1000). Its grease-lubricated roller bearings minimize wear, and the adjustable spur hood and leveler contribute to superior soil leveling and preparation. The machine also includes lubrication of connecting rods with steel seals for enhanced durability and reduced maintenance. With a double top hood, leveler extension, and lateral spillways, the spader is built for professional agricultural use. It comes equipped with specialized spades, including long spades for sandy soils, round spades for rocky terrains, and wide spades for paddy or kiwi fields. Additional accessories such as a removable leveler, hydraulic spur hood adjustment, and a rear three-point attachment (+150 kg / 331 lbs, Cat II) further enhance its adaptability, making the Selvatici 150.150 a reliable choice for demanding soil conditions.",
            photos: [
              Series1501505,
              Series1501502,
              Series1501503,
              Series1501504
            ],
            specifications: []
          }
        ]
      }
    ]
  },
  {
    name: "Aerial Working Platform",
    type: [
      {
        name: "Octoplus Series",
        description:
          "The Octopus line is characterized by its extreme compactness, which allows all the models in this range to pass through extremely narrow spaces. All models are equipped with double pantograph articulation, which allows incredible performance and movements for platforms in this category and, above all, perfectly vertical ascent/descent. Thanks to the new radio control systems, the operator can control the movement of the platform and avoid having to remain in the operative area of the platform; this means the operator enjoys greater operative safety when using an Octopus.",
        imgLink: Octoplus21Main,
        variants: [
          {
            variantName: "Octoplus 17",
            imgLink: Octoplus171,
            downloadLink: "NemoDownloadLink",
            highlight:
              "A Compact And Highly Maneuverable Tracked Aerial Platform Designed For Efficiency In Various Industries",
            descriptionMain:
              "The Manitex Octoplus 17 is a compact and highly maneuverable tracked aerial platform designed for efficiency in various industries, including construction, maintenance, and tree care. With a maximum working height of 17 meters, it provides excellent reach while maintaining stability on different terrains. Its lightweight and narrow design make it ideal for accessing confined spaces, while the tracked undercarriage ensures reliable movement on uneven ground. The Octoplus 17 is equipped with both diesel and electric power options, allowing operators to choose the best mode for their environment. Featuring automatic stabilization, overload sensors, and an emergency descent system, this aerial platform prioritizes safety while delivering outstanding performance.",
            photos: [Octoplus175, Octoplus172, Octoplus173, Octoplus174],
            specifications: []
          },
          {
            variantName: "Octoplus 21",
            imgLink: Octoplus211,
            downloadLink: "NemoDownloadLink",
            highlight:
              "A Versatile And Powerful Tracked Aerial Platform Engineered To Tackle Demanding Jobs With Ease.",
            descriptionMain:
              "The Manitex Octoplus 21 is a versatile and powerful tracked aerial platform engineered to tackle demanding jobs with ease. Offering a maximum working height of 21 meters, it enables operators to reach elevated areas safely and efficiently. Its compact design allows for easy transportation and operation in tight spaces, while the tracked base provides superior stability on rough or soft terrain. With dual power options, the Octoplus 21 can run on diesel for outdoor tasks or switch to electric for indoor applications where noise reduction is essential. Built with advanced safety features, including automatic stabilization and emergency descent functionality, this platform ensures both productivity and operator security in any work setting.",
            photos: [Octoplus212, Octoplus213, Octoplus214, Octoplus215],
            specifications: []
          }
        ]
      },
      {
        name: "Single Pantograph",
        description:
          "The Snake line includes articulated platforms with simple or double pantograph. With this design it is possible to move straight up and then extend over any obstacles at height. All models are fitted with a rotation system on the slew ring and are characterized by highly compact dimensions and performances.",
        imgLink: Snake2112Main,
        variants: [
          {
            variantName: "Snake 147",
            imgLink: Snake1471,
            downloadLink: "NemoDownloadLink",
            highlight:
              "A Compact And Highly Maneuverable Tracked Aerial Platform Designed For Efficiency In Various Industries",
            descriptionMain:
              "The Snake 147 is a compact and agile aerial platform designed for professionals who require efficient access to elevated work areas. With a maximum working height of 14.7 meters, it offers excellent versatility for tasks such as maintenance, installation, and construction. Its lightweight structure and compact dimensions make it easy to maneuver in tight spaces, while its articulated boom ensures precise positioning. Built for stability and safety, the Snake 147 features advanced hydraulic controls, reliable stabilization, and a user-friendly interface, making it an ideal solution for both indoor and outdoor applications.",
            photos: [Snake1472, Snake1473, Snake1474],
            specifications: []
          },
          {
            variantName: "Snake 189",
            imgLink: Snake1891,
            downloadLink: "NemoDownloadLink",
            highlight:
              "A Versatile And Powerful Tracked Aerial Platform Engineered To Tackle Demanding Jobs With Ease.",
            descriptionMain:
              "The Snake 189 is a high-performance articulated aerial platform designed to deliver extended reach and flexibility in various working environments. With a maximum working height of 18.9 meters, it provides exceptional access to elevated areas while maintaining stability and ease of operation. Its compact footprint allows it to navigate confined spaces effortlessly, while its sturdy construction ensures reliability on different terrains. Equipped with advanced safety features, smooth hydraulic controls, and a durable boom system, the Snake 189 is the perfect choice for professionals in maintenance, construction, and facility management.",
            specifications: []
          },
          {
            variantName: "Snake 2112",
            imgLink: Snake21121,
            downloadLink: "NemoDownloadLink",
            highlight:
              "A Powerful And Highly Versatile Aerial Platform Built For Demanding Work At Heights.",
            descriptionMain:
              "The Snake 2112 is a powerful and highly versatile aerial platform built for demanding work at heights. Reaching a maximum working height of 21.12 meters, it combines excellent reach with superior stability, making it ideal for tasks requiring precision and efficiency. Its articulated boom allows for flexible positioning, while the compact design ensures easy maneuverability in restricted areas. With both indoor and outdoor capabilities, the Snake 2112 is equipped with advanced safety systems, smooth operational controls, and a robust structure to enhance productivity while prioritizing operator safety.",
            photos: [Snake21122, Snake21123, Snake21124, Snake21125],
            specifications: []
          }
        ]
      },
      {
        name: "Double Pantograph",
        description:
          "The Snake line includes articulated platforms with simple or double pantograph. With this design it is possible to move straight up and then extend over any obstacles at height. All models are fitted with a rotation system on the slew ring and are characterized by highly compact dimensions and performances.",
        imgLink: Snake2413PMain,
        variants: [
          {
            variantName: "Snake 16",
            imgLink: Snake161,
            downloadLink: "NemoDownloadLink",
            highlight:
              "A Compact And Reliable Articulated Aerial Platform Designed For A Wide Range Of Elevated Work Applications.",
            descriptionMain:
              "The Snake 16 is a compact and reliable articulated aerial platform designed for a wide range of elevated work applications. With a maximum working height of 16 meters, it offers excellent maneuverability and ease of use in both indoor and outdoor environments. Its lightweight structure and articulated boom allow for precise positioning, making it ideal for tasks such as maintenance, installation, and facility management. Built with safety and efficiency in mind, the Snake 16 features smooth hydraulic controls, a stable base, and a user-friendly interface for maximum productivity.",
            photos: [Snake1611, Snake1612, Snake1613, Snake1614],
            specifications: []
          },
          {
            variantName: "Snake 20 FB",
            imgLink: Snake201,
            downloadLink: "NemoDownloadLink",
            highlight:
              "a versatile aerial platform that provides exceptional reach and flexibility for professionals working at heights.",
            descriptionMain:
              "The Snake 20 FB is a versatile aerial platform that provides exceptional reach and flexibility for professionals working at heights. With a maximum working height of 20 meters, it is engineered for precision and efficiency in demanding environments such as construction, restoration, and maintenance. Its articulated design allows for smooth and accurate positioning, while its compact footprint ensures easy navigation in confined spaces. Designed for durability and stability, the Snake 20 FB is equipped with advanced safety features and a reliable control system to enhance operator confidence and work performance.",
            photos: [Snake201, Snake202, Snake203, Snake204],
            specifications: []
          },
          {
            variantName: "Snake 24 FB",
            imgLink: Snake241,
            downloadLink: "NemoDownloadLink",
            highlight:
              "a high-performance aerial platform that delivers extended reach and excellent stability for elevated work operations.",
            descriptionMain:
              "The Snake 24 FB is a high-performance aerial platform that delivers extended reach and excellent stability for elevated work operations. With a maximum working height of 24 meters, it provides outstanding access to hard-to-reach areas while maintaining ease of operation. Its articulated boom system enables precise movements, making it ideal for industrial maintenance, construction projects, and facility upkeep. Built for durability and safety, the Snake 24 FB features advanced hydraulic controls, a stable chassis, and an intuitive control panel to ensure maximum efficiency and operator security.",
            photos: [Snake245, Snake242, Snake243, Snake244],
            specifications: []
          },
          {
            variantName: "Snake 2010 H Plus",
            imgLink: Snake2010H1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "a powerful and adaptable aerial platform designed to handle challenging work-at-height tasks with ease.",
            descriptionMain:
              "The Snake 2010 H Plus is a powerful and adaptable aerial platform designed to handle challenging work-at-height tasks with ease. Offering a maximum working height of 20 meters, it combines superior reach with exceptional stability, making it ideal for professionals in maintenance, signage installation, and industrial applications. Its articulated design allows for flexible positioning, while its compact build ensures effortless maneuverability in restricted areas. Featuring an advanced hydraulic system, automatic stabilization, and robust safety mechanisms, the Snake 2010 H Plus delivers reliable performance in both indoor and outdoor environments.",
            photos: [Snake2010H2, Snake2010H3, Snake2010H4, Snake2010H5],
            specifications: []
          },
          {
            variantName: "Snake 2111J Plus",
            imgLink: Snake2111J1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "a state-of-the-art articulated aerial platform that offers unparalleled precision and efficiency in elevated work operations.",
            descriptionMain:
              "The Snake 2111 J Plus is a state-of-the-art articulated aerial platform that offers unparalleled precision and efficiency in elevated work operations. With a maximum working height of 21 meters, it provides excellent reach and maneuverability, making it ideal for various industries, including construction, maintenance, and event setups. Its articulated boom and jib allow for greater flexibility in positioning, ensuring precise access to difficult areas. Built with cutting-edge safety features, a stable chassis, and intuitive controls, the Snake 2111 J Plus ensures a seamless and secure work experience for operators.",
            photos: [
              Snake2111J1,
              Snake2111J2,
              Snake2111J3,
              Snake2111J4,
              Snake2111J5
            ],
            specifications: []
          },
          {
            variantName: "Snake 2413 Plus",
            imgLink: Snake2413P1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "a premium aerial platform designed for superior performance and stability in high-reach tasks.",
            descriptionMain:
              "The Snake 2413 Plus is a premium aerial platform designed for superior performance and stability in high-reach tasks. With an impressive maximum working height of 24 meters, it excels in applications that demand precision, durability, and efficiency. Its advanced articulated boom system, combined with a telescopic jib, offers enhanced flexibility and smooth movement. Whether for construction, facility maintenance, or industrial operations, the Snake 2413 Plus is engineered for reliability with its robust safety features, user-friendly controls, and a reinforced structure that ensures consistent productivity in any environment.",
            photos: [Snake2413P2, Snake2413P3, Snake2413P4, Snake2413P5],
            specifications: []
          }
        ]
      }
    ]
  },
  {
    name: "Truck Mounted Cranes",
    type: [
      {
        name: "100 Series",
        description:
          "From 3 to 23 tm class 3T technology represents tomorrow’s technology today and is a new design philosophy adopted by the 100 series cranes aimed at more capacity, less weight and competitive price. Strong Light Competitive",
        imgLink: v123Cropped,
        variants: [
          {
            variantName: "103",
            imgLink: v103Cropped,
            downloadLink: "NemoDownloadLink",
            highlight: "Small in size, big on capability.",
            descriptionMain:
              "With a lifting moment class of 3 tm and up to 850 kg max capacity, the 103 is perfect for light-duty operations that demand precision and efficiency without compromising strength.",
            specifications: []
          },
          {
            variantName: "105",
            imgLink: v105Cropped,
            downloadLink: "NemoDownloadLink",
            highlight: "Versatility redefined.",
            descriptionMain:
              "Designed to handle more with a 4 tm class, the 105 boasts 1350 kg max lifting capacity and a reach of 7.01 meters—perfect for a wide range of urban and mobile applications.",
            specifications: []
          },
          {
            variantName: "108",
            imgLink: v108,
            downloadLink: "NemoDownloadLink",
            highlight: "Power and reach in balance",
            descriptionMain:
              "Delivering up to 2230 kg in lifting capacity and a strong 8 tm moment class, the 108 model is ideal for users needing a flexible yet powerful crane for demanding jobs.",
            specifications: []
          },
          {
            variantName: "111",
            imgLink: v111Cropped,
            downloadLink: "NemoDownloadLink",
            highlight: "The pro’s choice for control and strength",
            descriptionMain:
              "The 111 combines precision control with high performance, offering a 10 tm class and 2460 kg lift capacity—engineered for contractors who need consistency and capacity.",
            specifications: []
          },
          {
            variantName: "115",
            imgLink: v115_2,
            downloadLink: "NemoDownloadLink",
            highlight: "Big jobs, no compromise.",
            descriptionMain:
              "With a 14 tm moment class and 5950 kg of maximum lifting power, the 115 is designed for serious work while keeping overall crane weight in check.",
            specifications: []
          },
          {
            variantName: "120",
            imgLink: v120Cropped,
            downloadLink: "NemoDownloadLink",
            highlight: "Strength meets sophistication.",
            descriptionMain:
              "The 120 pushes boundaries with an 8140 kg lift capacity and a powerful 19 tm class. Perfect for fleets seeking efficiency and advanced performance.",
            specifications: []
          },
          {
            variantName: "123",
            imgLink: v123Cropped,
            downloadLink: "NemoDownloadLink",
            highlight: "Dominating lifts with precision.",
            descriptionMain:
              "The most capable in the series, the 123 delivers a massive 8680 kg lift capacity in the 21 tm class, making it the go-to crane for the heaviest, most demanding lifts in the 100 Series.",
            specifications: []
          }
        ]
      }
    ]
  },
  {
    name: "Hydraulics Generator",
    type: [
      {
        name: "Electricity Generation",
        description:
          "Our Electricity Generation line within the Hydraulics Generator category delivers reliable, high-efficiency solutions tailored for diverse applications. From the compact HG Hydraulic Generator to the field-proven HGG Hydraulic Ground Power Generator, each model is engineered for consistent performance under demanding conditions. The HGV POWER BOX and HGV Variable Hydraulic Generator System offer versatile, adjustable outputs for mobile and on-site energy needs, while the HWG Hydraulic Welding Generator combines electric generation with robust welding capabilities, making it ideal for industrial and repair tasks. Designed with power, durability, and adaptability in mind, this range ensures optimal hydraulic-to-electric conversion across all environments.",
        imgLink: HWGMain,
        variants: [
          {
            variantName: "HG Hydraulic Generator",
            imgLink: HGMain,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Produces electricity for all AC-powered tools, lights, heaters, coolers etc. in mobile use.",
            descriptionMain:
              "DYNASET HG Hydraulic Generator converts the hydraulic power of a mobile machine, vehicle or vessel into high-quality electricity for all AC-powered electric appliances.",
            photos: [HGPhoto1, HGPhoto2, HGPhoto3, HGPhoto4],
            specifications: []
          },
          {
            variantName: "HGG Hydraulic Ground Power Generator",
            imgLink: HGGMain,
            downloadLink: "NemoDownloadLink",
            highlight:
              "The hydraulic ground power generator is complete power station with overload protection.",
            descriptionMain:
              "DYNASET HGG Hydraulic Ground Power Generator converts the hydraulic power of a mobile machine, vehicle or vessel into low voltage DC electricity to operate e.g. in airports to provide ground power for airplanes or other applications.",
            photos: [HGGPhoto1],
            specifications: []
          },
          {
            variantName: "HGV POWER BOX Variable Hydraulic Generator System",
            imgLink: HGVMain,
            downloadLink: "NemoDownloadLink",
            highlight:
              "It is an all-in-one box type of modular system containing all the needed components to produce high quality electricity in mobile use, even while driving. The system has great benefits.",
            descriptionMain:
              "DYNASET HGV POWER BOX Variable Hydraulic Generator System converts a mobile machine’s, vehicle’s or vessel’s engine power through a PTO into high quality electricity.",
            photos: [HGVPhoto1, HGVPhoto2],
            specifications: []
          },
          {
            variantName: "HGV Variable Hydraulic Generator System",
            imgLink: HGVVarMain,
            downloadLink: "NemoDownloadLink",
            highlight:
              "The variable hydraulic generator system is designed to produce electricity in mobile use, even while driving. The system has great benefits.",
            descriptionMain:
              "DYNASET HGV Variable Hydraulic Generator System converts a mobile machine’s, vehicle’s or vessel’s engine power through a PTO into high quality electricity.",
            photos: [HGVVarPhoto1, HGVVarPhoto2, HGVVarPhoto3],
            specifications: []
          },
          {
            variantName: "HWG Hydraulic Welding Generator",
            imgLink: HWGMain,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Hydraulic welding generator can be located in confined space since it is powered by hydraulics and doesn’t require a diesel generator as power source.",
            descriptionMain:
              "DYNASET HWG Hydraulic Welding Generator converts the hydraulic power of a mobile machine, vehicle or vessel into welding current and auxiliary electricity.",
            photos: [HWGPhoto1, HWGPhoto2, HWGPhoto3, HWGPhoto4],
            specifications: []
          }
        ]
      },
      {
        name: "High Pressure Water",
        description:
          "Our High Pressure Water product lineup is built to tackle the toughest cleaning, cutting, and firefighting tasks with precision and power. This versatile range includes solutions like the FP Firefighting Piercing Kit and HPW-FIRE High Pressure Firefighting System, engineered for emergency response and safety-critical operations. For industrial and utility needs, we offer the HAC Hydraulic Abrasive Cutting System, HDF Drilling Fluid Pump, and HSP Submersible Pump, designed for rugged performance in harsh environments. Specialized units such as the HPW-DUST Dust Suppression System, JPL Bin Washing System, and KPL High Pressure Street Washing Unit ensure cleanliness and compliance in public and industrial spaces. From pipe and surface cleaning (PPL, SCU) to environmental management tools like the KPL-WEED Weedkiller Unit, every system is optimized for efficiency, durability, and hydraulic integration.",
        imgLink: HPWPPhoto3,
        variants: [
          // FP Firefighting Piercing Kit
          {
            variantName: "FP Firefighting Piercing Kit",
            imgLink: FPPhoto1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "It enables a firefighting team to pierce through windows, walls, and roofs to extinguish a fire with high-pressure water mist before firefighters enter the room.",
            descriptionMain:
              "DYNASET FP Firefighting Piercing Kit uses a mobile machine’s hydraulic system as a power source to produce piercing power and high-pressure water for fire extinguishing.",
            photos: [FPPhoto1, FPPhoto2, FPPhoto3, FPPhoto4, FPPhoto5],
            specifications: []
          },
          // HAC Hydraulic Abrasive Cutting System
          {
            variantName: "HAC Hydraulic Abrasive Cutting System",
            imgLink: HACPhoto1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "HAC Hydraulic Abrasive Cutting System allows you to cut material without sparkles.",
            descriptionMain:
              "DYNASET HAC Hydraulic Abrasive Cutting System is a hydraulic-powered cold-cutting system. The system is used for cold-cutting applications in various fields of industries, for example, in the rescue sector, the HAC Hydraulic Abrasive Cutting System is used for extinguishing fire safely through walls, doors, and roofs. As a rescue accessory, we also supply an accessory that allows users to spread firefighting foam with the system’s pistol. It can be used for cutting, e.g., metal or concrete, as well as wood.",
            photos: [HACPhoto1, HACPhoto2, HACPhoto3, HACPhoto4, HACPhoto5],
            specifications: []
          },
          // HDF Drilling Fluid Pump
          {
            variantName: "HDF Drilling Fluid Pump",
            imgLink: HDFPhoto1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "The hydraulic drilling fluid pump has higher tolerance for particles than standard pumps.",
            descriptionMain:
              "DYNASET HDF Hydraulic Drilling Fluid Pumps convert the hydraulic power of a mobile machine or vehicle into pumping power for fluids.",
            photos: [HDFPhoto1, HDFPhoto2, HDFPhoto3],
            specifications: []
          },
          // HPW Hydraulic High Pressure Water Pump
          {
            variantName: "HPW Hydraulic High Pressure Water Pump",
            imgLink: HPWPPhoto1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Produces high-pressure water for any application in mobile use.",
            descriptionMain:
              "DYNASET HPW Hydraulic High Pressure Water Pump converts the hydraulic power of a mobile machine, vehicle or vessel into high-pressure water for various applications.",
            photos: [
              HPWPPhoto1,
              HPWPPhoto2,
              HPWPPhoto3,
              HPWPPhoto4,
              HPWPPhoto5
            ],
            specifications: []
          },
          // HPW Hydraulic Power Washer
          {
            variantName: "HPW Hydraulic Power Washer",
            imgLink: HPWPhoto1,
            downloadLink: "NemoDownloadLink",
            highlight:
              "Produces high-pressure water for pressure washing in mobile use.",
            descriptionMain:
              "DYNASET HPW Hydraulic Power Washer converts the hydraulic power of a mobile machine, vehicle or vessel into high-pressure water for pressure washing.",
            photos: [HPWPhoto1, HPWPhoto2, HPWPhoto3, HPWPhoto4, HPWPhoto5],
            specifications: []
          },
          // HPW Dust High Pressure
          {
            variantName: "HPW-DUST High Pressure Dust Suppression System",
            imgLink: HPWDustPhoto3,
            downloadLink: "NemoDownloadLink",
            highlight:
              "The system produces high-pressure water mist for effective dust control.",
            descriptionMain:
              "HPW-DUST High Pressure Dust Suppression System is the most innovative dust control system for mobile machinery in demolition, street cleaning, quarrying, crushing, recycling etc. The system produces atomized water mist to suppress the dust and prevents the emissions from spreading to the environment.",
            photos: [
              HPWDustPhoto1,
              HPWDustPhoto2,
              HPWDustPhoto3,
              HPWDustPhoto4,
              HPWDustPhoto5
            ],
            specifications: []
          },
          //HPW Fire High Pressure Firefighting System
          {
            variantName: "HPW Fire High Pressure Firefighting System",
            imgLink: HPWFPhoto3,
            downloadLink: "NemoDownloadLink",
            highlight:
              "HPW-FIRE is a hydraulic powered and high-pressure version of firefighting.",
            descriptionMain:
              "The DYNASET HPW-FIRE High Pressure Firefighting System has a large variety of products that use the mobile machine’s hydraulic system as a power source.  Our products cover special nozzles, pumps, pressure intensifiers, piercing tools, and a flow multiplier.",
            photos: [
              HPWFPhoto1,
              HPWFPhoto2,
              HPWFPhoto3,
              HPWFPhoto4,
              HPWFPhoto5
            ],
            specifications: []
          },
          {
            variantName: "HSP Hydraulic Submersible Pump",
            imgLink: HSPPhoto3,
            downloadLink: "NemoDownloadLink",
            highlight:
              "DYNASET HSP Hydraulic Submersible Pump converts the hydraulic power of a mobile machine, vehicle or vessel into high volume water pumping power.",
            descriptionMain:
              "Compact size and durable design enable the submersible pump to tolerate mud and water containing solid substances such as rocks.",
            photos: [HSPPhoto1, HSPPhoto2, HSPPhoto3, HSPPhoto4, HSPPhoto5],
            specifications: []
          },
          {
            variantName: "JPL High Pressure Bin Washing System",
            imgLink: JPLPhoto3,
            downloadLink: "NemoDownloadLink",
            highlight:
              "The garbage collection and the bin washing services can efficiently be done with one vehicle.",
            descriptionMain:
              "DYNASET JPL Hydraulic High Pressure Water Pump converts the hydraulic power of a vehicle or into high-pressure water for bin washing.",
            photos: [JPLPhoto1, JPLPhoto2, JPLPhoto3, JPLPhoto4, JPLPhoto5],
            specifications: []
          },
          {
            variantName: "KPL-WEED Weedkiller Unit",
            imgLink: KPLWeedPhoto3,
            downloadLink: "NemoDownloadLink",
            highlight:
              "KPL-WEED Weedkiller Unit is a unit that is used with a work machine like a compact loader, and it produces hot water to control weeds without chemicals.",
            descriptionMain:
              "DYNASET KPL-WEED Weedkiller Unit is using hot water for weed control without any chemicals. The unit can handle large areas efficiently with a weed control pipe. You can easily remove weeds from streets, parking lots, side walks, pathways, pavements, curbs etc. The weedkiller is equipped with a water heating unit which heats the water up to 102°C. The heated water droplets can be spread through either from a weed control pipe or roller onto weed surface. The hot 98°C water affects all the way to the plant roots for complete elimination.",
            photos: [
              KPLWeedPhoto1,
              KPLWeedPhoto2,
              KPLWeedPhoto3,
              KPLWeedPhoto4,
              KPLWeedPhoto5
            ],
            specifications: []
          },
          {
            variantName: "KPL High Pressure Street Washing Unit",
            imgLink: KPLStreetPhoto3,
            downloadLink: "NemoDownloadLink",
            highlight:
              "One small vehicle with the KPL High pressure Street Washing unit can wash large areas without constantly refilling the water reservoir due to low water consumption.",
            descriptionMain:
              "DYNASET KPL Street Washing Unit converts the hydraulic power of a mobile machine or vehicle into high pressure water for street cleaning.",
            photos: [
              KPLStreetPhoto1,
              KPLStreetPhoto2,
              KPLStreetPhoto3,
              KPLStreetPhoto4,
              KPLStreetPhoto5
            ],
            specifications: []
          },
          {
            variantName: "PPL High Pressure Pipe Cleaning Unit",
            imgLink: PPLPhoto3,
            downloadLink: "NemoDownloadLink",
            highlight:
              "The pipe cleaning unit provides effective washing length up to 100 meters horizontally and 20 meters vertically.",
            descriptionMain:
              "DYNASET PPL Hydraulic Pipe Cleaning Unit converts the hydraulic power of a mobile machine or vehicle into high-pressure water for pipe cleaning. The high-quality equipment provides plenty of benefits.",
            photos: [PPLPhoto1, PPLPhoto2, PPLPhoto3, PPLPhoto4, PPLPhoto5],
            specifications: []
          },
          {
            variantName: "SCU Surface Cleaning Unit",
            imgLink: SCUPhoto3,
            downloadLink: "NemoDownloadLink",
            highlight: "Efficient cleaning up to 60 000 m2/Day",
            descriptionMain:
              "SCU Surface Cleaning unit effectively cleans parking garages and other large areas with flat surfaces. The unit washes the surface with high-pressure water and the vacuum collects the dirty water for recycling. The unit leaves a clean and dry surface behind without making any mess to the surroundings.",
            photos: [SCUPhoto1, SCUPhoto2, SCUPhoto3, SCUPhoto4, SCUPhoto5],
            specifications: []
          }
        ]
      }
    ]
  },
  {
    name: "Zoo Technology",
    type: [
      {
        name: "Processing & Crushing Units",
        description:
          "Our Processing & Crushing Units are designed to efficiently handle raw material breakdown for feed production, composting, or biomass systems. These machines ensure consistent particle size, increase nutrient absorption, and reduce waste. From light-duty shredding to heavy-duty crushing, this lineup combines strength, efficiency, and durability for all types of agricultural and industrial applications.",
        imgLink: CrushMain,
        variants: [
          {
            variantName: "Peruzzo Crush",
            imgLink: CrushMain,
            downloadLink: CrushPDF,
            highlight:
              "Powerful Solutions for Feed Preparation and Material Breakdown",
            descriptionMain:
              "The PERUZZO CRUSH is a high-performance crushing unit designed with advanced Italian engineering for efficient material reduction. Perfect for processing grains, dry forage, and fibrous feed materials, it ensures uniform particle size for optimal digestion and feed conversion. Built with a robust steel structure and high-speed rotary system, the Peruzzo Crush delivers powerful, consistent results with low maintenance and long service life—ideal for farms and industrial feed operations that demand reliability and precision.",
            photos: [Crush1, Crush2, Crush3, Crush4],
            specifications: []
          },
          {
            variantName: "Peruzzo A-17 R-17",
            imgLink: A17R17Main,
            downloadLink: A17R17Catalog,
            highlight: "Italian Engineering for Versatile Testing Performance",
            descriptionMain:
              "The PERUZZO A-17 is a streamlined testing unit engineered for precision and ease in compact environments. Designed with Italian innovation, the A-17 offers rapid, reliable results for essential testing needs across various sectors. Its minimal footprint makes it ideal for small laboratories or mobile setups, while its robust construction ensures durability and long-term performance. Perfect for applications requiring speed and simplicity without compromising accuracy.",
            photos: [A17R171, A17R172, A17R173, A17R174, A17R17Catalog],
            specifications: []
          },
          {
            variantName: "Peruzzo C-17",
            imgLink: C17Main,
            downloadLink: C17Catalog,
            highlight: "Italian Engineering for Advanced Testing Control",
            descriptionMain:
              "The PERUZZO C-17 is a high-precision testing unit designed for complex and demanding testing environments. Equipped with advanced Italian technology, it offers superior control, accuracy, and performance. Whether used for research, development, or intensive quality control, the C-17 ensures consistent output and user-friendly operation. Its robust structure and intuitive interface make it an essential tool for high-stakes testing where precision is non-negotiable.",
            photos: [C171, C172, C173, C174],
            specifications: []
          }
        ]
      },
      {
        name: "Animal Feed Mixers",
        description:
          "Engineered for efficiency and versatility, our Animal Feed Mixers range from compact to high-capacity units, designed to process, mix, and distribute livestock feed quickly and uniformly. The UNIVERSAL and EXPORT models are ideal for farms of all sizes, providing robust performance, precise mixing capabilities, and reliable long-term operation to optimize feeding routines.",
        imgLink: Zoo1000UniversalMain,
        variants: [
          {
            variantName: "200 Export",
            imgLink: ZooPhoto1,
            downloadLink: Zoo200Catalog,
            highlight: "Compact Efficiency for Small Farms",
            descriptionMain:
              "The 200 EXPORT is a lightweight and agile feed mixer ideal for small-scale operations. Its simple design makes it easy to operate and maintain, while still delivering a consistent mix for balanced nutrition. Perfect for farms that need reliable performance without a large footprint.",
            photos: [ZooPhoto5, ZooPhoto2, ZooPhoto3, ZooPhoto4],
            specifications: []
          },
          {
            variantName: "200 Universal",
            imgLink: Zoo200UniversalMain,
            downloadLink: Zoo200UniversalCatalog,
            highlight: "Flexible Performance, Everyday Reliability",
            descriptionMain:
              "The 200 UNIVERSAL offers dependable feed mixing with versatile configuration options. Designed for farms with moderate output needs, this model balances size, efficiency, and performance, making it a great entry point into the UNIVERSAL series.",
            photos: [Zoo200UniversalPhoto1, Zoo200UniversalPhoto2],
            specifications: []
          },
          {
            variantName: "300 Universal",
            imgLink: Zoo300UniversalMain,
            downloadLink: Zoo300UniversalCatalog,
            highlight: "Enhanced Capacity, Greater Control",
            descriptionMain:
              "With increased mixing volume and improved operational features, the 300 UNIVERSAL is perfect for farms looking to scale. It maintains uniform blend quality while offering robust construction and user-friendly controls.",
            photos: [
              Zoo300UniversalPhoto1,
              Zoo300UniversalPhoto2,
              Zoo300UniversalPhoto3,
              Zoo300UniversalPhoto4
            ],
            specifications: []
          },
          {
            variantName: "500 Universal",
            imgLink: Zoo500UniversalMain,
            downloadLink: Zoo500UniversalCatalog,
            highlight: "Mid-Size Powerhouse",
            descriptionMain:
              "A reliable workhorse in the mid-range category, the 500 UNIVERSAL delivers high mixing efficiency and capacity for medium-sized farms. It’s built to handle a wide variety of feed ingredients while reducing prep time and labor effort.",
            photos: [
              Zoo500UniversalPhoto1,
              Zoo500UniversalPhoto2,
              Zoo500UniversalPhoto3
            ],
            specifications: []
          },
          {
            variantName: "700 Universal",
            imgLink: Zoo700UniversalMain,
            downloadLink: Zoo700UniversalCatalog,
            highlight: "High-Volume Mixing, Farm-Proven Strength",
            descriptionMain:
              "Designed for larger farming operations, the 700 UNIVERSAL offers exceptional throughput and consistent results. Its reinforced structure and powerful mixing mechanism ensure durability and reliability under daily heavy use.",
            photos: [
              Zoo700UniversalPhoto1,
              Zoo700UniversalPhoto2,
              Zoo700UniversalPhoto3,
              Zoo700UniversalPhoto4
            ],
            specifications: []
          },
          {
            variantName: "1000 Universal",
            imgLink: Zoo1000UniversalMain,
            downloadLink: Zoo1000UniversalCatalog,
            highlight: "Top-Tier Capacity, Industrial Strength",
            descriptionMain:
              "The largest in the series, the 1000 UNIVERSAL is engineered for maximum productivity. Ideal for industrial-scale feed production, it combines high-volume capacity with rugged durability, precise mixing technology, and operator-friendly functionality.",
            photos: [
              Zoo1000UniversalPhoto1,
              Zoo1000UniversalPhoto2,
              Zoo1000UniversalPhoto3,
              Zoo1000UniversalPhoto4
            ],
            specifications: []
          }
        ]
      },
      {
        name: "Biogas and Sustainability Units",
        description:
          "Our Biogas and Sustainability solutions, such as the BIOMASS BIOGAS PLANTS UNIVERSAL 1000, are designed to convert agricultural waste into renewable energy. These systems support environmentally responsible farming practices by producing biogas and reducing waste, all while delivering operational efficiency and supporting energy independence on the farm.",
        imgLink: Biomass1000Main,
        variants: [
          {
            variantName: "Biomass Biogas Plants Universal 1000",
            imgLink: Biomass1000Main,
            downloadLink: Biomass1000Catalog,
            highlight: "Turning Waste Into Renewable Power",
            descriptionMain:
              "The UNIVERSAL 1000 Biogas Plant is a powerful solution for sustainable energy production on farms and agricultural facilities. Designed to process organic waste—such as animal manure, crop residue, and silage—this system efficiently converts biomass into clean, usable biogas for heating, electricity, or fuel. Its high-capacity design supports continuous operation, making it an ideal investment for farms seeking energy independence, reduced carbon footprint, and enhanced waste management. Built with corrosion-resistant materials and smart system controls, the UNIVERSAL 1000 ensures long-lasting performance and minimal maintenance.",
            photos: [
              Biomass1000Photo1,
              Biomass1000Photo2,
              Biomass1000Photo3,
              Biomass1000Photo4
            ],
            specifications: []
          }
        ]
      },
      {
        name: "Specialized Mixing Systems",
        description:
          "Our Specialized Mixing Systems are built for farms that need more than just standard mixing. These machines offer advanced configurations, smart features, and custom capabilities to handle complex feeding tasks, multiple feed types, and tight space constraints. Whether you're working with flour, feed, or alternative materials, these mixers deliver precise performance and flexibility—streamlining workflow and boosting productivity.",
        imgLink: CombySpecialMain,
        variants: [
          {
            variantName: "Comby 85",
            imgLink: Comby85Main,
            downloadLink: Comby85Catalog,
            highlight: "Compact Efficiency for Smaller Farms",
            descriptionMain:
              "The COMBY 85 is a multifunctional unit designed for versatility in compact spaces. It’s ideal for operations requiring a space-saving solution without sacrificing feed quality or output. With easy handling and robust performance, it's a smart investment for smaller facilities.",
            photos: [
              Comby85Photo1,
              Comby85Photo2,
              Comby85Photo3,
              Comby85Photo4
            ],
            specifications: []
          },
          {
            variantName: "Comby MCM",
            imgLink: CombyMCMMain,
            downloadLink: CombyMCMPDF,
            highlight: "Dual Mixing, Maximum Flexibility",
            descriptionMain:
              "The COMBY MCM is equipped with multiple chambers, allowing for the simultaneous mixing of different feed types. This design is perfect for farms that cater to multiple animal groups with unique nutritional needs. Streamline your feeding process while enhancing consistency and control.",
            photos: [CombyMCM1, CombyMCM2, CombyMCM3],
            specifications: []
          },
          {
            variantName: "Comby Special",
            imgLink: CombySpecialMain,
            downloadLink: CombySpecialPDF,
            highlight: "Custom-Built for Complex Operations",
            descriptionMain:
              "The COMBY SPECIAL is engineered for farms that need something out of the ordinary. Whether it's extended compartments, extra discharge points, or specific integration requirements, this mixer is custom-designed to meet your workflow and capacity expectations—right down to the last bolt.",
            photos: [
              CombySpecial1,
              CombySpecial2,
              CombySpecial3,
              CombySpecial4
            ],
            specifications: []
          },
          {
            variantName: "Rised Flour Mixer",
            imgLink: RisedFlourMixerMain,
            downloadLink: RisedFlourMixerPDF,
            highlight: "Effortless Mixing Above Ground",
            descriptionMain:
              "The RISED FLOUR MIXER offers above-ground convenience and consistent flour processing. With a vertical build, it's easy to access and maintain, providing efficient mixing without taking up floor space. Ideal for feed mills and production setups requiring smooth, dust-minimized operation.",
            photos: [RisedFlourMixer1, RisedFlourMixer2],
            specifications: []
          },
          {
            variantName: "Buried Flour Mixer",
            imgLink: BuriedFlourMixerMain,
            downloadLink: BuriedFlourMixerPDF,
            highlight: "Integrated Mixing Below the Surface",
            descriptionMain:
              "Designed to be installed below ground level, BURIED FLOUR MIXERS help streamline operations by reducing surface clutter and allowing for gravity-fed discharge systems. They’re perfect for high-volume processing environments that require seamless mixing and efficient material flow.",
            photos: [BuriedFlourMixer1, BuriedFlourMixer2],
            specifications: []
          }
        ]
      },
      {
        name: "Processing & Crushing Units",
        description:
          "Our Processing & Crushing Units are designed to efficiently handle raw material breakdown for feed production, composting, or biomass systems. These machines ensure consistent particle size, increase nutrient absorption, and reduce waste. From light-duty shredding to heavy-duty crushing, this lineup combines strength, efficiency, and durability for all types of agricultural and industrial applications.",
        imgLink: CrushMain,
        variants: [
          {
            variantName: "Peruzzo Crush",
            imgLink: CrushMain,
            downloadLink: CrushPDF,
            highlight:
              "Powerful Solutions for Feed Preparation and Material Breakdown",
            descriptionMain:
              "The PERUZZO CRUSH is a high-performance crushing unit designed with advanced Italian engineering for efficient material reduction. Perfect for processing grains, dry forage, and fibrous feed materials, it ensures uniform particle size for optimal digestion and feed conversion. Built with a robust steel structure and high-speed rotary system, the Peruzzo Crush delivers powerful, consistent results with low maintenance and long service life—ideal for farms and industrial feed operations that demand reliability and precision.",
            photos: [Crush1, Crush2, Crush3, Crush4],
            specifications: []
          }
        ]
      }
    ]
  }
];

export default category;
